const NAME_ALIASES = {
    english: "en",
    spanish: "es",
    french: "fr",
    german: "de",
    italian: "it",
    portuguese: "pt",
    "portuguese (brazil)": "pt-br",
    dutch: "nl",
    swedish: "sv",
    norwegian: "no",
    danish: "da",
    finnish: "fi",
    polish: "pl",
    czech: "cs",
    slovak: "sk",
    hungarian: "hu",
    romanian: "ro",
    bulgarian: "bg",
    greek: "el",
    turkish: "tr",
    russian: "ru",
    ukrainian: "uk",
    arabic: "ar",
    hebrew: "he",
    hindi: "hi",
    bengali: "bn",
    urdu: "ur",
    chinese: "zh",
    "chinese (simplified)": "zh-cn",
    "chinese (traditional)": "zh-tw",
    japanese: "ja",
    korean: "ko",
    vietnamese: "vi",
    thai: "th",
    indonesian: "id",
    malay: "ms",
    tagalog: "tl",
    persian: "fa",
    serbian: "sr",
    croatian: "hr",
};
const translations = {
    en: {
        "chat.activityProductsFor": "Looking for {goal}…",
        "agentDebug.queue": "Waiting to start",
        "agentDebug.firstReply": "First reply",
        "agentDebug.total": "Response time",
        "agentDebug.usage": "{calls} model calls · {tokens} tokens",
        "agentDebug.actions": "What NOA did",
        "agentDebug.action": "Working on your request",
        "agentDebug.noActions": "Preparing the response; no tools used yet.",
        "agentDebug.fields": "Information saved",
        "agentDebug.products": "Products found: {count}",
        "agentDebug.details": "Inputs and results",
        "agentDebug.tasks": "Saved task progress",
        "agentDebug.sources": "Official sources",
        "agentDebug.context": "Conversation context",
        "agentDebug.history": "Recent messages: {count}",
        "agentDebug.tools": "Available capabilities",
        "agentDebug.raw": "Technical details",
        "agentDebug.readProducts": "Reading previous products",
        "agentDebug.taskDetails": "Reading task requirements",
        "agentDebug.startTask": "Starting or resuming a task",
        "agentDebug.readTask": "Reading saved progress",
        "agentDebug.readCustomer": "Reading known customer information",
        "agentDebug.readHistory": "Reading earlier messages",
        "agentDebug.closeTask": "Completing a task",
        "agentDebug.searchTimeout": "The search took too long. No second search was started.",
        "agentDebug.noCredits": "Search credits are unavailable.",
        "agentDebug.unavailable": "This capability is unavailable.",
        "agentDebug.unsupportedField": "An unsupported customer field was rejected.",
        "agentDebug.invalidProducts": "Search output could not be validated.",
        "agentDebug.toolFailed": "The operation could not be completed.",
        "agentDebug.uncertainAction": "The external result is uncertain and needs review.",
        "agentDebug.humanActive": "AI stopped because human takeover is active.",
        "agentDebug.runFailed": "The response could not be completed.",
        "agentDebug.status.queued": "Waiting",
        "agentDebug.status.running": "In progress",
        "agentDebug.status.completed": "Completed",
        "agentDebug.status.succeeded": "Completed",
        "agentDebug.status.failed": "Failed",
        "agentDebug.status.pending": "In progress",
        "agentDebug.status.uncertain": "Needs review",
        "agentDebug.status.interrupted": "Stopped",
        "agentDebug.status.awaiting_approval": "Waiting for approval",
        "agentDebug.status.awaiting_input": "Waiting for customer information",
        "agentDebug.status.ready_to_submit": "Information collected",
        "agentDebug.status.submitted": "Delivered",
        "agentDebug.status.cancelled": "Cancelled",
        "agentDebug.status.unknown": "Saved",
        "chat.activityThinking": "Preparing your reply…",
        "chat.activityProductDetails": "Checking product details…",
        "chat.activityProductReview": "Reviewing products…",
        "chat.activitySending": "Sending your information…",
        "chat.activityHandoff": "Requesting human assistance…",
        "chat.activitySupport": "Reading support guidance…",
        "chat.activityKnowledge": "Searching business information…",
        "chat.activityProducts": "Looking for products…",
        "chat.activityAvailability": "Checking availability…",
        "chat.activityBooking": "Creating your booking…",
        "chat.activitySaving": "Saving your information…",
        "tab.home": "Home",
        "tab.history": "History",
        "tab.help": "Help",
        "home.welcome": "Welcome",
        "home.startFlowChatWith": "Start flow chat with {brandName}",
        "home.latestConversation": "Latest conversation",
        "chat.placeholder": "Ask anything...",
        "chat.send": "Send message",
        "chat.retryHint": "Retry will resend your last message.",
        "chat.retry": "Retry",
        "chat.noAvailableTimes": "No available times right now.",
        "chat.slots": "{count} slots",
        "chat.bookedFor": "Booked for {start} - {end}",
        "chat.unableToConfirm": "Unable to confirm this slot. Try another time.",
        "chat.timezone": "Timezone: {timezone}",
        "chat.sources": "Sources",
        "chat.invalidSourceGroup": "Other",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Booking...",
        "chat.booked": "Booked",
        "chat.confirmBooking": "Confirm booking",
        "chat.you": "You",
        "chat.support": "Support",
        "history.rename": "Rename",
        "history.delete": "Delete",
        "history.deleteTitle": "Delete conversation?",
        "history.deleteBody": "This will remove the conversation from your history. You can't undo this action.",
        "history.cancel": "Cancel",
        "history.confirmDelete": "Delete",
        "consent.title": "Privacy notice",
        "consent.body": "Before chatting with {brandName}, please approve our privacy policy so we can process your messages for support.",
        "consent.cta": "I agree and want to chat",
        "header.back": "Back",
        "header.flowReasoning": "Flow reasoning",
        "header.minimize": "Minimize chatbot",
        "closedFlows.dismiss": "Dismiss flow suggestions",
        "flowDebug.title": "Flow reasoning",
        "flowDebug.noActiveFlow": "No active flow",
        "flowDebug.notUpdated": "Not updated yet",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Conversation ID",
        "flowDebug.flowRunId": "Flow run ID",
        "flowDebug.selectedFlowId": "Selected flow ID",
        "flowDebug.completion": "Completion",
        "flowDebug.isComplete": "Is complete",
        "flowDebug.lastUpdated": "Last updated",
        "flowDebug.missingFields": "Missing fields",
        "flowDebug.noMissingFields": "No missing fields.",
        "flowDebug.validationIssues": "Validation issues",
        "flowDebug.unknownField": "Unknown field",
        "flowDebug.noDetails": "No details provided.",
        "flowDebug.noValidationIssues": "No validation issues.",
        "flowDebug.routerNotes": "Router notes",
        "flowDebug.noRouterDetails": "No router details available yet.",
        "flowDebug.close": "Close flow reasoning",
        "flowDebug.yes": "Yes",
        "flowDebug.no": "No",
        "help.howTitle": "How it works",
        "help.howBody": "This widget is frontend-only for now. When connected, it will reach {baseUrl} with conversation payloads. Configure apiBaseUrl when mounting to point to your environment.",
        "help.embedTitle": "Embedding",
        "help.embedBody": "Include chatbot-widget.js via a script tag. Call ChatbotWidget.mount with a target element, or simply include the script to auto-create a floating bubble. The iframe at /chatbot-embed.html pulls the same bundle.",
        "help.themeTitle": "Theming",
        "help.themeBody": "Adjust theme values for accent color, background, text, and corner radius. Position can be set to bottom-left or bottom-right for floating installs.",
        "widget.welcomeMessage": "Hi! I'm {brandName}. Start a new chat to explore help topics or resume where you left off.",
        "widget.homeHeroTitle": "Chat with {brandName}",
        "widget.homeHeroSubtitle": "Get quick answers, revisit your history, or browse help without leaving the page. Conversations stay synced across this session.",
        "widget.auth.startTrialActivate": "Start your free trial to activate this chatbot.",
        "widget.auth.unauthorized": "Unauthorized.",
        "widget.auth.unableAuth": "Unable to authenticate chatbot.",
        "widget.auth.notWorking": "This chatbot is currently not working. Try again later.",
        "widget.auth.startTrialEnable": "Start your free trial to enable conversations and flows.",
        "widget.auth.activateTitle": "Activate this chatbot",
        "widget.auth.goToDashboard": "Go to dashboard",
        "widget.openChatbot": "Open chatbot",
        "widget.conversation.defaultName": "Conversation {id}",
        "widget.conversation.defaultShort": "Conversation",
        "widget.conversation.new": "New conversation",
        "widget.conversation.pending": "Starting conversation...",
        "widget.conversation.openHistory": "Open to view conversation history.",
        "widget.handoff.connectingTitle": "A live agent will join shortly",
        "widget.handoff.connectingBody": "Please keep this chat open. They will see the conversation context when they connect.",
        "widget.handoff.joined": "A human agent has joined the chat. You can now send and receive messages in real time.",
        "widget.errors.noResponse": "I couldn't generate a response. Please try again.",
        "widget.errors.moreContext": "I need a little more context before booking. Please try again.",
        "widget.errors.meetingBooked": "Your meeting is booked. You'll receive a calendar invite shortly.",
        "widget.errors.bookingConfirmFailed": "Sorry, I couldn't confirm that slot. Please pick another time.",
        "widget.errors.connectFailed": "Sorry, I had trouble connecting to the assistant. Please try again in a moment.",
        "widget.time.justNow": "Just now",
    },
    es: {
        "chat.activityProductsFor": "Buscando {goal}…",
        "chat.activityThinking": "Preparando tu respuesta…",
        "chat.activityProductDetails": "Comprobando detalles del producto…",
        "chat.activityProductReview": "Revisando productos…",
        "chat.activitySending": "Enviando tu información…",
        "chat.activityHandoff": "Solicitando ayuda humana…",
        "chat.activitySupport": "Consultando las instrucciones de soporte…",
        "chat.activityKnowledge": "Buscando información del negocio…",
        "chat.activityProducts": "Buscando productos…",
        "chat.activityAvailability": "Consultando disponibilidad…",
        "chat.activityBooking": "Creando la reserva…",
        "chat.activitySaving": "Guardando información…",
        "tab.home": "Inicio",
        "tab.history": "Historial",
        "tab.help": "Ayuda",
        "home.welcome": "Bienvenido",
        "home.startFlowChatWith": "Iniciar chat de flujo con {brandName}",
        "home.latestConversation": "Última conversación",
        "chat.placeholder": "Pregunta lo que sea...",
        "chat.send": "Enviar mensaje",
        "chat.retryHint": "Reintentar reenviará tu último mensaje.",
        "chat.retry": "Reintentar",
        "chat.noAvailableTimes": "No hay horarios disponibles ahora.",
        "chat.slots": "{count} horarios",
        "chat.bookedFor": "Reservado para {start} - {end}",
        "chat.unableToConfirm": "No se pudo confirmar este horario. Intenta otro.",
        "chat.timezone": "Zona horaria: {timezone}",
        "chat.sources": "Fuentes",
        "chat.invalidSourceGroup": "Otros",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Reservando...",
        "chat.booked": "Reservado",
        "chat.confirmBooking": "Confirmar reserva",
        "chat.you": "Tú",
        "chat.support": "Soporte",
        "history.rename": "Renombrar",
        "history.delete": "Eliminar",
        "history.deleteTitle": "¿Eliminar conversación?",
        "history.deleteBody": "Esto eliminará la conversación de tu historial. No puedes deshacer esta acción.",
        "history.cancel": "Cancelar",
        "history.confirmDelete": "Eliminar",
        "consent.title": "Aviso de privacidad",
        "consent.body": "Antes de chatear con {brandName}, aprueba nuestra política de privacidad.",
        "consent.cta": "Estoy de acuerdo y quiero chatear",
        "header.back": "Atrás",
        "header.flowReasoning": "Razonamiento del flujo",
        "header.minimize": "Minimizar chatbot",
        "closedFlows.dismiss": "Descartar sugerencias de flujo",
        "flowDebug.title": "Razonamiento del flujo",
        "flowDebug.noActiveFlow": "Sin flujo activo",
        "flowDebug.notUpdated": "Aún no actualizado",
        "flowDebug.status": "Estado",
        "flowDebug.conversationId": "ID de conversación",
        "flowDebug.flowRunId": "ID de ejecución del flujo",
        "flowDebug.selectedFlowId": "ID de flujo seleccionado",
        "flowDebug.completion": "Completado",
        "flowDebug.isComplete": "Está completo",
        "flowDebug.lastUpdated": "Última actualización",
        "flowDebug.missingFields": "Campos faltantes",
        "flowDebug.noMissingFields": "No hay campos faltantes.",
        "flowDebug.validationIssues": "Problemas de validación",
        "flowDebug.unknownField": "Campo desconocido",
        "flowDebug.noDetails": "Sin detalles.",
        "flowDebug.noValidationIssues": "Sin problemas de validación.",
        "flowDebug.routerNotes": "Notas del enrutador",
        "flowDebug.noRouterDetails": "Aún no hay detalles del enrutador.",
        "flowDebug.close": "Cerrar razonamiento del flujo",
        "flowDebug.yes": "Sí",
        "flowDebug.no": "No",
        "help.howTitle": "Cómo funciona",
        "help.howBody": "Este widget es solo de frontend por ahora. Cuando se conecta, enviará datos a {baseUrl}. Configura apiBaseUrl al montar.",
        "help.embedTitle": "Integración",
        "help.embedBody": "Incluye chatbot-widget.js con una etiqueta script. Llama a ChatbotWidget.mount con un elemento objetivo o incluye el script para crear una burbuja flotante. El iframe /chatbot-embed.html usa el mismo bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Ajusta los valores de theme para color de acento, fondo, texto y radio de esquinas. La posición puede ser abajo-izquierda o abajo-derecha.",
        "widget.welcomeMessage": "¡Hola! Soy {brandName}. Inicia un nuevo chat para explorar ayuda o continuar.",
        "widget.homeHeroTitle": "Chatea con {brandName}",
        "widget.homeHeroSubtitle": "Obtén respuestas rápidas, revisa tu historial o busca ayuda sin salir de la página.",
        "widget.auth.startTrialActivate": "Inicia tu prueba gratuita para activar este chatbot.",
        "widget.auth.unauthorized": "No autorizado.",
        "widget.auth.unableAuth": "No se pudo autenticar el chatbot.",
        "widget.auth.notWorking": "Este chatbot no funciona en este momento. Intenta más tarde.",
        "widget.auth.startTrialEnable": "Inicia tu prueba gratuita para habilitar conversaciones y flujos.",
        "widget.auth.activateTitle": "Activa este chatbot",
        "widget.auth.goToDashboard": "Ir al panel",
        "widget.openChatbot": "Abrir chatbot",
        "widget.conversation.defaultName": "Conversación {id}",
        "widget.conversation.defaultShort": "Conversación",
        "widget.conversation.new": "Nueva conversación",
        "widget.conversation.pending": "Iniciando conversación...",
        "widget.conversation.openHistory": "Abre para ver el historial de conversación.",
        "widget.handoff.joined": "Un agente humano se unió al chat. Ahora puedes enviar y recibir mensajes en tiempo real.",
        "widget.errors.noResponse": "No pude generar una respuesta. Inténtalo de nuevo.",
        "widget.errors.moreContext": "Necesito más contexto antes de reservar. Inténtalo de nuevo.",
        "widget.errors.meetingBooked": "Tu reunión está reservada. Recibirás una invitación de calendario pronto.",
        "widget.errors.bookingConfirmFailed": "Lo siento, no pude confirmar ese horario. Elige otro.",
        "widget.errors.connectFailed": "Lo siento, tuve problemas para conectar con el asistente. Intenta de nuevo en un momento.",
        "widget.time.justNow": "Justo ahora",
    },
    fr: {
        "chat.activityProductsFor": "Je recherche {goal}…",
        "chat.activityThinking": "Je prépare votre réponse…",
        "chat.activityProductDetails": "Vérification des détails du produit…",
        "chat.activityProductReview": "Examen des produits…",
        "chat.activitySending": "Envoi de vos informations…",
        "chat.activityHandoff": "Demande d’assistance humaine…",
        "chat.activitySupport": "Consultation des instructions d’assistance…",
        "chat.activityKnowledge": "Recherche d’informations sur l’entreprise…",
        "chat.activityProducts": "Recherche de produits…",
        "chat.activityAvailability": "Vérification des disponibilités…",
        "chat.activityBooking": "Création de la réservation…",
        "chat.activitySaving": "Enregistrement des informations…",
        "tab.home": "Accueil",
        "tab.history": "Historique",
        "tab.help": "Aide",
        "home.welcome": "Bienvenue",
        "home.startFlowChatWith": "Démarrer le chat de flux avec {brandName}",
        "home.latestConversation": "Dernière conversation",
        "chat.placeholder": "Posez une question...",
        "chat.send": "Envoyer le message",
        "chat.retryHint": "Réessayer renverra votre dernier message.",
        "chat.retry": "Réessayer",
        "chat.noAvailableTimes": "Aucun créneau disponible pour le moment.",
        "chat.slots": "{count} créneaux",
        "chat.bookedFor": "Réservé pour {start} - {end}",
        "chat.unableToConfirm": "Impossible de confirmer ce créneau. Essayez un autre.",
        "chat.timezone": "Fuseau horaire : {timezone}",
        "chat.sources": "Sources",
        "chat.invalidSourceGroup": "Autres",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Réservation...",
        "chat.booked": "Réservé",
        "chat.confirmBooking": "Confirmer la réservation",
        "chat.you": "Vous",
        "chat.support": "Support",
        "history.rename": "Renommer",
        "history.delete": "Supprimer",
        "history.deleteTitle": "Supprimer la conversation ?",
        "history.deleteBody": "Cela supprimera la conversation de votre historique. Cette action est irréversible.",
        "history.cancel": "Annuler",
        "history.confirmDelete": "Supprimer",
        "consent.title": "Avis de confidentialité",
        "consent.body": "Avant de discuter avec {brandName}, veuillez approuver notre politique de confidentialité.",
        "consent.cta": "J'accepte et je veux discuter",
        "header.back": "Retour",
        "header.flowReasoning": "Raisonnement du flux",
        "header.minimize": "Réduire le chatbot",
        "closedFlows.dismiss": "Ignorer les suggestions de flux",
        "flowDebug.title": "Raisonnement du flux",
        "flowDebug.noActiveFlow": "Aucun flux actif",
        "flowDebug.notUpdated": "Pas encore mis à jour",
        "flowDebug.status": "Statut",
        "flowDebug.conversationId": "ID de conversation",
        "flowDebug.flowRunId": "ID d'exécution du flux",
        "flowDebug.selectedFlowId": "ID du flux sélectionné",
        "flowDebug.completion": "Avancement",
        "flowDebug.isComplete": "Terminé",
        "flowDebug.lastUpdated": "Dernière mise à jour",
        "flowDebug.missingFields": "Champs manquants",
        "flowDebug.noMissingFields": "Aucun champ manquant.",
        "flowDebug.validationIssues": "Problèmes de validation",
        "flowDebug.unknownField": "Champ inconnu",
        "flowDebug.noDetails": "Aucun détail fourni.",
        "flowDebug.noValidationIssues": "Aucun problème de validation.",
        "flowDebug.routerNotes": "Notes du routeur",
        "flowDebug.noRouterDetails": "Aucun détail du routeur pour l'instant.",
        "flowDebug.close": "Fermer le raisonnement du flux",
        "flowDebug.yes": "Oui",
        "flowDebug.no": "Non",
        "help.howTitle": "Fonctionnement",
        "help.howBody": "Ce widget est pour l'instant uniquement côté frontend. Une fois connecté, il enverra des données à {baseUrl}. Configurez apiBaseUrl au montage.",
        "help.embedTitle": "Intégration",
        "help.embedBody": "Incluez chatbot-widget.js via une balise script. Appelez ChatbotWidget.mount avec un élément cible ou incluez simplement le script pour créer une bulle flottante. L’iframe /chatbot-embed.html utilise le même bundle.",
        "help.themeTitle": "Thème",
        "help.themeBody": "Ajustez les valeurs theme pour l'accent, le fond, le texte et le rayon. La position peut être en bas à gauche ou à droite.",
        "widget.welcomeMessage": "Bonjour ! Je suis {brandName}. Commencez un nouveau chat pour obtenir de l'aide ou reprendre.",
        "widget.homeHeroTitle": "Discuter avec {brandName}",
        "widget.homeHeroSubtitle": "Obtenez des réponses rapides, consultez votre historique ou parcourez l’aide sans quitter la page.",
        "widget.auth.startTrialActivate": "Démarrez votre essai gratuit pour activer ce chatbot.",
        "widget.auth.unauthorized": "Non autorisé.",
        "widget.auth.unableAuth": "Impossible d’authentifier le chatbot.",
        "widget.auth.notWorking": "Ce chatbot ne fonctionne pas pour le moment. Réessayez plus tard.",
        "widget.auth.startTrialEnable": "Démarrez votre essai gratuit pour activer conversations et flux.",
        "widget.auth.activateTitle": "Activer ce chatbot",
        "widget.auth.goToDashboard": "Aller au tableau de bord",
        "widget.openChatbot": "Ouvrir le chatbot",
        "widget.conversation.defaultName": "Conversation {id}",
        "widget.conversation.defaultShort": "Conversation",
        "widget.conversation.new": "Nouvelle conversation",
        "widget.conversation.pending": "Démarrage de la conversation...",
        "widget.conversation.openHistory": "Ouvrez pour voir l’historique de conversation.",
        "widget.handoff.joined": "Un agent humain a rejoint la conversation. Vous pouvez maintenant échanger en temps réel.",
        "widget.errors.noResponse": "Je n’ai pas pu générer de réponse. Veuillez réessayer.",
        "widget.errors.moreContext": "J’ai besoin d’un peu plus de contexte avant de réserver. Réessayez.",
        "widget.errors.meetingBooked": "Votre rendez-vous est réservé. Vous recevrez bientôt une invitation calendrier.",
        "widget.errors.bookingConfirmFailed": "Désolé, impossible de confirmer ce créneau. Choisissez-en un autre.",
        "widget.errors.connectFailed": "Désolé, problème de connexion à l’assistant. Réessayez dans un instant.",
        "widget.time.justNow": "À l’instant",
    },
    de: {
        "chat.activityProductsFor": "Suche nach {goal}…",
        "chat.activityThinking": "Antwort wird vorbereitet…",
        "chat.activityProductDetails": "Produktdetails werden geprüft…",
        "chat.activityProductReview": "Produkte werden verglichen…",
        "chat.activitySending": "Ihre Angaben werden gesendet…",
        "chat.activityHandoff": "Menschliche Hilfe wird angefragt…",
        "chat.activitySupport": "Supportanweisungen werden gelesen…",
        "chat.activityKnowledge": "Geschäftsinformationen werden gesucht…",
        "chat.activityProducts": "Produkte werden gesucht…",
        "chat.activityAvailability": "Verfügbarkeit wird geprüft…",
        "chat.activityBooking": "Buchung wird erstellt…",
        "chat.activitySaving": "Informationen werden gespeichert…",
        "tab.home": "Start",
        "tab.history": "Verlauf",
        "tab.help": "Hilfe",
        "home.welcome": "Willkommen",
        "home.startFlowChatWith": "Flow-Chat starten mit {brandName}",
        "home.latestConversation": "Letzte Konversation",
        "chat.placeholder": "Frag einfach...",
        "chat.send": "Nachricht senden",
        "chat.retryHint": "Erneut senden wiederholt deine letzte Nachricht.",
        "chat.retry": "Erneut senden",
        "chat.noAvailableTimes": "Derzeit keine verfügbaren Zeiten.",
        "chat.slots": "{count} Termine",
        "chat.bookedFor": "Gebucht für {start} - {end}",
        "chat.unableToConfirm": "Dieser Termin konnte nicht bestätigt werden. Bitte einen anderen wählen.",
        "chat.timezone": "Zeitzone: {timezone}",
        "chat.durationMinutes": "{minutes} Min",
        "chat.bookingPending": "Buchung...",
        "chat.booked": "Gebucht",
        "chat.confirmBooking": "Buchung bestätigen",
        "chat.you": "Du",
        "chat.support": "Support",
        "history.rename": "Umbenennen",
        "history.delete": "Löschen",
        "history.deleteTitle": "Konversation löschen?",
        "history.deleteBody": "Dies entfernt die Konversation aus deinem Verlauf. Das kann nicht rückgängig gemacht werden.",
        "history.cancel": "Abbrechen",
        "history.confirmDelete": "Löschen",
        "consent.title": "Datenschutzhinweis",
        "consent.body": "Bevor du mit {brandName} chattest, bestätige bitte unsere Datenschutzerklärung.",
        "consent.cta": "Ich stimme zu und möchte chatten",
        "header.back": "Zurück",
        "header.flowReasoning": "Flow-Begründung",
        "header.minimize": "Chatbot minimieren",
        "closedFlows.dismiss": "Flow-Vorschläge ausblenden",
        "flowDebug.title": "Flow-Begründung",
        "flowDebug.noActiveFlow": "Kein aktiver Flow",
        "flowDebug.notUpdated": "Noch nicht aktualisiert",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Konversations-ID",
        "flowDebug.flowRunId": "Flow-Run-ID",
        "flowDebug.selectedFlowId": "Ausgewählte Flow-ID",
        "flowDebug.completion": "Fortschritt",
        "flowDebug.isComplete": "Abgeschlossen",
        "flowDebug.lastUpdated": "Zuletzt aktualisiert",
        "flowDebug.missingFields": "Fehlende Felder",
        "flowDebug.noMissingFields": "Keine fehlenden Felder.",
        "flowDebug.validationIssues": "Validierungsprobleme",
        "flowDebug.unknownField": "Unbekanntes Feld",
        "flowDebug.noDetails": "Keine Details angegeben.",
        "flowDebug.noValidationIssues": "Keine Validierungsprobleme.",
        "flowDebug.routerNotes": "Router-Notizen",
        "flowDebug.noRouterDetails": "Noch keine Router-Details verfügbar.",
        "flowDebug.close": "Flow-Begründung schließen",
        "flowDebug.yes": "Ja",
        "flowDebug.no": "Nein",
        "help.howTitle": "So funktioniert es",
        "help.howBody": "Dieses Widget ist derzeit nur frontend-seitig. Wenn verbunden, sendet es Daten an {baseUrl}. Setze apiBaseUrl beim Mounten, um auf deine Umgebung zu zeigen.",
        "help.embedTitle": "Einbettung",
        "help.embedBody": "Füge chatbot-widget.js per Script-Tag ein. Rufe ChatbotWidget.mount mit einem Ziel-Element auf oder binde das Script ein, um eine schwebende Blase zu erstellen. Das Iframe unter /chatbot-embed.html nutzt dasselbe Bundle.",
        "help.themeTitle": "Thema",
        "help.themeBody": "Passe theme-Werte für Akzentfarbe, Hintergrund, Text und Eckenradius an. Position kann unten links oder unten rechts sein.",
        "widget.welcomeMessage": "Hi! Ich bin {brandName}. Starte einen neuen Chat, um Hilfe zu erhalten oder dort weiterzumachen, wo du aufgehört hast.",
        "widget.homeHeroTitle": "Chatte mit {brandName}",
        "widget.homeHeroSubtitle": "Erhalte schnelle Antworten, sieh deinen Verlauf oder durchsuche die Hilfe, ohne die Seite zu verlassen.",
        "widget.auth.startTrialActivate": "Starte deine kostenlose Testphase, um diesen Chatbot zu aktivieren.",
        "widget.auth.unauthorized": "Nicht autorisiert.",
        "widget.auth.unableAuth": "Chatbot-Authentifizierung fehlgeschlagen.",
        "widget.auth.notWorking": "Dieser Chatbot funktioniert derzeit nicht. Versuche es später erneut.",
        "widget.auth.startTrialEnable": "Starte deine kostenlose Testphase, um Gespräche und Flows zu aktivieren.",
        "widget.auth.activateTitle": "Chatbot aktivieren",
        "widget.auth.goToDashboard": "Zum Dashboard",
        "widget.openChatbot": "Chatbot öffnen",
        "widget.conversation.defaultName": "Konversation {id}",
        "widget.conversation.defaultShort": "Konversation",
        "widget.conversation.new": "Neue Konversation",
        "widget.conversation.pending": "Konversation wird gestartet...",
        "widget.conversation.openHistory": "Öffnen, um den Gesprächsverlauf zu sehen.",
        "widget.handoff.joined": "Ein menschlicher Agent ist dem Chat beigetreten. Du kannst jetzt in Echtzeit schreiben.",
        "widget.errors.noResponse": "Ich konnte keine Antwort erzeugen. Bitte versuche es erneut.",
        "widget.errors.moreContext": "Ich brauche mehr Kontext vor der Buchung. Bitte versuche es erneut.",
        "widget.errors.meetingBooked": "Dein Termin ist gebucht. Du erhältst bald eine Kalendereinladung.",
        "widget.errors.bookingConfirmFailed": "Entschuldigung, der Termin konnte nicht bestätigt werden. Bitte wähle einen anderen.",
        "widget.errors.connectFailed": "Entschuldigung, Verbindung zum Assistenten fehlgeschlagen. Bitte gleich erneut versuchen.",
        "widget.time.justNow": "Gerade eben",
    },
    it: {
        "chat.activityProductsFor": "Cerco {goal}…",
        "chat.activityThinking": "Preparo la risposta…",
        "chat.activityProductDetails": "Verifico i dettagli del prodotto…",
        "chat.activityProductReview": "Valuto i prodotti…",
        "chat.activitySending": "Invio le tue informazioni…",
        "chat.activityHandoff": "Richiedo assistenza umana…",
        "chat.activitySupport": "Consulto le istruzioni di supporto…",
        "chat.activityKnowledge": "Ricerca di informazioni sull’attività…",
        "chat.activityProducts": "Ricerca di prodotti…",
        "chat.activityAvailability": "Verifica della disponibilità…",
        "chat.activityBooking": "Creazione della prenotazione…",
        "chat.activitySaving": "Salvataggio delle informazioni…",
        "tab.home": "Home",
        "tab.history": "Cronologia",
        "tab.help": "Aiuto",
        "home.welcome": "Benvenuto",
        "home.startFlowChatWith": "Avvia chat del flusso con {brandName}",
        "home.latestConversation": "Ultima conversazione",
        "chat.placeholder": "Chiedi qualsiasi cosa...",
        "chat.send": "Invia messaggio",
        "chat.retryHint": "Riprova reinvierà l’ultimo messaggio.",
        "chat.retry": "Riprova",
        "chat.noAvailableTimes": "Nessun orario disponibile al momento.",
        "chat.slots": "{count} slot",
        "chat.bookedFor": "Prenotato per {start} - {end}",
        "chat.unableToConfirm": "Impossibile confermare questo slot. Prova un altro.",
        "chat.timezone": "Fuso orario: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Prenotazione...",
        "chat.booked": "Prenotato",
        "chat.confirmBooking": "Conferma prenotazione",
        "chat.you": "Tu",
        "chat.support": "Supporto",
        "history.rename": "Rinomina",
        "history.delete": "Elimina",
        "history.deleteTitle": "Eliminare la conversazione?",
        "history.deleteBody": "Questo rimuoverà la conversazione dalla cronologia. Non puoi annullare l’azione.",
        "history.cancel": "Annulla",
        "history.confirmDelete": "Elimina",
        "consent.title": "Informativa sulla privacy",
        "consent.body": "Prima di chattare con {brandName}, approva la nostra informativa.",
        "consent.cta": "Accetto e voglio chattare",
        "header.back": "Indietro",
        "header.flowReasoning": "Motivazione del flusso",
        "header.minimize": "Minimizza chatbot",
        "closedFlows.dismiss": "Nascondi suggerimenti del flusso",
        "flowDebug.title": "Motivazione del flusso",
        "flowDebug.noActiveFlow": "Nessun flusso attivo",
        "flowDebug.notUpdated": "Non ancora aggiornato",
        "flowDebug.status": "Stato",
        "flowDebug.conversationId": "ID conversazione",
        "flowDebug.flowRunId": "ID esecuzione flusso",
        "flowDebug.selectedFlowId": "ID flusso selezionato",
        "flowDebug.completion": "Completamento",
        "flowDebug.isComplete": "È completo",
        "flowDebug.lastUpdated": "Ultimo aggiornamento",
        "flowDebug.missingFields": "Campi mancanti",
        "flowDebug.noMissingFields": "Nessun campo mancante.",
        "flowDebug.validationIssues": "Problemi di validazione",
        "flowDebug.unknownField": "Campo sconosciuto",
        "flowDebug.noDetails": "Nessun dettaglio fornito.",
        "flowDebug.noValidationIssues": "Nessun problema di validazione.",
        "flowDebug.routerNotes": "Note del router",
        "flowDebug.noRouterDetails": "Nessun dettaglio del router disponibile.",
        "flowDebug.close": "Chiudi motivazione del flusso",
        "flowDebug.yes": "Sì",
        "flowDebug.no": "No",
        "help.howTitle": "Come funziona",
        "help.howBody": "Questo widget è solo frontend per ora. Quando collegato, invia a {baseUrl}. Configura apiBaseUrl al mount.",
        "help.embedTitle": "Integrazione",
        "help.embedBody": "Includi chatbot-widget.js con un tag script. Chiama ChatbotWidget.mount con un elemento target o includi lo script per creare una bolla flottante. L’iframe /chatbot-embed.html usa lo stesso bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Regola i valori theme per colore accento, sfondo, testo e raggio angoli. La posizione può essere in basso a sinistra o a destra.",
        "widget.welcomeMessage": "Ciao! Sono {brandName}. Avvia una nuova chat per esplorare l’aiuto o riprendere.",
        "widget.homeHeroTitle": "Chatta con {brandName}",
        "widget.homeHeroSubtitle": "Risposte rapide, cronologia e aiuto senza lasciare la pagina.",
        "widget.auth.startTrialActivate": "Avvia la prova gratuita per attivare questo chatbot.",
        "widget.auth.unauthorized": "Non autorizzato.",
        "widget.auth.unableAuth": "Impossibile autenticare il chatbot.",
        "widget.auth.notWorking": "Questo chatbot non è attivo al momento. Riprova più tardi.",
        "widget.auth.startTrialEnable": "Avvia la prova gratuita per abilitare conversazioni e flussi.",
        "widget.auth.activateTitle": "Attiva questo chatbot",
        "widget.auth.goToDashboard": "Vai alla dashboard",
        "widget.openChatbot": "Apri chatbot",
        "widget.conversation.defaultName": "Conversazione {id}",
        "widget.conversation.defaultShort": "Conversazione",
        "widget.conversation.new": "Nuova conversazione",
        "widget.conversation.pending": "Avvio conversazione...",
        "widget.conversation.openHistory": "Apri per vedere la cronologia.",
        "widget.handoff.joined": "Un agente umano si è unito alla chat. Ora puoi inviare e ricevere messaggi in tempo reale.",
        "widget.errors.noResponse": "Non sono riuscito a generare una risposta. Riprova.",
        "widget.errors.moreContext": "Ho bisogno di più contesto prima di prenotare. Riprova.",
        "widget.errors.meetingBooked": "Il tuo appuntamento è prenotato. Riceverai un invito al calendario.",
        "widget.errors.bookingConfirmFailed": "Mi dispiace, non posso confermare questo slot. Scegline un altro.",
        "widget.errors.connectFailed": "Mi dispiace, problema di connessione con l’assistente. Riprova tra poco.",
        "widget.time.justNow": "Proprio ora",
    },
    pt: {
        "chat.activityProductsFor": "A procurar {goal}…",
        "chat.activityThinking": "A preparar a resposta…",
        "chat.activityProductDetails": "A verificar detalhes do produto…",
        "chat.activityProductReview": "A analisar produtos…",
        "chat.activitySending": "A enviar os seus dados…",
        "chat.activityHandoff": "A pedir assistência humana…",
        "chat.activitySupport": "A consultar as instruções de apoio…",
        "chat.activityKnowledge": "A procurar informações sobre a empresa…",
        "chat.activityProducts": "A procurar produtos…",
        "chat.activityAvailability": "A verificar disponibilidade…",
        "chat.activityBooking": "A criar a reserva…",
        "chat.activitySaving": "A guardar informações…",
        "tab.home": "Início",
        "tab.history": "Histórico",
        "tab.help": "Ajuda",
        "home.welcome": "Bem-vindo",
        "home.startFlowChatWith": "Iniciar chat de fluxo com {brandName}",
        "home.latestConversation": "Última conversa",
        "chat.placeholder": "Pergunte qualquer coisa...",
        "chat.send": "Enviar mensagem",
        "chat.retryHint": "Reenviar enviará sua última mensagem.",
        "chat.retry": "Reenviar",
        "chat.noAvailableTimes": "Sem horários disponíveis no momento.",
        "chat.slots": "{count} horários",
        "chat.bookedFor": "Agendado para {start} - {end}",
        "chat.unableToConfirm": "Não foi possível confirmar este horário. Tente outro.",
        "chat.timezone": "Fuso horário: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Agendando...",
        "chat.booked": "Agendado",
        "chat.confirmBooking": "Confirmar agendamento",
        "chat.you": "Você",
        "chat.support": "Suporte",
        "history.rename": "Renomear",
        "history.delete": "Excluir",
        "history.deleteTitle": "Excluir conversa?",
        "history.deleteBody": "Isso removerá a conversa do histórico. Não é possível desfazer.",
        "history.cancel": "Cancelar",
        "history.confirmDelete": "Excluir",
        "consent.title": "Aviso de privacidade",
        "consent.body": "Antes de conversar com {brandName}, aprove nossa política de privacidade.",
        "consent.cta": "Concordo e quero conversar",
        "header.back": "Voltar",
        "header.flowReasoning": "Raciocínio do fluxo",
        "header.minimize": "Minimizar chatbot",
        "closedFlows.dismiss": "Dispensar sugestões de fluxo",
        "flowDebug.title": "Raciocínio do fluxo",
        "flowDebug.noActiveFlow": "Nenhum fluxo ativo",
        "flowDebug.notUpdated": "Ainda não atualizado",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID da conversa",
        "flowDebug.flowRunId": "ID de execução do fluxo",
        "flowDebug.selectedFlowId": "ID do fluxo selecionado",
        "flowDebug.completion": "Conclusão",
        "flowDebug.isComplete": "Está concluído",
        "flowDebug.lastUpdated": "Última atualização",
        "flowDebug.missingFields": "Campos ausentes",
        "flowDebug.noMissingFields": "Nenhum campo ausente.",
        "flowDebug.validationIssues": "Problemas de validação",
        "flowDebug.unknownField": "Campo desconhecido",
        "flowDebug.noDetails": "Sem detalhes fornecidos.",
        "flowDebug.noValidationIssues": "Sem problemas de validação.",
        "flowDebug.routerNotes": "Notas do roteador",
        "flowDebug.noRouterDetails": "Nenhum detalhe do roteador ainda.",
        "flowDebug.close": "Fechar raciocínio do fluxo",
        "flowDebug.yes": "Sim",
        "flowDebug.no": "Não",
        "help.howTitle": "Como funciona",
        "help.howBody": "Este widget é apenas frontend por enquanto. Quando conectado, enviará dados para {baseUrl}. Configure apiBaseUrl ao montar.",
        "help.embedTitle": "Incorporação",
        "help.embedBody": "Inclua chatbot-widget.js com uma tag script. Chame ChatbotWidget.mount com um elemento alvo ou inclua o script para criar uma bolha flutuante. O iframe /chatbot-embed.html usa o mesmo bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Ajuste os valores de tema para cor de destaque, fundo, texto e raio dos cantos. A posição pode ser inferior esquerda ou direita.",
        "widget.welcomeMessage": "Olá! Sou {brandName}. Inicie um novo chat para explorar ajuda ou continuar.",
        "widget.homeHeroTitle": "Converse com {brandName}",
        "widget.homeHeroSubtitle": "Receba respostas rápidas, veja seu histórico ou explore a ajuda sem sair da página.",
        "widget.auth.startTrialActivate": "Inicie seu teste gratuito para ativar este chatbot.",
        "widget.auth.unauthorized": "Não autorizado.",
        "widget.auth.unableAuth": "Não foi possível autenticar o chatbot.",
        "widget.auth.notWorking": "Este chatbot não está funcionando agora. Tente novamente mais tarde.",
        "widget.auth.startTrialEnable": "Inicie seu teste gratuito para habilitar conversas e fluxos.",
        "widget.auth.activateTitle": "Ativar este chatbot",
        "widget.auth.goToDashboard": "Ir para o painel",
        "widget.openChatbot": "Abrir chatbot",
        "widget.conversation.defaultName": "Conversa {id}",
        "widget.conversation.defaultShort": "Conversa",
        "widget.conversation.new": "Nova conversa",
        "widget.conversation.pending": "Iniciando conversa...",
        "widget.conversation.openHistory": "Abra para ver o histórico de conversa.",
        "widget.handoff.joined": "Um agente humano entrou no chat. Agora você pode enviar e receber mensagens em tempo real.",
        "widget.errors.noResponse": "Não consegui gerar uma resposta. Tente novamente.",
        "widget.errors.moreContext": "Preciso de mais contexto antes de agendar. Tente novamente.",
        "widget.errors.meetingBooked": "Sua reunião está agendada. Você receberá um convite de calendário em breve.",
        "widget.errors.bookingConfirmFailed": "Desculpe, não consegui confirmar esse horário. Escolha outro.",
        "widget.errors.connectFailed": "Desculpe, tive problemas para conectar ao assistente. Tente novamente em alguns instantes.",
        "widget.time.justNow": "Agora mesmo",
    },
    "pt-br": {
        "chat.activityProductsFor": "Buscando {goal}…",
        "chat.activityThinking": "Preparando sua resposta…",
        "chat.activityProductDetails": "Verificando detalhes do produto…",
        "chat.activityProductReview": "Analisando produtos…",
        "chat.activitySending": "Enviando suas informações…",
        "chat.activityHandoff": "Solicitando atendimento humano…",
        "chat.activitySupport": "Consultando as instruções de suporte…",
        "tab.home": "Início",
        "tab.history": "Histórico",
        "tab.help": "Ajuda",
        "home.welcome": "Bem-vindo",
        "home.startFlowChatWith": "Iniciar chat de fluxo com {brandName}",
        "home.latestConversation": "Última conversa",
        "chat.placeholder": "Pergunte qualquer coisa...",
        "chat.send": "Enviar mensagem",
        "chat.retryHint": "Reenviar vai mandar sua última mensagem.",
        "chat.retry": "Reenviar",
        "chat.noAvailableTimes": "Sem horários disponíveis agora.",
        "chat.slots": "{count} horários",
        "chat.bookedFor": "Agendado para {start} - {end}",
        "chat.unableToConfirm": "Não foi possível confirmar este horário. Tente outro.",
        "chat.timezone": "Fuso horário: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Agendando...",
        "chat.booked": "Agendado",
        "chat.confirmBooking": "Confirmar agendamento",
        "chat.you": "Você",
        "chat.support": "Suporte",
        "history.rename": "Renomear",
        "history.delete": "Excluir",
        "history.deleteTitle": "Excluir conversa?",
        "history.deleteBody": "Isso removerá a conversa do histórico. Não é possível desfazer.",
        "history.cancel": "Cancelar",
        "history.confirmDelete": "Excluir",
        "consent.title": "Aviso de privacidade",
        "consent.body": "Antes de conversar com {brandName}, aceite nossa política de privacidade.",
        "consent.cta": "Concordo e quero conversar",
        "header.back": "Voltar",
        "header.flowReasoning": "Raciocínio do fluxo",
        "header.minimize": "Minimizar chatbot",
        "closedFlows.dismiss": "Dispensar sugestões de fluxo",
        "flowDebug.title": "Raciocínio do fluxo",
        "flowDebug.noActiveFlow": "Nenhum fluxo ativo",
        "flowDebug.notUpdated": "Ainda não atualizado",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID da conversa",
        "flowDebug.flowRunId": "ID de execução do fluxo",
        "flowDebug.selectedFlowId": "ID do fluxo selecionado",
        "flowDebug.completion": "Conclusão",
        "flowDebug.isComplete": "Está concluído",
        "flowDebug.lastUpdated": "Última atualização",
        "flowDebug.missingFields": "Campos ausentes",
        "flowDebug.noMissingFields": "Nenhum campo ausente.",
        "flowDebug.validationIssues": "Problemas de validação",
        "flowDebug.unknownField": "Campo desconhecido",
        "flowDebug.noDetails": "Sem detalhes fornecidos.",
        "flowDebug.noValidationIssues": "Sem problemas de validação.",
        "flowDebug.routerNotes": "Notas do roteador",
        "flowDebug.noRouterDetails": "Nenhum detalhe do roteador ainda.",
        "flowDebug.close": "Fechar raciocínio do fluxo",
        "flowDebug.yes": "Sim",
        "flowDebug.no": "Não",
        "help.howTitle": "Como funciona",
        "help.howBody": "Este widget é apenas frontend por enquanto. Quando conectado, enviará dados para {baseUrl}. Configure apiBaseUrl ao montar.",
        "help.embedTitle": "Incorporação",
        "help.embedBody": "Inclua chatbot-widget.js com uma tag script. Chame ChatbotWidget.mount com um elemento alvo ou inclua o script para criar uma bolha flutuante. O iframe /chatbot-embed.html usa o mesmo bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Ajuste o tema para cor de destaque, fundo, texto e raio dos cantos. A posição pode ser inferior esquerda ou direita.",
        "widget.welcomeMessage": "Oi! Eu sou {brandName}. Inicie um novo chat para explorar ajuda ou continuar.",
        "widget.homeHeroTitle": "Converse com {brandName}",
        "widget.homeHeroSubtitle": "Respostas rápidas, histórico e ajuda sem sair da página.",
        "widget.auth.startTrialActivate": "Comece seu teste grátis para ativar este chatbot.",
        "widget.auth.unauthorized": "Não autorizado.",
        "widget.auth.unableAuth": "Não foi possível autenticar o chatbot.",
        "widget.auth.notWorking": "Este chatbot não está funcionando agora. Tente mais tarde.",
        "widget.auth.startTrialEnable": "Comece seu teste grátis para habilitar conversas e fluxos.",
        "widget.auth.activateTitle": "Ativar este chatbot",
        "widget.auth.goToDashboard": "Ir para o painel",
        "widget.openChatbot": "Abrir chatbot",
        "widget.conversation.defaultName": "Conversa {id}",
        "widget.conversation.defaultShort": "Conversa",
        "widget.conversation.new": "Nova conversa",
        "widget.conversation.pending": "Iniciando conversa...",
        "widget.conversation.openHistory": "Abra para ver o histórico da conversa.",
        "widget.handoff.joined": "Um agente humano entrou no chat. Agora você pode enviar e receber mensagens em tempo real.",
        "widget.errors.noResponse": "Não consegui gerar uma resposta. Tente novamente.",
        "widget.errors.moreContext": "Preciso de mais contexto antes de agendar. Tente novamente.",
        "widget.errors.meetingBooked": "Sua reunião está agendada. Você receberá um convite de calendário em breve.",
        "widget.errors.bookingConfirmFailed": "Desculpe, não consegui confirmar esse horário. Escolha outro.",
        "widget.errors.connectFailed": "Desculpe, tive problemas para conectar ao assistente. Tente novamente em alguns instantes.",
        "widget.time.justNow": "Agora mesmo",
    },
    nl: {
        "chat.activityProductsFor": "Zoeken naar {goal}…",
        "chat.activityThinking": "Je antwoord voorbereiden…",
        "chat.activityProductDetails": "Productdetails controleren…",
        "chat.activityProductReview": "Producten beoordelen…",
        "chat.activitySending": "Je gegevens versturen…",
        "chat.activityHandoff": "Menselijke hulp aanvragen…",
        "chat.activitySupport": "Ondersteuningsinstructies lezen…",
        "chat.activityKnowledge": "Bedrijfsinformatie zoeken…",
        "chat.activityProducts": "Producten zoeken…",
        "chat.activityAvailability": "Beschikbaarheid controleren…",
        "chat.activityBooking": "Boeking maken…",
        "chat.activitySaving": "Informatie opslaan…",
        "tab.home": "Start",
        "tab.history": "Geschiedenis",
        "tab.help": "Help",
        "home.welcome": "Welkom",
        "home.startFlowChatWith": "Start flow-chat met {brandName}",
        "home.latestConversation": "Laatste gesprek",
        "chat.placeholder": "Stel een vraag...",
        "chat.send": "Bericht verzenden",
        "chat.retryHint": "Opnieuw proberen stuurt je laatste bericht opnieuw.",
        "chat.retry": "Opnieuw proberen",
        "chat.noAvailableTimes": "Geen beschikbare tijden op dit moment.",
        "chat.slots": "{count} tijdsloten",
        "chat.bookedFor": "Geboekt voor {start} - {end}",
        "chat.unableToConfirm": "Kan dit tijdslot niet bevestigen. Probeer een andere tijd.",
        "chat.timezone": "Tijdzone: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Bezig met boeken...",
        "chat.booked": "Geboekt",
        "chat.confirmBooking": "Boeking bevestigen",
        "chat.you": "Jij",
        "chat.support": "Support",
        "history.rename": "Hernoemen",
        "history.delete": "Verwijderen",
        "history.deleteTitle": "Gesprek verwijderen?",
        "history.deleteBody": "Dit verwijdert het gesprek uit je geschiedenis. Dit kan niet ongedaan worden gemaakt.",
        "history.cancel": "Annuleren",
        "history.confirmDelete": "Verwijderen",
        "consent.title": "Privacyverklaring",
        "consent.body": "Voordat je met {brandName} chat, ga akkoord met ons privacybeleid.",
        "consent.cta": "Ik ga akkoord en wil chatten",
        "header.back": "Terug",
        "header.flowReasoning": "Flow-redenering",
        "header.minimize": "Chatbot minimaliseren",
        "closedFlows.dismiss": "Flow-suggesties sluiten",
        "flowDebug.title": "Flow-redenering",
        "flowDebug.noActiveFlow": "Geen actieve flow",
        "flowDebug.notUpdated": "Nog niet bijgewerkt",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Gespreks-ID",
        "flowDebug.flowRunId": "Flow-run-ID",
        "flowDebug.selectedFlowId": "Geselecteerde flow-ID",
        "flowDebug.completion": "Voltooiing",
        "flowDebug.isComplete": "Is voltooid",
        "flowDebug.lastUpdated": "Laatst bijgewerkt",
        "flowDebug.missingFields": "Ontbrekende velden",
        "flowDebug.noMissingFields": "Geen ontbrekende velden.",
        "flowDebug.validationIssues": "Validatieproblemen",
        "flowDebug.unknownField": "Onbekend veld",
        "flowDebug.noDetails": "Geen details opgegeven.",
        "flowDebug.noValidationIssues": "Geen validatieproblemen.",
        "flowDebug.routerNotes": "Routernotities",
        "flowDebug.noRouterDetails": "Nog geen routerdetails beschikbaar.",
        "flowDebug.close": "Flow-redenering sluiten",
        "flowDebug.yes": "Ja",
        "flowDebug.no": "Nee",
        "help.howTitle": "Hoe het werkt",
        "help.howBody": "Deze widget is voorlopig alleen frontend. Wanneer verbonden, stuurt het payloads naar {baseUrl}. Configureer apiBaseUrl bij het mounten.",
        "help.embedTitle": "Insluiten",
        "help.embedBody": "Neem chatbot-widget.js op via een script-tag. Roep ChatbotWidget.mount aan met een doelelement of voeg het script toe voor een zwevende bubble. De iframe op /chatbot-embed.html gebruikt dezelfde bundle.",
        "help.themeTitle": "Thema",
        "help.themeBody": "Pas themawaarden aan voor accentkleur, achtergrond, tekst en hoekradius. Positie kan linksonder of rechtsonder zijn.",
        "widget.welcomeMessage": "Hoi! Ik ben {brandName}. Start een nieuw gesprek om hulp te verkennen of door te gaan.",
        "widget.homeHeroTitle": "Chat met {brandName}",
        "widget.homeHeroSubtitle": "Krijg snel antwoorden, bekijk je geschiedenis of blader door hulp zonder de pagina te verlaten.",
        "widget.auth.startTrialActivate": "Start je gratis proefperiode om deze chatbot te activeren.",
        "widget.auth.unauthorized": "Niet geautoriseerd.",
        "widget.auth.unableAuth": "Kan chatbot niet verifiëren.",
        "widget.auth.notWorking": "Deze chatbot werkt momenteel niet. Probeer het later opnieuw.",
        "widget.auth.startTrialEnable": "Start je gratis proefperiode om gesprekken en flows in te schakelen.",
        "widget.auth.activateTitle": "Chatbot activeren",
        "widget.auth.goToDashboard": "Ga naar dashboard",
        "widget.openChatbot": "Chatbot openen",
        "widget.conversation.defaultName": "Gesprek {id}",
        "widget.conversation.defaultShort": "Gesprek",
        "widget.conversation.new": "Nieuw gesprek",
        "widget.conversation.pending": "Gesprek starten...",
        "widget.conversation.openHistory": "Open om gespreksgeschiedenis te bekijken.",
        "widget.handoff.joined": "Een menselijke agent is aan de chat toegevoegd. Je kunt nu in realtime berichten sturen en ontvangen.",
        "widget.errors.noResponse": "Ik kon geen antwoord genereren. Probeer het opnieuw.",
        "widget.errors.moreContext": "Ik heb meer context nodig voordat ik boek. Probeer het opnieuw.",
        "widget.errors.meetingBooked": "Je afspraak is geboekt. Je ontvangt binnenkort een agenda-uitnodiging.",
        "widget.errors.bookingConfirmFailed": "Sorry, ik kon dat tijdslot niet bevestigen. Kies een andere.",
        "widget.errors.connectFailed": "Sorry, ik had problemen om te verbinden met de assistent. Probeer het zo weer.",
        "widget.time.justNow": "Zojuist",
    },
    sv: {
        "chat.activityProductsFor": "Letar efter {goal}…",
        "chat.activityThinking": "Förbereder ditt svar…",
        "chat.activityProductDetails": "Kontrollerar produktdetaljer…",
        "chat.activityProductReview": "Granskar produkter…",
        "chat.activitySending": "Skickar dina uppgifter…",
        "chat.activityHandoff": "Begär mänsklig hjälp…",
        "chat.activitySupport": "Läser supportinstruktioner…",
        "chat.activityKnowledge": "Söker företagsinformation…",
        "chat.activityProducts": "Söker produkter…",
        "chat.activityAvailability": "Kontrollerar tillgänglighet…",
        "chat.activityBooking": "Skapar bokning…",
        "chat.activitySaving": "Sparar information…",
        "tab.home": "Hem",
        "tab.history": "Historik",
        "tab.help": "Hjälp",
        "home.welcome": "Välkommen",
        "home.startFlowChatWith": "Starta flödeschatt med {brandName}",
        "home.latestConversation": "Senaste konversationen",
        "chat.placeholder": "Fråga vad som helst...",
        "chat.send": "Skicka meddelande",
        "chat.retryHint": "Försök igen skickar om ditt senaste meddelande.",
        "chat.retry": "Försök igen",
        "chat.noAvailableTimes": "Inga lediga tider just nu.",
        "chat.slots": "{count} tider",
        "chat.bookedFor": "Bokat för {start} - {end}",
        "chat.unableToConfirm": "Kan inte bekräfta denna tid. Prova en annan.",
        "chat.timezone": "Tidszon: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Bokar...",
        "chat.booked": "Bokat",
        "chat.confirmBooking": "Bekräfta bokning",
        "chat.you": "Du",
        "chat.support": "Support",
        "history.rename": "Byt namn",
        "history.delete": "Ta bort",
        "history.deleteTitle": "Ta bort konversation?",
        "history.deleteBody": "Detta tar bort konversationen från din historik. Det går inte att ångra.",
        "history.cancel": "Avbryt",
        "history.confirmDelete": "Ta bort",
        "consent.title": "Sekretessmeddelande",
        "consent.body": "Innan du chattar med {brandName}, godkänn vår sekretesspolicy.",
        "consent.cta": "Jag godkänner och vill chatta",
        "header.back": "Tillbaka",
        "header.flowReasoning": "Flödesresonemang",
        "header.minimize": "Minimera chatbot",
        "closedFlows.dismiss": "Avfärda flödesförslag",
        "flowDebug.title": "Flödesresonemang",
        "flowDebug.noActiveFlow": "Inget aktivt flöde",
        "flowDebug.notUpdated": "Inte uppdaterat än",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Konversations-ID",
        "flowDebug.flowRunId": "Flödeskörnings-ID",
        "flowDebug.selectedFlowId": "Valt flödes-ID",
        "flowDebug.completion": "Slutförande",
        "flowDebug.isComplete": "Är klart",
        "flowDebug.lastUpdated": "Senast uppdaterad",
        "flowDebug.missingFields": "Saknade fält",
        "flowDebug.noMissingFields": "Inga saknade fält.",
        "flowDebug.validationIssues": "Valideringsproblem",
        "flowDebug.unknownField": "Okänt fält",
        "flowDebug.noDetails": "Inga detaljer angivna.",
        "flowDebug.noValidationIssues": "Inga valideringsproblem.",
        "flowDebug.routerNotes": "Routeranteckningar",
        "flowDebug.noRouterDetails": "Inga routerdetaljer ännu.",
        "flowDebug.close": "Stäng flödesresonemang",
        "flowDebug.yes": "Ja",
        "flowDebug.no": "Nej",
        "help.howTitle": "Så fungerar det",
        "help.howBody": "Den här widgeten är frontend-only just nu. När den är ansluten skickar den data till {baseUrl}. Konfigurera apiBaseUrl vid montering.",
        "help.embedTitle": "Inbäddning",
        "help.embedBody": "Inkludera chatbot-widget.js via en script-tagg. Anropa ChatbotWidget.mount med ett målelement eller inkludera scriptet för att skapa en flytande bubbla. Iframe på /chatbot-embed.html använder samma bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Justera temavärden för accentfärg, bakgrund, text och hörnradie. Position kan vara nere till vänster eller höger.",
        "widget.welcomeMessage": "Hej! Jag är {brandName}. Starta en ny chatt för att utforska hjälp eller fortsätta.",
        "widget.homeHeroTitle": "Chatta med {brandName}",
        "widget.homeHeroSubtitle": "Få snabba svar, se din historik eller bläddra i hjälp utan att lämna sidan.",
        "widget.auth.startTrialActivate": "Starta din kostnadsfria provperiod för att aktivera denna chatbot.",
        "widget.auth.unauthorized": "Obehörig.",
        "widget.auth.unableAuth": "Kunde inte autentisera chatbot.",
        "widget.auth.notWorking": "Denna chatbot fungerar inte just nu. Försök igen senare.",
        "widget.auth.startTrialEnable": "Starta din kostnadsfria provperiod för att aktivera samtal och flöden.",
        "widget.auth.activateTitle": "Aktivera denna chatbot",
        "widget.auth.goToDashboard": "Gå till instrumentpanelen",
        "widget.openChatbot": "Öppna chatbot",
        "widget.conversation.defaultName": "Konversation {id}",
        "widget.conversation.defaultShort": "Konversation",
        "widget.conversation.new": "Ny konversation",
        "widget.conversation.pending": "Startar konversation...",
        "widget.conversation.openHistory": "Öppna för att se konversationshistorik.",
        "widget.handoff.joined": "En mänsklig agent har anslutit. Du kan nu skicka och ta emot meddelanden i realtid.",
        "widget.errors.noResponse": "Jag kunde inte skapa ett svar. Försök igen.",
        "widget.errors.moreContext": "Jag behöver mer kontext innan bokning. Försök igen.",
        "widget.errors.meetingBooked": "Ditt möte är bokat. Du får en kalenderinbjudan snart.",
        "widget.errors.bookingConfirmFailed": "Tyvärr kunde jag inte bekräfta tiden. Välj en annan.",
        "widget.errors.connectFailed": "Tyvärr kunde jag inte ansluta till assistenten. Försök igen om en stund.",
        "widget.time.justNow": "Just nu",
    },
    no: {
        "chat.activityProductsFor": "Leter etter {goal}…",
        "chat.activityThinking": "Forbereder svaret ditt…",
        "chat.activityProductDetails": "Sjekker produktdetaljer…",
        "chat.activityProductReview": "Vurderer produkter…",
        "chat.activitySending": "Sender opplysningene dine…",
        "chat.activityHandoff": "Ber om menneskelig hjelp…",
        "chat.activitySupport": "Leser støtteinstruksjoner…",
        "chat.activityKnowledge": "Søker etter bedriftsinformasjon…",
        "chat.activityProducts": "Søker etter produkter…",
        "chat.activityAvailability": "Sjekker tilgjengelighet…",
        "chat.activityBooking": "Oppretter bestilling…",
        "chat.activitySaving": "Lagrer informasjon…",
        "tab.home": "Hjem",
        "tab.history": "Historikk",
        "tab.help": "Hjelp",
        "home.welcome": "Velkommen",
        "home.startFlowChatWith": "Start flyt-chat med {brandName}",
        "home.latestConversation": "Siste samtale",
        "chat.placeholder": "Spør om hva som helst...",
        "chat.send": "Send melding",
        "chat.retryHint": "Prøv igjen sender forrige melding på nytt.",
        "chat.retry": "Prøv igjen",
        "chat.noAvailableTimes": "Ingen ledige tider akkurat nå.",
        "chat.slots": "{count} tider",
        "chat.bookedFor": "Booket for {start} - {end}",
        "chat.unableToConfirm": "Kan ikke bekrefte denne tiden. Prøv en annen.",
        "chat.timezone": "Tidssone: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Booker...",
        "chat.booked": "Booket",
        "chat.confirmBooking": "Bekreft booking",
        "chat.you": "Du",
        "chat.support": "Support",
        "history.rename": "Gi nytt navn",
        "history.delete": "Slett",
        "history.deleteTitle": "Slett samtale?",
        "history.deleteBody": "Dette fjerner samtalen fra historikken. Det kan ikke angres.",
        "history.cancel": "Avbryt",
        "history.confirmDelete": "Slett",
        "consent.title": "Personvernmelding",
        "consent.body": "Før du chatter med {brandName}, godkjenn vår personvernerklæring.",
        "consent.cta": "Jeg godtar og vil chatte",
        "header.back": "Tilbake",
        "header.flowReasoning": "Flyt-resonnement",
        "header.minimize": "Minimer chatbot",
        "closedFlows.dismiss": "Avvis flytforslag",
        "flowDebug.title": "Flyt-resonnement",
        "flowDebug.noActiveFlow": "Ingen aktiv flyt",
        "flowDebug.notUpdated": "Ikke oppdatert ennå",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Samtale-ID",
        "flowDebug.flowRunId": "Flyt-kjørings-ID",
        "flowDebug.selectedFlowId": "Valgt flyt-ID",
        "flowDebug.completion": "Fullføring",
        "flowDebug.isComplete": "Er fullført",
        "flowDebug.lastUpdated": "Sist oppdatert",
        "flowDebug.missingFields": "Manglende felt",
        "flowDebug.noMissingFields": "Ingen manglende felt.",
        "flowDebug.validationIssues": "Valideringsproblemer",
        "flowDebug.unknownField": "Ukjent felt",
        "flowDebug.noDetails": "Ingen detaljer oppgitt.",
        "flowDebug.noValidationIssues": "Ingen valideringsproblemer.",
        "flowDebug.routerNotes": "Ruter-notater",
        "flowDebug.noRouterDetails": "Ingen ruter-detaljer ennå.",
        "flowDebug.close": "Lukk flyt-resonnement",
        "flowDebug.yes": "Ja",
        "flowDebug.no": "Nei",
        "help.howTitle": "Slik fungerer det",
        "help.howBody": "Denne widgeten er kun frontend foreløpig. Når den er koblet til, sender den data til {baseUrl}. Konfigurer apiBaseUrl ved montering.",
        "help.embedTitle": "Innebygging",
        "help.embedBody": "Inkluder chatbot-widget.js via en script-tag. Kall ChatbotWidget.mount med et målelement eller inkluder scriptet for å lage en flytende boble. Iframe på /chatbot-embed.html bruker samme bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Juster temaverdier for aksentfarge, bakgrunn, tekst og hjørneradius. Posisjon kan være nederst til venstre eller høyre.",
        "widget.welcomeMessage": "Hei! Jeg er {brandName}. Start en ny chat for å utforske hjelp eller fortsette.",
        "widget.homeHeroTitle": "Chat med {brandName}",
        "widget.homeHeroSubtitle": "Få raske svar, se historikken din eller bla i hjelpen uten å forlate siden.",
        "widget.auth.startTrialActivate": "Start gratis prøveperiode for å aktivere denne chatboten.",
        "widget.auth.unauthorized": "Ikke autorisert.",
        "widget.auth.unableAuth": "Kunne ikke autentisere chatbot.",
        "widget.auth.notWorking": "Denne chatboten fungerer ikke akkurat nå. Prøv igjen senere.",
        "widget.auth.startTrialEnable": "Start gratis prøveperiode for å aktivere samtaler og flyter.",
        "widget.auth.activateTitle": "Aktiver denne chatboten",
        "widget.auth.goToDashboard": "Gå til dashbord",
        "widget.openChatbot": "Åpne chatbot",
        "widget.conversation.defaultName": "Samtale {id}",
        "widget.conversation.defaultShort": "Samtale",
        "widget.conversation.new": "Ny samtale",
        "widget.conversation.pending": "Starter samtale...",
        "widget.conversation.openHistory": "Åpne for å se samtalehistorikk.",
        "widget.handoff.joined": "En menneskelig agent har blitt med i chatten. Du kan nå sende og motta meldinger i sanntid.",
        "widget.errors.noResponse": "Jeg kunne ikke lage et svar. Prøv igjen.",
        "widget.errors.moreContext": "Jeg trenger mer kontekst før booking. Prøv igjen.",
        "widget.errors.meetingBooked": "Møtet ditt er booket. Du får en kalenderinvitasjon snart.",
        "widget.errors.bookingConfirmFailed": "Beklager, jeg kunne ikke bekrefte tiden. Velg en annen.",
        "widget.errors.connectFailed": "Beklager, jeg hadde problemer med å koble til assistenten. Prøv igjen om litt.",
        "widget.time.justNow": "Akkurat nå",
    },
    da: {
        "chat.activityProductsFor": "Leder efter {goal}…",
        "chat.activityThinking": "Forbereder dit svar…",
        "chat.activityProductDetails": "Kontrollerer produktoplysninger…",
        "chat.activityProductReview": "Vurderer produkter…",
        "chat.activitySending": "Sender dine oplysninger…",
        "chat.activityHandoff": "Anmoder om menneskelig hjælp…",
        "chat.activitySupport": "Læser supportvejledning…",
        "chat.activityKnowledge": "Søger efter virksomhedsoplysninger…",
        "chat.activityProducts": "Søger efter produkter…",
        "chat.activityAvailability": "Kontrollerer tilgængelighed…",
        "chat.activityBooking": "Opretter reservation…",
        "chat.activitySaving": "Gemmer oplysninger…",
        "tab.home": "Hjem",
        "tab.history": "Historik",
        "tab.help": "Hjælp",
        "home.welcome": "Velkommen",
        "home.startFlowChatWith": "Start flow-chat med {brandName}",
        "home.latestConversation": "Seneste samtale",
        "chat.placeholder": "Spørg om hvad som helst...",
        "chat.send": "Send besked",
        "chat.retryHint": "Prøv igen sender din sidste besked igen.",
        "chat.retry": "Prøv igen",
        "chat.noAvailableTimes": "Ingen ledige tider lige nu.",
        "chat.slots": "{count} tider",
        "chat.bookedFor": "Booket til {start} - {end}",
        "chat.unableToConfirm": "Kan ikke bekræfte denne tid. Prøv en anden.",
        "chat.timezone": "Tidszone: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Booker...",
        "chat.booked": "Booket",
        "chat.confirmBooking": "Bekræft booking",
        "chat.you": "Du",
        "chat.support": "Support",
        "history.rename": "Omdøb",
        "history.delete": "Slet",
        "history.deleteTitle": "Slet samtale?",
        "history.deleteBody": "Dette fjerner samtalen fra din historik. Det kan ikke fortrydes.",
        "history.cancel": "Annuller",
        "history.confirmDelete": "Slet",
        "consent.title": "Privatlivsmeddelelse",
        "consent.body": "Før du chatter med {brandName}, skal du godkende vores privatlivspolitik.",
        "consent.cta": "Jeg accepterer og vil chatte",
        "header.back": "Tilbage",
        "header.flowReasoning": "Flow-begrundelse",
        "header.minimize": "Minimer chatbot",
        "closedFlows.dismiss": "Afvis flow-forslag",
        "flowDebug.title": "Flow-begrundelse",
        "flowDebug.noActiveFlow": "Ingen aktiv flow",
        "flowDebug.notUpdated": "Ikke opdateret endnu",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "Samtale-ID",
        "flowDebug.flowRunId": "Flow-run-ID",
        "flowDebug.selectedFlowId": "Valgt flow-ID",
        "flowDebug.completion": "Fuldførelse",
        "flowDebug.isComplete": "Er fuldført",
        "flowDebug.lastUpdated": "Sidst opdateret",
        "flowDebug.missingFields": "Manglende felter",
        "flowDebug.noMissingFields": "Ingen manglende felter.",
        "flowDebug.validationIssues": "Valideringsproblemer",
        "flowDebug.unknownField": "Ukendt felt",
        "flowDebug.noDetails": "Ingen detaljer angivet.",
        "flowDebug.noValidationIssues": "Ingen valideringsproblemer.",
        "flowDebug.routerNotes": "Router-noter",
        "flowDebug.noRouterDetails": "Ingen router-detaljer endnu.",
        "flowDebug.close": "Luk flow-begrundelse",
        "flowDebug.yes": "Ja",
        "flowDebug.no": "Nej",
        "help.howTitle": "Sådan fungerer det",
        "help.howBody": "Denne widget er kun frontend lige nu. Når den er forbundet, sender den data til {baseUrl}. Konfigurer apiBaseUrl ved montering.",
        "help.embedTitle": "Indlejring",
        "help.embedBody": "Inkludér chatbot-widget.js via en script-tag. Kald ChatbotWidget.mount med et målelement eller inkludér scriptet for en flydende boble. Iframe på /chatbot-embed.html bruger samme bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Juster temaværdier for accentfarve, baggrund, tekst og hjørneradius. Position kan være nederst til venstre eller højre.",
        "widget.welcomeMessage": "Hej! Jeg er {brandName}. Start en ny chat for at få hjælp eller fortsætte.",
        "widget.homeHeroTitle": "Chat med {brandName}",
        "widget.homeHeroSubtitle": "Få hurtige svar, se din historik eller browse hjælpen uden at forlade siden.",
        "widget.auth.startTrialActivate": "Start din gratis prøveperiode for at aktivere denne chatbot.",
        "widget.auth.unauthorized": "Ikke autoriseret.",
        "widget.auth.unableAuth": "Kunne ikke godkende chatbot.",
        "widget.auth.notWorking": "Denne chatbot virker ikke lige nu. Prøv igen senere.",
        "widget.auth.startTrialEnable": "Start din gratis prøveperiode for at aktivere samtaler og flows.",
        "widget.auth.activateTitle": "Aktiver denne chatbot",
        "widget.auth.goToDashboard": "Gå til dashboard",
        "widget.openChatbot": "Åbn chatbot",
        "widget.conversation.defaultName": "Samtale {id}",
        "widget.conversation.defaultShort": "Samtale",
        "widget.conversation.new": "Ny samtale",
        "widget.conversation.pending": "Starter samtale...",
        "widget.conversation.openHistory": "Åbn for at se samtalehistorik.",
        "widget.handoff.joined": "En menneskelig agent har tilsluttet sig chatten. Du kan nu sende og modtage beskeder i realtid.",
        "widget.errors.noResponse": "Jeg kunne ikke generere et svar. Prøv igen.",
        "widget.errors.moreContext": "Jeg har brug for mere kontekst før booking. Prøv igen.",
        "widget.errors.meetingBooked": "Dit møde er booket. Du modtager snart en kalenderinvitation.",
        "widget.errors.bookingConfirmFailed": "Beklager, jeg kunne ikke bekræfte den tid. Vælg en anden.",
        "widget.errors.connectFailed": "Beklager, jeg havde problemer med at forbinde til assistenten. Prøv igen om lidt.",
        "widget.time.justNow": "Lige nu",
    },
    fi: {
        "chat.activityProductsFor": "Etsin {goal}…",
        "chat.activityThinking": "Valmistelen vastaustasi…",
        "chat.activityProductDetails": "Tarkistan tuotetietoja…",
        "chat.activityProductReview": "Arvioin tuotteita…",
        "chat.activitySending": "Lähetän tietojasi…",
        "chat.activityHandoff": "Pyydän apua ihmiseltä…",
        "chat.activitySupport": "Luen tukiohjeita…",
        "chat.activityKnowledge": "Etsitään yritystietoja…",
        "chat.activityProducts": "Etsitään tuotteita…",
        "chat.activityAvailability": "Tarkistetaan saatavuutta…",
        "chat.activityBooking": "Luodaan varausta…",
        "chat.activitySaving": "Tallennetaan tietoja…",
        "tab.home": "Koti",
        "tab.history": "Historia",
        "tab.help": "Ohje",
        "home.welcome": "Tervetuloa",
        "home.startFlowChatWith": "Aloita flow-keskustelu {brandName}",
        "home.latestConversation": "Viimeisin keskustelu",
        "chat.placeholder": "Kysy mitä tahansa...",
        "chat.send": "Lähetä viesti",
        "chat.retryHint": "Yritä uudelleen lähettää viimeisimmän viestin.",
        "chat.retry": "Yritä uudelleen",
        "chat.noAvailableTimes": "Ei vapaita aikoja juuri nyt.",
        "chat.slots": "{count} aikaa",
        "chat.bookedFor": "Varattu {start} - {end}",
        "chat.unableToConfirm": "Tätä aikaa ei voitu vahvistaa. Valitse toinen.",
        "chat.timezone": "Aikavyöhyke: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Varataan...",
        "chat.booked": "Varattu",
        "chat.confirmBooking": "Vahvista varaus",
        "chat.you": "Sinä",
        "chat.support": "Tuki",
        "history.rename": "Nimeä uudelleen",
        "history.delete": "Poista",
        "history.deleteTitle": "Poistetaanko keskustelu?",
        "history.deleteBody": "Tämä poistaa keskustelun historiastasi. Tätä ei voi kumota.",
        "history.cancel": "Peruuta",
        "history.confirmDelete": "Poista",
        "consent.title": "Tietosuojailmoitus",
        "consent.body": "Ennen kuin keskustelet {brandName} kanssa, hyväksy tietosuojakäytäntömme.",
        "consent.cta": "Hyväksyn ja haluan keskustella",
        "header.back": "Takaisin",
        "header.flowReasoning": "Flow-perustelu",
        "header.minimize": "Pienennä chatbot",
        "closedFlows.dismiss": "Hylkää flow-ehdotukset",
        "flowDebug.title": "Flow-perustelu",
        "flowDebug.noActiveFlow": "Ei aktiivista flow'ta",
        "flowDebug.notUpdated": "Ei vielä päivitetty",
        "flowDebug.status": "Tila",
        "flowDebug.conversationId": "Keskustelu-ID",
        "flowDebug.flowRunId": "Flow-ajon ID",
        "flowDebug.selectedFlowId": "Valittu flow-ID",
        "flowDebug.completion": "Valmius",
        "flowDebug.isComplete": "On valmis",
        "flowDebug.lastUpdated": "Viimeksi päivitetty",
        "flowDebug.missingFields": "Puuttuvat kentät",
        "flowDebug.noMissingFields": "Ei puuttuvia kenttiä.",
        "flowDebug.validationIssues": "Validointiongelmat",
        "flowDebug.unknownField": "Tuntematon kenttä",
        "flowDebug.noDetails": "Ei lisätietoja.",
        "flowDebug.noValidationIssues": "Ei validointiongelmia.",
        "flowDebug.routerNotes": "Reitittimen muistiinpanot",
        "flowDebug.noRouterDetails": "Reitittimen tietoja ei vielä.",
        "flowDebug.close": "Sulje flow-perustelu",
        "flowDebug.yes": "Kyllä",
        "flowDebug.no": "Ei",
        "help.howTitle": "Miten se toimii",
        "help.howBody": "Tämä widget on toistaiseksi vain frontend. Yhdistettynä se lähettää tiedot {baseUrl}. Määritä apiBaseUrl asennuksessa.",
        "help.embedTitle": "Upotus",
        "help.embedBody": "Sisällytä chatbot-widget.js script-tagilla. Kutsu ChatbotWidget.mount kohde-elementillä tai sisällytä skripti kelluvaa kuplaa varten. Iframe /chatbot-embed.html käyttää samaa bundlea.",
        "help.themeTitle": "Teema",
        "help.themeBody": "Säädä teeman värejä, taustaa, tekstiä ja kulmasädettä. Sijainti voi olla alavasen tai alaoikea.",
        "widget.welcomeMessage": "Hei! Olen {brandName}. Aloita uusi keskustelu tutkiaksesi apua tai jatkaaksesi.",
        "widget.homeHeroTitle": "Keskustele {brandName}",
        "widget.homeHeroSubtitle": "Saat nopeasti vastauksia, näet historiasi tai selaat apua poistumatta sivulta.",
        "widget.auth.startTrialActivate": "Aloita ilmainen kokeilu aktivoidaksesi tämän chatbotin.",
        "widget.auth.unauthorized": "Ei valtuutettu.",
        "widget.auth.unableAuth": "Chatbotia ei voitu todentaa.",
        "widget.auth.notWorking": "Tämä chatbot ei toimi nyt. Yritä myöhemmin uudelleen.",
        "widget.auth.startTrialEnable": "Aloita ilmainen kokeilu aktivoidaksesi keskustelut ja flow't.",
        "widget.auth.activateTitle": "Aktivoi tämä chatbot",
        "widget.auth.goToDashboard": "Siirry hallintapaneeliin",
        "widget.openChatbot": "Avaa chatbot",
        "widget.conversation.defaultName": "Keskustelu {id}",
        "widget.conversation.defaultShort": "Keskustelu",
        "widget.conversation.new": "Uusi keskustelu",
        "widget.conversation.pending": "Aloitetaan keskustelua...",
        "widget.conversation.openHistory": "Avaa nähdäksesi keskusteluhistorian.",
        "widget.handoff.joined": "Ihmisagentti liittyi keskusteluun. Voit nyt lähettää ja vastaanottaa viestejä reaaliajassa.",
        "widget.errors.noResponse": "En pystynyt luomaan vastausta. Yritä uudelleen.",
        "widget.errors.moreContext": "Tarvitsen enemmän kontekstia ennen varausta. Yritä uudelleen.",
        "widget.errors.meetingBooked": "Tapaamisesi on varattu. Saat pian kalenterikutsun.",
        "widget.errors.bookingConfirmFailed": "Pahoittelut, en voinut vahvistaa aikaa. Valitse toinen.",
        "widget.errors.connectFailed": "Pahoittelut, yhteys avustajaan epäonnistui. Yritä hetken kuluttua.",
        "widget.time.justNow": "Juuri nyt",
    },
    pl: {
        "chat.activityProductsFor": "Szukam: {goal}…",
        "chat.activityThinking": "Przygotowuję odpowiedź…",
        "chat.activityProductDetails": "Sprawdzam szczegóły produktu…",
        "chat.activityProductReview": "Oceniam produkty…",
        "chat.activitySending": "Wysyłam Twoje informacje…",
        "chat.activityHandoff": "Proszę o pomoc człowieka…",
        "chat.activitySupport": "Czytam instrukcje pomocy…",
        "chat.activityKnowledge": "Wyszukiwanie informacji o firmie…",
        "chat.activityProducts": "Wyszukiwanie produktów…",
        "chat.activityAvailability": "Sprawdzanie dostępności…",
        "chat.activityBooking": "Tworzenie rezerwacji…",
        "chat.activitySaving": "Zapisywanie informacji…",
        "tab.home": "Start",
        "tab.history": "Historia",
        "tab.help": "Pomoc",
        "home.welcome": "Witamy",
        "home.startFlowChatWith": "Rozpocznij czat przepływu z {brandName}",
        "home.latestConversation": "Ostatnia rozmowa",
        "chat.placeholder": "Zapytaj o cokolwiek...",
        "chat.send": "Wyślij wiadomość",
        "chat.retryHint": "Ponów spowoduje wysłanie ostatniej wiadomości.",
        "chat.retry": "Ponów",
        "chat.noAvailableTimes": "Brak dostępnych terminów.",
        "chat.slots": "{count} terminów",
        "chat.bookedFor": "Zarezerwowano na {start} - {end}",
        "chat.unableToConfirm": "Nie można potwierdzić tego terminu. Wybierz inny.",
        "chat.timezone": "Strefa czasowa: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezerwacja...",
        "chat.booked": "Zarezerwowano",
        "chat.confirmBooking": "Potwierdź rezerwację",
        "chat.you": "Ty",
        "chat.support": "Wsparcie",
        "history.rename": "Zmień nazwę",
        "history.delete": "Usuń",
        "history.deleteTitle": "Usunąć rozmowę?",
        "history.deleteBody": "To usunie rozmowę z historii. Nie można cofnąć.",
        "history.cancel": "Anuluj",
        "history.confirmDelete": "Usuń",
        "consent.title": "Informacja o prywatności",
        "consent.body": "Przed rozpoczęciem rozmowy z {brandName} zaakceptuj naszą politykę prywatności.",
        "consent.cta": "Zgadzam się i chcę rozmawiać",
        "header.back": "Wstecz",
        "header.flowReasoning": "Uzasadnienie przepływu",
        "header.minimize": "Zminimalizuj chatbot",
        "closedFlows.dismiss": "Odrzuć sugestie przepływu",
        "flowDebug.title": "Uzasadnienie przepływu",
        "flowDebug.noActiveFlow": "Brak aktywnego przepływu",
        "flowDebug.notUpdated": "Jeszcze nie zaktualizowano",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID rozmowy",
        "flowDebug.flowRunId": "ID uruchomienia przepływu",
        "flowDebug.selectedFlowId": "Wybrane ID przepływu",
        "flowDebug.completion": "Ukończenie",
        "flowDebug.isComplete": "Jest ukończone",
        "flowDebug.lastUpdated": "Ostatnia aktualizacja",
        "flowDebug.missingFields": "Brakujące pola",
        "flowDebug.noMissingFields": "Brak brakujących pól.",
        "flowDebug.validationIssues": "Problemy walidacji",
        "flowDebug.unknownField": "Nieznane pole",
        "flowDebug.noDetails": "Brak szczegółów.",
        "flowDebug.noValidationIssues": "Brak problemów z walidacją.",
        "flowDebug.routerNotes": "Notatki routera",
        "flowDebug.noRouterDetails": "Brak szczegółów routera.",
        "flowDebug.close": "Zamknij uzasadnienie przepływu",
        "flowDebug.yes": "Tak",
        "flowDebug.no": "Nie",
        "help.howTitle": "Jak to działa",
        "help.howBody": "Ten widget jest na razie tylko frontendowy. Po połączeniu wyśle dane do {baseUrl}. Skonfiguruj apiBaseUrl przy montowaniu.",
        "help.embedTitle": "Osadzanie",
        "help.embedBody": "Dołącz chatbot-widget.js przez tag script. Wywołaj ChatbotWidget.mount z elementem docelowym lub dodaj skrypt, by utworzyć pływającą bańkę. Iframe /chatbot-embed.html korzysta z tego samego bundla.",
        "help.themeTitle": "Motyw",
        "help.themeBody": "Dostosuj wartości motywu dla koloru akcentu, tła, tekstu i promienia rogów. Pozycja może być lewy-dół lub prawy-dół.",
        "widget.welcomeMessage": "Cześć! Jestem {brandName}. Zacznij nową rozmowę, aby uzyskać pomoc lub kontynuować.",
        "widget.homeHeroTitle": "Czatuj z {brandName}",
        "widget.homeHeroSubtitle": "Szybkie odpowiedzi, historia i pomoc bez opuszczania strony.",
        "widget.auth.startTrialActivate": "Rozpocznij darmowy okres próbny, aby aktywować tego chatbota.",
        "widget.auth.unauthorized": "Brak autoryzacji.",
        "widget.auth.unableAuth": "Nie udało się uwierzytelnić chatbota.",
        "widget.auth.notWorking": "Ten chatbot obecnie nie działa. Spróbuj później.",
        "widget.auth.startTrialEnable": "Rozpocznij darmowy okres próbny, aby włączyć rozmowy i przepływy.",
        "widget.auth.activateTitle": "Aktywuj tego chatbota",
        "widget.auth.goToDashboard": "Przejdź do panelu",
        "widget.openChatbot": "Otwórz chatbota",
        "widget.conversation.defaultName": "Rozmowa {id}",
        "widget.conversation.defaultShort": "Rozmowa",
        "widget.conversation.new": "Nowa rozmowa",
        "widget.conversation.pending": "Rozpoczynanie rozmowy...",
        "widget.conversation.openHistory": "Otwórz, aby zobaczyć historię rozmów.",
        "widget.handoff.joined": "Do czatu dołączył agent. Możesz teraz wysyłać i odbierać wiadomości w czasie rzeczywistym.",
        "widget.errors.noResponse": "Nie udało się wygenerować odpowiedzi. Spróbuj ponownie.",
        "widget.errors.moreContext": "Potrzebuję więcej kontekstu przed rezerwacją. Spróbuj ponownie.",
        "widget.errors.meetingBooked": "Twoje spotkanie zostało zarezerwowane. Wkrótce otrzymasz zaproszenie do kalendarza.",
        "widget.errors.bookingConfirmFailed": "Przepraszam, nie udało się potwierdzić terminu. Wybierz inny.",
        "widget.errors.connectFailed": "Przepraszam, problem z połączeniem z asystentem. Spróbuj za chwilę.",
        "widget.time.justNow": "Przed chwilą",
    },
    cs: {
        "chat.activityProductsFor": "Hledám: {goal}…",
        "chat.activityThinking": "Připravuji odpověď…",
        "chat.activityProductDetails": "Ověřuji podrobnosti produktu…",
        "chat.activityProductReview": "Posuzuji produkty…",
        "chat.activitySending": "Odesílám vaše údaje…",
        "chat.activityHandoff": "Žádám o pomoc člověka…",
        "chat.activitySupport": "Čtu pokyny podpory…",
        "chat.activityKnowledge": "Hledání informací o firmě…",
        "chat.activityProducts": "Hledání produktů…",
        "chat.activityAvailability": "Kontrola dostupnosti…",
        "chat.activityBooking": "Vytváření rezervace…",
        "chat.activitySaving": "Ukládání informací…",
        "tab.home": "Domů",
        "tab.history": "Historie",
        "tab.help": "Nápověda",
        "home.welcome": "Vítejte",
        "home.startFlowChatWith": "Spustit flow chat s {brandName}",
        "home.latestConversation": "Poslední konverzace",
        "chat.placeholder": "Zeptejte se na cokoli...",
        "chat.send": "Odeslat zprávu",
        "chat.retryHint": "Opakování odešle poslední zprávu znovu.",
        "chat.retry": "Zkusit znovu",
        "chat.noAvailableTimes": "Momentálně nejsou dostupné termíny.",
        "chat.slots": "{count} termínů",
        "chat.bookedFor": "Rezervováno na {start} - {end}",
        "chat.unableToConfirm": "Nelze potvrdit tento termín. Zkuste jiný.",
        "chat.timezone": "Časové pásmo: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezervuji...",
        "chat.booked": "Rezervováno",
        "chat.confirmBooking": "Potvrdit rezervaci",
        "chat.you": "Vy",
        "chat.support": "Podpora",
        "history.rename": "Přejmenovat",
        "history.delete": "Smazat",
        "history.deleteTitle": "Smazat konverzaci?",
        "history.deleteBody": "Tímto odstraníte konverzaci z historie. Akci nelze vrátit.",
        "history.cancel": "Zrušit",
        "history.confirmDelete": "Smazat",
        "consent.title": "Oznámení o ochraně soukromí",
        "consent.body": "Než budete chatovat s {brandName}, schvalte naše zásady ochrany soukromí.",
        "consent.cta": "Souhlasím a chci chatovat",
        "header.back": "Zpět",
        "header.flowReasoning": "Odůvodnění flow",
        "header.minimize": "Minimalizovat chatbota",
        "closedFlows.dismiss": "Skrýt návrhy flow",
        "flowDebug.title": "Odůvodnění flow",
        "flowDebug.noActiveFlow": "Žádný aktivní flow",
        "flowDebug.notUpdated": "Ještě neaktualizováno",
        "flowDebug.status": "Stav",
        "flowDebug.conversationId": "ID konverzace",
        "flowDebug.flowRunId": "ID běhu flow",
        "flowDebug.selectedFlowId": "Vybrané ID flow",
        "flowDebug.completion": "Dokončení",
        "flowDebug.isComplete": "Je dokončeno",
        "flowDebug.lastUpdated": "Naposledy aktualizováno",
        "flowDebug.missingFields": "Chybějící pole",
        "flowDebug.noMissingFields": "Žádná chybějící pole.",
        "flowDebug.validationIssues": "Problémy s validací",
        "flowDebug.unknownField": "Neznámé pole",
        "flowDebug.noDetails": "Bez podrobností.",
        "flowDebug.noValidationIssues": "Žádné problémy s validací.",
        "flowDebug.routerNotes": "Poznámky routeru",
        "flowDebug.noRouterDetails": "Zatím žádné podrobnosti routeru.",
        "flowDebug.close": "Zavřít odůvodnění flow",
        "flowDebug.yes": "Ano",
        "flowDebug.no": "Ne",
        "help.howTitle": "Jak to funguje",
        "help.howBody": "Tento widget je zatím pouze frontend. Po připojení odešle data na {baseUrl}. Při mountu nastavte apiBaseUrl.",
        "help.embedTitle": "Vložení",
        "help.embedBody": "Vložte chatbot-widget.js pomocí script tagu. Zavolejte ChatbotWidget.mount s cílovým elementem nebo přidejte skript pro plovoucí bublinu. Iframe na /chatbot-embed.html používá stejný bundle.",
        "help.themeTitle": "Motiv",
        "help.themeBody": "Upravte hodnoty motivu pro zvýraznění, pozadí, text a zaoblení rohů. Pozice může být vlevo dole nebo vpravo dole.",
        "widget.welcomeMessage": "Ahoj! Jsem {brandName}. Začněte nový chat a pokračujte nebo prozkoumejte nápovědu.",
        "widget.homeHeroTitle": "Chat s {brandName}",
        "widget.homeHeroSubtitle": "Rychlé odpovědi, historie a nápověda bez opuštění stránky.",
        "widget.auth.startTrialActivate": "Začněte bezplatnou zkušební dobu a aktivujte chatbota.",
        "widget.auth.unauthorized": "Neautorizováno.",
        "widget.auth.unableAuth": "Nepodařilo se ověřit chatbota.",
        "widget.auth.notWorking": "Chatbot nyní nefunguje. Zkuste později.",
        "widget.auth.startTrialEnable": "Začněte bezplatnou zkušební dobu pro aktivaci konverzací a flow.",
        "widget.auth.activateTitle": "Aktivovat chatbota",
        "widget.auth.goToDashboard": "Přejít na dashboard",
        "widget.openChatbot": "Otevřít chatbota",
        "widget.conversation.defaultName": "Konverzace {id}",
        "widget.conversation.defaultShort": "Konverzace",
        "widget.conversation.new": "Nová konverzace",
        "widget.conversation.pending": "Spouštím konverzaci...",
        "widget.conversation.openHistory": "Otevřete pro zobrazení historie konverzací.",
        "widget.handoff.joined": "Lidský agent se připojil. Nyní můžete posílat a přijímat zprávy v reálném čase.",
        "widget.errors.noResponse": "Nepodařilo se vygenerovat odpověď. Zkuste to znovu.",
        "widget.errors.moreContext": "Před rezervací potřebuji více kontextu. Zkuste to znovu.",
        "widget.errors.meetingBooked": "Vaše schůzka je rezervována. Brzy obdržíte pozvánku do kalendáře.",
        "widget.errors.bookingConfirmFailed": "Omlouvám se, nepodařilo se potvrdit termín. Vyberte jiný.",
        "widget.errors.connectFailed": "Omlouvám se, problém s připojením k asistentovi. Zkuste to za chvíli.",
        "widget.time.justNow": "Právě teď",
    },
    sk: {
        "chat.activityProductsFor": "Hľadám: {goal}…",
        "chat.activityThinking": "Pripravujem odpoveď…",
        "chat.activityProductDetails": "Overujem podrobnosti produktu…",
        "chat.activityProductReview": "Posudzujem produkty…",
        "chat.activitySending": "Odosielam vaše údaje…",
        "chat.activityHandoff": "Žiadam o pomoc človeka…",
        "chat.activitySupport": "Čítam pokyny podpory…",
        "chat.activityKnowledge": "Hľadanie informácií o firme…",
        "chat.activityProducts": "Hľadanie produktov…",
        "chat.activityAvailability": "Kontrola dostupnosti…",
        "chat.activityBooking": "Vytváranie rezervácie…",
        "chat.activitySaving": "Ukladanie informácií…",
        "tab.home": "Domov",
        "tab.history": "História",
        "tab.help": "Pomoc",
        "home.welcome": "Vitajte",
        "home.startFlowChatWith": "Spustiť flow chat s {brandName}",
        "home.latestConversation": "Posledný rozhovor",
        "chat.placeholder": "Opýtajte sa čokoľvek...",
        "chat.send": "Odoslať správu",
        "chat.retryHint": "Skúsiť znova odošle poslednú správu.",
        "chat.retry": "Skúsiť znova",
        "chat.noAvailableTimes": "Momentálne nie sú dostupné termíny.",
        "chat.slots": "{count} termínov",
        "chat.bookedFor": "Rezervované na {start} - {end}",
        "chat.unableToConfirm": "Nie je možné potvrdiť tento termín. Skúste iný.",
        "chat.timezone": "Časové pásmo: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezervujem...",
        "chat.booked": "Rezervované",
        "chat.confirmBooking": "Potvrdiť rezerváciu",
        "chat.you": "Vy",
        "chat.support": "Podpora",
        "history.rename": "Premenovať",
        "history.delete": "Vymazať",
        "history.deleteTitle": "Vymazať rozhovor?",
        "history.deleteBody": "Týmto odstránite rozhovor z histórie. Akciu nemožno vrátiť.",
        "history.cancel": "Zrušiť",
        "history.confirmDelete": "Vymazať",
        "consent.title": "Oznámenie o súkromí",
        "consent.body": "Pred chatovaním s {brandName} schváľte naše zásady ochrany súkromia.",
        "consent.cta": "Súhlasím a chcem chatovať",
        "header.back": "Späť",
        "header.flowReasoning": "Odôvodnenie flow",
        "header.minimize": "Minimalizovať chatbota",
        "closedFlows.dismiss": "Skryť návrhy flow",
        "flowDebug.title": "Odôvodnenie flow",
        "flowDebug.noActiveFlow": "Žiadny aktívny flow",
        "flowDebug.notUpdated": "Ešte neaktualizované",
        "flowDebug.status": "Stav",
        "flowDebug.conversationId": "ID rozhovoru",
        "flowDebug.flowRunId": "ID behu flow",
        "flowDebug.selectedFlowId": "Vybrané ID flow",
        "flowDebug.completion": "Dokončenie",
        "flowDebug.isComplete": "Je dokončené",
        "flowDebug.lastUpdated": "Naposledy aktualizované",
        "flowDebug.missingFields": "Chýbajúce polia",
        "flowDebug.noMissingFields": "Žiadne chýbajúce polia.",
        "flowDebug.validationIssues": "Problémy s validáciou",
        "flowDebug.unknownField": "Neznáme pole",
        "flowDebug.noDetails": "Bez podrobností.",
        "flowDebug.noValidationIssues": "Žiadne problémy s validáciou.",
        "flowDebug.routerNotes": "Poznámky routera",
        "flowDebug.noRouterDetails": "Zatiaľ žiadne podrobnosti routera.",
        "flowDebug.close": "Zavrieť odôvodnenie flow",
        "flowDebug.yes": "Áno",
        "flowDebug.no": "Nie",
        "help.howTitle": "Ako to funguje",
        "help.howBody": "Tento widget je zatiaľ len frontend. Po pripojení pošle dáta na {baseUrl}. Pri mountnutí nastavte apiBaseUrl.",
        "help.embedTitle": "Vloženie",
        "help.embedBody": "Vložte chatbot-widget.js pomocou script tagu. Zavolajte ChatbotWidget.mount s cieľovým elementom alebo pridajte skript pre plávajúcu bublinu. Iframe na /chatbot-embed.html používa rovnaký bundle.",
        "help.themeTitle": "Téma",
        "help.themeBody": "Upravte hodnoty témy pre zvýraznenie, pozadie, text a zaoblenie rohov. Pozícia môže byť vľavo dole alebo vpravo dole.",
        "widget.welcomeMessage": "Ahoj! Som {brandName}. Spustite nový chat pre pomoc alebo pokračovanie.",
        "widget.homeHeroTitle": "Chat s {brandName}",
        "widget.homeHeroSubtitle": "Rýchle odpovede, história a pomoc bez opustenia stránky.",
        "widget.auth.startTrialActivate": "Začnite bezplatnú skúšobnú dobu na aktiváciu chatbota.",
        "widget.auth.unauthorized": "Neautorizované.",
        "widget.auth.unableAuth": "Nepodarilo sa overiť chatbota.",
        "widget.auth.notWorking": "Chatbot momentálne nefunguje. Skúste neskôr.",
        "widget.auth.startTrialEnable": "Začnite bezplatnú skúšobnú dobu na aktiváciu konverzácií a flow.",
        "widget.auth.activateTitle": "Aktivovať chatbota",
        "widget.auth.goToDashboard": "Prejsť na dashboard",
        "widget.openChatbot": "Otvoriť chatbota",
        "widget.conversation.defaultName": "Rozhovor {id}",
        "widget.conversation.defaultShort": "Rozhovor",
        "widget.conversation.new": "Nový rozhovor",
        "widget.conversation.pending": "Spúšťam rozhovor...",
        "widget.conversation.openHistory": "Otvorte pre zobrazenie histórie rozhovorov.",
        "widget.handoff.joined": "Ľudský agent sa pripojil. Teraz môžete posielať a prijímať správy v reálnom čase.",
        "widget.errors.noResponse": "Nepodarilo sa vygenerovať odpoveď. Skúste znova.",
        "widget.errors.moreContext": "Potrebujem viac kontextu pred rezerváciou. Skúste znova.",
        "widget.errors.meetingBooked": "Vaše stretnutie je rezervované. Čoskoro dostanete pozvánku do kalendára.",
        "widget.errors.bookingConfirmFailed": "Prepáčte, nepodarilo sa potvrdiť termín. Vyberte iný.",
        "widget.errors.connectFailed": "Prepáčte, problém s pripojením k asistentovi. Skúste o chvíľu.",
        "widget.time.justNow": "Práve teraz",
    },
    hu: {
        "chat.activityProductsFor": "Keresés: {goal}…",
        "chat.activityThinking": "Előkészítem a választ…",
        "chat.activityProductDetails": "Ellenőrzöm a termék részleteit…",
        "chat.activityProductReview": "Áttekintem a termékeket…",
        "chat.activitySending": "Küldöm az adatait…",
        "chat.activityHandoff": "Emberi segítséget kérek…",
        "chat.activitySupport": "Olvasom a támogatási útmutatót…",
        "chat.activityKnowledge": "Céges információk keresése…",
        "chat.activityProducts": "Termékek keresése…",
        "chat.activityAvailability": "Elérhetőség ellenőrzése…",
        "chat.activityBooking": "Foglalás létrehozása…",
        "chat.activitySaving": "Információk mentése…",
        "tab.home": "Kezdőlap",
        "tab.history": "Előzmények",
        "tab.help": "Súgó",
        "home.welcome": "Üdvözöljük",
        "home.startFlowChatWith": "Flow chat indítása {brandName} névvel",
        "home.latestConversation": "Legutóbbi beszélgetés",
        "chat.placeholder": "Kérdezz bármit...",
        "chat.send": "Üzenet küldése",
        "chat.retryHint": "Az újrapróbálás újraküldi az utolsó üzenetet.",
        "chat.retry": "Újrapróbálás",
        "chat.noAvailableTimes": "Jelenleg nincs elérhető időpont.",
        "chat.slots": "{count} időpont",
        "chat.bookedFor": "Foglalva: {start} - {end}",
        "chat.unableToConfirm": "Nem sikerült megerősíteni ezt az időpontot. Próbálj másikat.",
        "chat.timezone": "Időzóna: {timezone}",
        "chat.durationMinutes": "{minutes} perc",
        "chat.bookingPending": "Foglalás...",
        "chat.booked": "Foglalva",
        "chat.confirmBooking": "Foglalás megerősítése",
        "chat.you": "Te",
        "chat.support": "Támogatás",
        "history.rename": "Átnevezés",
        "history.delete": "Törlés",
        "history.deleteTitle": "Töröljük a beszélgetést?",
        "history.deleteBody": "Ez eltávolítja a beszélgetést az előzményekből. Nem vonható vissza.",
        "history.cancel": "Mégse",
        "history.confirmDelete": "Törlés",
        "consent.title": "Adatvédelmi tájékoztató",
        "consent.body": "Mielőtt {brandName} névvel chatelsz, fogadd el az adatvédelmi irányelveinket.",
        "consent.cta": "Elfogadom és chatelni szeretnék",
        "header.back": "Vissza",
        "header.flowReasoning": "Flow indoklás",
        "header.minimize": "Chatbot minimalizálása",
        "closedFlows.dismiss": "Flow javaslatok elvetése",
        "flowDebug.title": "Flow indoklás",
        "flowDebug.noActiveFlow": "Nincs aktív flow",
        "flowDebug.notUpdated": "Még nincs frissítve",
        "flowDebug.status": "Állapot",
        "flowDebug.conversationId": "Beszélgetés ID",
        "flowDebug.flowRunId": "Flow futás ID",
        "flowDebug.selectedFlowId": "Kiválasztott flow ID",
        "flowDebug.completion": "Teljesítés",
        "flowDebug.isComplete": "Teljes",
        "flowDebug.lastUpdated": "Legutóbb frissítve",
        "flowDebug.missingFields": "Hiányzó mezők",
        "flowDebug.noMissingFields": "Nincsenek hiányzó mezők.",
        "flowDebug.validationIssues": "Érvényesítési hibák",
        "flowDebug.unknownField": "Ismeretlen mező",
        "flowDebug.noDetails": "Nincsenek részletek.",
        "flowDebug.noValidationIssues": "Nincsenek érvényesítési hibák.",
        "flowDebug.routerNotes": "Router megjegyzések",
        "flowDebug.noRouterDetails": "Még nincsenek router részletek.",
        "flowDebug.close": "Flow indoklás bezárása",
        "flowDebug.yes": "Igen",
        "flowDebug.no": "Nem",
        "help.howTitle": "Hogyan működik",
        "help.howBody": "Ez a widget jelenleg csak frontend. Kapcsolat esetén adatot küld a {baseUrl} címre. Állítsd be az apiBaseUrl-t a mountoláskor.",
        "help.embedTitle": "Beágyazás",
        "help.embedBody": "Illeszd be a chatbot-widget.js fájlt script taggel. Hívd a ChatbotWidget.mount-ot cél elemmel, vagy csak illeszd be a scriptet a lebegő buborékhoz. A /chatbot-embed.html iframe ugyanazt a bundle-t használja.",
        "help.themeTitle": "Téma",
        "help.themeBody": "Állítsd be a téma értékeit kiemeléshez, háttérhez, szöveghez és sarokrádiuszhoz. A pozíció lehet bal alsó vagy jobb alsó.",
        "widget.welcomeMessage": "Szia! {brandName} vagyok. Indíts új chatet segítséghez vagy folytatáshoz.",
        "widget.homeHeroTitle": "Chatelj {brandName} névvel",
        "widget.homeHeroSubtitle": "Gyors válaszok, előzmények és segítség az oldal elhagyása nélkül.",
        "widget.auth.startTrialActivate": "Indítsd el az ingyenes próbaidőszakot a chatbot aktiválásához.",
        "widget.auth.unauthorized": "Nincs jogosultság.",
        "widget.auth.unableAuth": "Nem sikerült hitelesíteni a chatbotot.",
        "widget.auth.notWorking": "Ez a chatbot jelenleg nem működik. Próbáld később.",
        "widget.auth.startTrialEnable": "Indítsd el az ingyenes próbaidőszakot beszélgetések és flow-k engedélyezéséhez.",
        "widget.auth.activateTitle": "Chatbot aktiválása",
        "widget.auth.goToDashboard": "Ugrás a vezérlőpultra",
        "widget.openChatbot": "Chatbot megnyitása",
        "widget.conversation.defaultName": "Beszélgetés {id}",
        "widget.conversation.defaultShort": "Beszélgetés",
        "widget.conversation.new": "Új beszélgetés",
        "widget.conversation.pending": "Beszélgetés indítása...",
        "widget.conversation.openHistory": "Nyisd meg az előzmények megtekintéséhez.",
        "widget.handoff.joined": "Egy emberi ügynök csatlakozott a beszélgetéshez. Most valós időben küldhetsz és fogadhatsz üzeneteket.",
        "widget.errors.noResponse": "Nem sikerült választ generálni. Próbáld újra.",
        "widget.errors.moreContext": "Több kontextusra van szükség a foglalás előtt. Próbáld újra.",
        "widget.errors.meetingBooked": "Az időpontod le van foglalva. Hamarosan kapsz naptármeghívót.",
        "widget.errors.bookingConfirmFailed": "Sajnálom, nem tudtam megerősíteni az időpontot. Válassz másikat.",
        "widget.errors.connectFailed": "Sajnálom, nem sikerült csatlakozni az asszisztenshez. Próbáld újra egy kicsit később.",
        "widget.time.justNow": "Épp most",
    },
    ro: {
        "chat.activityProductsFor": "Caut {goal}…",
        "chat.activityThinking": "Pregătesc răspunsul…",
        "chat.activityProductDetails": "Verific detaliile produsului…",
        "chat.activityProductReview": "Analizez produsele…",
        "chat.activitySending": "Trimit informațiile tale…",
        "chat.activityHandoff": "Solicit ajutor uman…",
        "chat.activitySupport": "Consult instrucțiunile de asistență…",
        "chat.activityKnowledge": "Se caută informații despre companie…",
        "chat.activityProducts": "Se caută produse…",
        "chat.activityAvailability": "Se verifică disponibilitatea…",
        "chat.activityBooking": "Se creează rezervarea…",
        "chat.activitySaving": "Se salvează informațiile…",
        "tab.home": "Acasă",
        "tab.history": "Istoric",
        "tab.help": "Ajutor",
        "home.welcome": "Bun venit",
        "home.startFlowChatWith": "Pornește chatul de flux cu {brandName}",
        "home.latestConversation": "Ultima conversație",
        "chat.placeholder": "Întreabă orice...",
        "chat.send": "Trimite mesaj",
        "chat.retryHint": "Reîncearcă va retrimite ultimul mesaj.",
        "chat.retry": "Reîncearcă",
        "chat.noAvailableTimes": "Nu sunt intervale disponibile acum.",
        "chat.slots": "{count} intervale",
        "chat.bookedFor": "Rezervat pentru {start} - {end}",
        "chat.unableToConfirm": "Nu pot confirma acest interval. Încearcă altul.",
        "chat.timezone": "Fus orar: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Se rezervă...",
        "chat.booked": "Rezervat",
        "chat.confirmBooking": "Confirmă rezervarea",
        "chat.you": "Tu",
        "chat.support": "Suport",
        "history.rename": "Redenumește",
        "history.delete": "Șterge",
        "history.deleteTitle": "Șterge conversația?",
        "history.deleteBody": "Aceasta va elimina conversația din istoric. Nu poate fi anulată.",
        "history.cancel": "Anulează",
        "history.confirmDelete": "Șterge",
        "consent.title": "Notificare de confidențialitate",
        "consent.body": "Înainte de a discuta cu {brandName}, acceptă politica noastră de confidențialitate.",
        "consent.cta": "Sunt de acord și vreau să discut",
        "header.back": "Înapoi",
        "header.flowReasoning": "Raționament de flux",
        "header.minimize": "Minimizează chatbotul",
        "closedFlows.dismiss": "Respinge sugestiile de flux",
        "flowDebug.title": "Raționament de flux",
        "flowDebug.noActiveFlow": "Niciun flux activ",
        "flowDebug.notUpdated": "Încă neactualizat",
        "flowDebug.status": "Stare",
        "flowDebug.conversationId": "ID conversație",
        "flowDebug.flowRunId": "ID rulare flux",
        "flowDebug.selectedFlowId": "ID flux selectat",
        "flowDebug.completion": "Finalizare",
        "flowDebug.isComplete": "Este complet",
        "flowDebug.lastUpdated": "Ultima actualizare",
        "flowDebug.missingFields": "Câmpuri lipsă",
        "flowDebug.noMissingFields": "Niciun câmp lipsă.",
        "flowDebug.validationIssues": "Probleme de validare",
        "flowDebug.unknownField": "Câmp necunoscut",
        "flowDebug.noDetails": "Fără detalii.",
        "flowDebug.noValidationIssues": "Fără probleme de validare.",
        "flowDebug.routerNotes": "Note router",
        "flowDebug.noRouterDetails": "Încă nu există detalii despre router.",
        "flowDebug.close": "Închide raționamentul de flux",
        "flowDebug.yes": "Da",
        "flowDebug.no": "Nu",
        "help.howTitle": "Cum funcționează",
        "help.howBody": "Acest widget este doar frontend momentan. Când este conectat, va trimite date către {baseUrl}. Configurează apiBaseUrl la montare.",
        "help.embedTitle": "Înglobare",
        "help.embedBody": "Include chatbot-widget.js cu un tag script. Apelează ChatbotWidget.mount cu un element țintă sau include scriptul pentru o bulă flotantă. Iframe-ul /chatbot-embed.html folosește același bundle.",
        "help.themeTitle": "Temă",
        "help.themeBody": "Ajustează valorile temei pentru culoare accent, fundal, text și raza colțurilor. Poziția poate fi jos-stânga sau jos-dreapta.",
        "widget.welcomeMessage": "Salut! Sunt {brandName}. Începe un chat nou pentru ajutor sau pentru a continua.",
        "widget.homeHeroTitle": "Discută cu {brandName}",
        "widget.homeHeroSubtitle": "Răspunsuri rapide, istoric și ajutor fără a părăsi pagina.",
        "widget.auth.startTrialActivate": "Începe perioada de probă gratuită pentru a activa acest chatbot.",
        "widget.auth.unauthorized": "Neautorizat.",
        "widget.auth.unableAuth": "Nu s-a putut autentifica chatbotul.",
        "widget.auth.notWorking": "Acest chatbot nu funcționează acum. Încearcă mai târziu.",
        "widget.auth.startTrialEnable": "Începe perioada de probă gratuită pentru a activa conversațiile și fluxurile.",
        "widget.auth.activateTitle": "Activează chatbotul",
        "widget.auth.goToDashboard": "Mergi la dashboard",
        "widget.openChatbot": "Deschide chatbotul",
        "widget.conversation.defaultName": "Conversația {id}",
        "widget.conversation.defaultShort": "Conversație",
        "widget.conversation.new": "Conversație nouă",
        "widget.conversation.pending": "Se pornește conversația...",
        "widget.conversation.openHistory": "Deschide pentru a vedea istoricul conversațiilor.",
        "widget.handoff.joined": "Un agent uman s-a alăturat chatului. Poți trimite și primi mesaje în timp real.",
        "widget.errors.noResponse": "Nu am putut genera un răspuns. Încearcă din nou.",
        "widget.errors.moreContext": "Am nevoie de mai mult context înainte de rezervare. Încearcă din nou.",
        "widget.errors.meetingBooked": "Întâlnirea ta este rezervată. Vei primi în curând o invitație în calendar.",
        "widget.errors.bookingConfirmFailed": "Îmi pare rău, nu am putut confirma acel interval. Alege altul.",
        "widget.errors.connectFailed": "Îmi pare rău, am avut probleme la conectarea cu asistentul. Încearcă din nou peste puțin.",
        "widget.time.justNow": "Chiar acum",
    },
    bg: {
        "chat.activityProductsFor": "Търся {goal}…",
        "agentDebug.queue": "Изчакване за старт",
        "agentDebug.firstReply": "Първи отговор",
        "agentDebug.total": "Време за отговор",
        "agentDebug.usage": "{calls} заявки към модела · {tokens} токена",
        "agentDebug.actions": "Какво направи NOA",
        "agentDebug.action": "Работа по заявката",
        "agentDebug.noActions": "Подготвя се отговор; още няма използвани инструменти.",
        "agentDebug.fields": "Запазена информация",
        "agentDebug.products": "Намерени продукти: {count}",
        "agentDebug.details": "Входни данни и резултат",
        "agentDebug.tasks": "Запазен напредък по задачите",
        "agentDebug.sources": "Официални източници",
        "agentDebug.context": "Контекст на разговора",
        "agentDebug.history": "Последни съобщения: {count}",
        "agentDebug.tools": "Налични възможности",
        "agentDebug.raw": "Технически подробности",
        "agentDebug.readProducts": "Преглед на предишни продукти",
        "agentDebug.taskDetails": "Преглед на изискванията",
        "agentDebug.startTask": "Започване или продължаване на задача",
        "agentDebug.readTask": "Преглед на запазения напредък",
        "agentDebug.readCustomer": "Преглед на известната информация за клиента",
        "agentDebug.readHistory": "Преглед на предишни съобщения",
        "agentDebug.closeTask": "Завършване на задача",
        "agentDebug.searchTimeout": "Търсенето отне твърде дълго. Не е започнато второ търсене.",
        "agentDebug.noCredits": "Няма налични кредити за търсене.",
        "agentDebug.unavailable": "Тази възможност не е достъпна.",
        "agentDebug.unsupportedField": "Отхвърлено е неподдържано поле за клиента.",
        "agentDebug.invalidProducts": "Резултатът от търсенето не може да бъде валидиран.",
        "agentDebug.toolFailed": "Действието не можа да бъде завършено.",
        "agentDebug.uncertainAction": "Резултатът от външното действие е неясен и изисква проверка.",
        "agentDebug.humanActive": "AI спря, защото разговорът е поет от човек.",
        "agentDebug.runFailed": "Отговорът не можа да бъде завършен.",
        "agentDebug.status.queued": "Изчакване",
        "agentDebug.status.running": "В процес",
        "agentDebug.status.completed": "Завършено",
        "agentDebug.status.succeeded": "Завършено",
        "agentDebug.status.failed": "Неуспешно",
        "agentDebug.status.pending": "В процес",
        "agentDebug.status.uncertain": "Изисква проверка",
        "agentDebug.status.interrupted": "Спряно",
        "agentDebug.status.awaiting_approval": "Изчаква одобрение",
        "agentDebug.status.awaiting_input": "Изчаква информация от клиента",
        "agentDebug.status.ready_to_submit": "Информацията е събрана",
        "agentDebug.status.submitted": "Изпратено",
        "agentDebug.status.cancelled": "Отменено",
        "agentDebug.status.unknown": "Запазено",
        "chat.activityThinking": "Подготвям отговора ви…",
        "chat.activityProductDetails": "Проверявам подробностите за продуктите…",
        "chat.activityProductReview": "Подбирам подходящи продукти…",
        "chat.activitySending": "Изпращам информацията ви…",
        "chat.activityHandoff": "Заявявам помощ от човек…",
        "chat.activitySupport": "Преглеждам указанията за помощ…",
        "chat.activityKnowledge": "Търсене на информация за бизнеса…",
        "chat.activityProducts": "Търсене на продукти…",
        "chat.activityAvailability": "Проверка на свободни часове…",
        "chat.activityBooking": "Създаване на резервация…",
        "chat.activitySaving": "Запазване на информация…",
        "tab.home": "Начало",
        "tab.history": "История",
        "tab.help": "Помощ",
        "home.welcome": "Добре дошли",
        "home.startFlowChatWith": "Започнете flow чат с {brandName}",
        "home.latestConversation": "Последен разговор",
        "chat.placeholder": "Попитайте каквото и да е...",
        "chat.send": "Изпрати съобщение",
        "chat.retryHint": "Опитай отново ще изпрати последното ти съобщение.",
        "chat.retry": "Опитай отново",
        "chat.noAvailableTimes": "Няма налични часове в момента.",
        "chat.slots": "{count} часа",
        "chat.bookedFor": "Резервирано за {start} - {end}",
        "chat.unableToConfirm": "Не може да се потвърди този час. Опитайте друг.",
        "chat.timezone": "Часова зона: {timezone}",
        "chat.durationMinutes": "{minutes} мин",
        "chat.bookingPending": "Резервиране...",
        "chat.booked": "Резервирано",
        "chat.confirmBooking": "Потвърди резервация",
        "chat.you": "Вие",
        "chat.support": "Поддръжка",
        "history.rename": "Преименуване",
        "history.delete": "Изтриване",
        "history.deleteTitle": "Изтриване на разговора?",
        "history.deleteBody": "Това ще премахне разговора от историята. Действието не може да се отмени.",
        "history.cancel": "Отказ",
        "history.confirmDelete": "Изтрий",
        "consent.title": "Известие за поверителност",
        "consent.body": "Преди да чатите с {brandName}, одобрете нашата политика за поверителност.",
        "consent.cta": "Съгласен съм и искам да чатя",
        "header.back": "Назад",
        "header.flowReasoning": "Обосновка на потока",
        "header.minimize": "Минимизирай чатбота",
        "closedFlows.dismiss": "Отхвърли предложенията за поток",
        "flowDebug.title": "Обосновка на потока",
        "flowDebug.noActiveFlow": "Няма активен поток",
        "flowDebug.notUpdated": "Още не е актуализирано",
        "flowDebug.status": "Статус",
        "flowDebug.conversationId": "ID на разговор",
        "flowDebug.flowRunId": "ID на изпълнение на поток",
        "flowDebug.selectedFlowId": "Избран ID на поток",
        "flowDebug.completion": "Завършване",
        "flowDebug.isComplete": "Завършено",
        "flowDebug.lastUpdated": "Последна актуализация",
        "flowDebug.missingFields": "Липсващи полета",
        "flowDebug.noMissingFields": "Няма липсващи полета.",
        "flowDebug.validationIssues": "Проблеми при валидиране",
        "flowDebug.unknownField": "Неизвестно поле",
        "flowDebug.noDetails": "Няма подробности.",
        "flowDebug.noValidationIssues": "Няма проблеми при валидиране.",
        "flowDebug.routerNotes": "Бележки на рутера",
        "flowDebug.noRouterDetails": "Все още няма детайли от рутера.",
        "flowDebug.close": "Затвори обосновката на потока",
        "flowDebug.yes": "Да",
        "flowDebug.no": "Не",
        "help.howTitle": "Как работи",
        "help.howBody": "Този уиджет засега е само фронтенд. Когато е свързан, ще изпраща данни към {baseUrl}. Конфигурирайте apiBaseUrl при монтиране.",
        "help.embedTitle": "Вграждане",
        "help.embedBody": "Включете chatbot-widget.js чрез script tag. Извикайте ChatbotWidget.mount с целеви елемент или включете скрипта за плаващ балон. Iframe на /chatbot-embed.html използва същия bundle.",
        "help.themeTitle": "Тема",
        "help.themeBody": "Настройте стойностите на темата за акцентен цвят, фон, текст и радиус на ъглите. Позицията може да е долу вляво или долу вдясно.",
        "widget.welcomeMessage": "Здравейте! Аз съм {brandName}. Започнете нов чат за помощ или продължение.",
        "widget.homeHeroTitle": "Чат с {brandName}",
        "widget.homeHeroSubtitle": "Бързи отговори, история и помощ без да напускате страницата.",
        "widget.auth.startTrialActivate": "Започнете безплатен пробен период, за да активирате този чатбот.",
        "widget.auth.unauthorized": "Неоторизиран.",
        "widget.auth.unableAuth": "Неуспешна автентикация на чатбота.",
        "widget.auth.notWorking": "Този чатбот не работи в момента. Опитайте по-късно.",
        "widget.auth.startTrialEnable": "Започнете безплатен пробен период, за да активирате разговори и потоци.",
        "widget.auth.activateTitle": "Активирай този чатбот",
        "widget.auth.goToDashboard": "Към таблото",
        "widget.openChatbot": "Отвори чатбота",
        "widget.conversation.defaultName": "Разговор {id}",
        "widget.conversation.defaultShort": "Разговор",
        "widget.conversation.new": "Нов разговор",
        "widget.conversation.pending": "Стартиране на разговор...",
        "widget.conversation.openHistory": "Отворете, за да видите историята на разговорите.",
        "widget.handoff.joined": "Човешки агент се присъедини към чата. Вече можете да изпращате и получавате съобщения в реално време.",
        "widget.errors.noResponse": "Не успях да генерирам отговор. Опитайте отново.",
        "widget.errors.moreContext": "Нуждая се от повече контекст преди резервация. Опитайте отново.",
        "widget.errors.meetingBooked": "Срещата ви е резервирана. Скоро ще получите покана за календар.",
        "widget.errors.bookingConfirmFailed": "Съжалявам, не успях да потвърдя часа. Изберете друг.",
        "widget.errors.connectFailed": "Съжалявам, имах проблем с връзката с асистента. Опитайте отново след малко.",
        "widget.time.justNow": "Току-що",
    },
    el: {
        "chat.activityProductsFor": "Αναζητώ {goal}…",
        "chat.activityThinking": "Ετοιμάζω την απάντησή σας…",
        "chat.activityProductDetails": "Ελέγχω τις λεπτομέρειες του προϊόντος…",
        "chat.activityProductReview": "Αξιολογώ προϊόντα…",
        "chat.activitySending": "Στέλνω τα στοιχεία σας…",
        "chat.activityHandoff": "Ζητώ ανθρώπινη βοήθεια…",
        "chat.activitySupport": "Διαβάζω τις οδηγίες υποστήριξης…",
        "chat.activityKnowledge": "Αναζήτηση πληροφοριών επιχείρησης…",
        "chat.activityProducts": "Αναζήτηση προϊόντων…",
        "chat.activityAvailability": "Έλεγχος διαθεσιμότητας…",
        "chat.activityBooking": "Δημιουργία κράτησης…",
        "chat.activitySaving": "Αποθήκευση πληροφοριών…",
        "tab.home": "Αρχική",
        "tab.history": "Ιστορικό",
        "tab.help": "Βοήθεια",
        "home.welcome": "Καλώς ήρθατε",
        "home.startFlowChatWith": "Έναρξη ροής συνομιλίας με {brandName}",
        "home.latestConversation": "Τελευταία συνομιλία",
        "chat.placeholder": "Ρωτήστε οτιδήποτε...",
        "chat.send": "Αποστολή μηνύματος",
        "chat.retryHint": "Η επανάληψη θα ξαναστείλει το τελευταίο μήνυμα.",
        "chat.retry": "Επανάληψη",
        "chat.noAvailableTimes": "Δεν υπάρχουν διαθέσιμες ώρες αυτή τη στιγμή.",
        "chat.slots": "{count} διαθέσιμες ώρες",
        "chat.bookedFor": "Κρατήθηκε για {start} - {end}",
        "chat.unableToConfirm": "Δεν ήταν δυνατή η επιβεβαίωση αυτής της ώρας. Δοκιμάστε άλλη.",
        "chat.timezone": "Ζώνη ώρας: {timezone}",
        "chat.durationMinutes": "{minutes} λεπτά",
        "chat.bookingPending": "Γίνεται κράτηση...",
        "chat.booked": "Κρατήθηκε",
        "chat.confirmBooking": "Επιβεβαίωση κράτησης",
        "chat.you": "Εσύ",
        "chat.support": "Υποστήριξη",
        "history.rename": "Μετονομασία",
        "history.delete": "Διαγραφή",
        "history.deleteTitle": "Διαγραφή συνομιλίας;",
        "history.deleteBody": "Αυτό θα αφαιρέσει τη συνομιλία από το ιστορικό. Δεν μπορεί να αναιρεθεί.",
        "history.cancel": "Ακύρωση",
        "history.confirmDelete": "Διαγραφή",
        "consent.title": "Ειδοποίηση απορρήτου",
        "consent.body": "Πριν συνομιλήσετε με {brandName}, εγκρίνετε την πολιτική απορρήτου μας.",
        "consent.cta": "Συμφωνώ και θέλω να συνομιλήσω",
        "header.back": "Πίσω",
        "header.flowReasoning": "Αιτιολόγηση ροής",
        "header.minimize": "Ελαχιστοποίηση chatbot",
        "closedFlows.dismiss": "Απόρριψη προτάσεων ροής",
        "flowDebug.title": "Αιτιολόγηση ροής",
        "flowDebug.noActiveFlow": "Δεν υπάρχει ενεργή ροή",
        "flowDebug.notUpdated": "Δεν έχει ενημερωθεί ακόμη",
        "flowDebug.status": "Κατάσταση",
        "flowDebug.conversationId": "ID συνομιλίας",
        "flowDebug.flowRunId": "ID εκτέλεσης ροής",
        "flowDebug.selectedFlowId": "Επιλεγμένο ID ροής",
        "flowDebug.completion": "Ολοκλήρωση",
        "flowDebug.isComplete": "Είναι ολοκληρωμένο",
        "flowDebug.lastUpdated": "Τελευταία ενημέρωση",
        "flowDebug.missingFields": "Λείπουν πεδία",
        "flowDebug.noMissingFields": "Δεν λείπουν πεδία.",
        "flowDebug.validationIssues": "Προβλήματα επικύρωσης",
        "flowDebug.unknownField": "Άγνωστο πεδίο",
        "flowDebug.noDetails": "Δεν παρέχονται λεπτομέρειες.",
        "flowDebug.noValidationIssues": "Δεν υπάρχουν προβλήματα επικύρωσης.",
        "flowDebug.routerNotes": "Σημειώσεις δρομολογητή",
        "flowDebug.noRouterDetails": "Δεν υπάρχουν ακόμη λεπτομέρειες δρομολογητή.",
        "flowDebug.close": "Κλείσιμο αιτιολόγησης ροής",
        "flowDebug.yes": "Ναι",
        "flowDebug.no": "Όχι",
        "help.howTitle": "Πώς λειτουργεί",
        "help.howBody": "Αυτό το widget είναι προς το παρόν μόνο frontend. Όταν συνδεθεί, θα στείλει δεδομένα στο {baseUrl}. Ρυθμίστε το apiBaseUrl κατά το mount.",
        "help.embedTitle": "Ενσωμάτωση",
        "help.embedBody": "Προσθέστε το chatbot-widget.js με script tag. Καλέστε το ChatbotWidget.mount με στοιχείο στόχο ή προσθέστε το script για πλωτή φυσαλίδα. Το iframe στο /chatbot-embed.html χρησιμοποιεί το ίδιο bundle.",
        "help.themeTitle": "Θέμα",
        "help.themeBody": "Ρυθμίστε τις τιμές θέματος για χρώμα έμφασης, φόντο, κείμενο και ακτίνα γωνιών. Η θέση μπορεί να είναι κάτω αριστερά ή κάτω δεξιά.",
        "widget.welcomeMessage": "Γεια! Είμαι η {brandName}. Ξεκινήστε νέα συνομιλία για βοήθεια ή συνέχεια.",
        "widget.homeHeroTitle": "Συνομιλήστε με {brandName}",
        "widget.homeHeroSubtitle": "Γρήγορες απαντήσεις, ιστορικό και βοήθεια χωρίς να φύγετε από τη σελίδα.",
        "widget.auth.startTrialActivate": "Ξεκινήστε τη δωρεάν δοκιμή για να ενεργοποιήσετε αυτό το chatbot.",
        "widget.auth.unauthorized": "Μη εξουσιοδοτημένο.",
        "widget.auth.unableAuth": "Αδυναμία ταυτοποίησης του chatbot.",
        "widget.auth.notWorking": "Αυτό το chatbot δεν λειτουργεί αυτή τη στιγμή. Δοκιμάστε αργότερα.",
        "widget.auth.startTrialEnable": "Ξεκινήστε τη δωρεάν δοκιμή για να ενεργοποιήσετε συνομιλίες και ροές.",
        "widget.auth.activateTitle": "Ενεργοποίηση chatbot",
        "widget.auth.goToDashboard": "Μετάβαση στο ταμπλό",
        "widget.openChatbot": "Άνοιγμα chatbot",
        "widget.conversation.defaultName": "Συνομιλία {id}",
        "widget.conversation.defaultShort": "Συνομιλία",
        "widget.conversation.new": "Νέα συνομιλία",
        "widget.conversation.pending": "Εκκίνηση συνομιλίας...",
        "widget.conversation.openHistory": "Άνοιγμα για προβολή ιστορικού συνομιλιών.",
        "widget.handoff.joined": "Ένας ανθρώπινος εκπρόσωπος μπήκε στη συνομιλία. Μπορείτε τώρα να στέλνετε και να λαμβάνετε μηνύματα σε πραγματικό χρόνο.",
        "widget.errors.noResponse": "Δεν μπόρεσα να δημιουργήσω απάντηση. Δοκιμάστε ξανά.",
        "widget.errors.moreContext": "Χρειάζομαι περισσότερα στοιχεία πριν την κράτηση. Δοκιμάστε ξανά.",
        "widget.errors.meetingBooked": "Η συνάντησή σας έχει κλειστεί. Θα λάβετε σύντομα πρόσκληση ημερολογίου.",
        "widget.errors.bookingConfirmFailed": "Λυπάμαι, δεν μπόρεσα να επιβεβαιώσω αυτό το χρόνο. Επιλέξτε άλλον.",
        "widget.errors.connectFailed": "Λυπάμαι, υπήρξε πρόβλημα σύνδεσης με τον βοηθό. Δοκιμάστε ξανά σε λίγο.",
        "widget.time.justNow": "Μόλις τώρα",
    },
    tr: {
        "chat.activityProductsFor": "Aranıyor: {goal}…",
        "chat.activityThinking": "Yanıtınız hazırlanıyor…",
        "chat.activityProductDetails": "Ürün ayrıntılarını kontrol ediyorum…",
        "chat.activityProductReview": "Ürünleri değerlendiriyorum…",
        "chat.activitySending": "Bilgilerinizi gönderiyorum…",
        "chat.activityHandoff": "İnsan desteği talep ediyorum…",
        "chat.activitySupport": "Destek yönergelerini okuyorum…",
        "chat.activityKnowledge": "İşletme bilgileri aranıyor…",
        "chat.activityProducts": "Ürünler aranıyor…",
        "chat.activityAvailability": "Uygunluk kontrol ediliyor…",
        "chat.activityBooking": "Rezervasyon oluşturuluyor…",
        "chat.activitySaving": "Bilgiler kaydediliyor…",
        "tab.home": "Ana Sayfa",
        "tab.history": "Geçmiş",
        "tab.help": "Yardım",
        "home.welcome": "Hoş geldiniz",
        "home.startFlowChatWith": "{brandName} ile akış sohbeti başlat",
        "home.latestConversation": "Son konuşma",
        "chat.placeholder": "Her şeyi sor...",
        "chat.send": "Mesaj gönder",
        "chat.retryHint": "Yeniden dene son mesajınızı tekrar gönderir.",
        "chat.retry": "Yeniden dene",
        "chat.noAvailableTimes": "Şu anda uygun zaman yok.",
        "chat.slots": "{count} zaman",
        "chat.bookedFor": "{start} - {end} için rezerve edildi",
        "chat.unableToConfirm": "Bu zamanı onaylayamadım. Başka birini deneyin.",
        "chat.timezone": "Saat dilimi: {timezone}",
        "chat.durationMinutes": "{minutes} dk",
        "chat.bookingPending": "Rezervasyon yapılıyor...",
        "chat.booked": "Rezerve edildi",
        "chat.confirmBooking": "Rezervasyonu onayla",
        "chat.you": "Sen",
        "chat.support": "Destek",
        "history.rename": "Yeniden adlandır",
        "history.delete": "Sil",
        "history.deleteTitle": "Konuşma silinsin mi?",
        "history.deleteBody": "Bu işlem konuşmayı geçmişten kaldırır. Geri alınamaz.",
        "history.cancel": "İptal",
        "history.confirmDelete": "Sil",
        "consent.title": "Gizlilik bildirimi",
        "consent.body": "{brandName} ile sohbet etmeden önce gizlilik politikamızı onaylayın.",
        "consent.cta": "Kabul ediyorum ve sohbet etmek istiyorum",
        "header.back": "Geri",
        "header.flowReasoning": "Akış gerekçesi",
        "header.minimize": "Chatbot'u küçült",
        "closedFlows.dismiss": "Akış önerilerini kapat",
        "flowDebug.title": "Akış gerekçesi",
        "flowDebug.noActiveFlow": "Aktif akış yok",
        "flowDebug.notUpdated": "Henüz güncellenmedi",
        "flowDebug.status": "Durum",
        "flowDebug.conversationId": "Konuşma ID",
        "flowDebug.flowRunId": "Akış çalıştırma ID",
        "flowDebug.selectedFlowId": "Seçilen akış ID",
        "flowDebug.completion": "Tamamlama",
        "flowDebug.isComplete": "Tamamlandı",
        "flowDebug.lastUpdated": "Son güncelleme",
        "flowDebug.missingFields": "Eksik alanlar",
        "flowDebug.noMissingFields": "Eksik alan yok.",
        "flowDebug.validationIssues": "Doğrulama sorunları",
        "flowDebug.unknownField": "Bilinmeyen alan",
        "flowDebug.noDetails": "Detay yok.",
        "flowDebug.noValidationIssues": "Doğrulama sorunu yok.",
        "flowDebug.routerNotes": "Yönlendirici notları",
        "flowDebug.noRouterDetails": "Yönlendirici ayrıntısı yok.",
        "flowDebug.close": "Akış gerekçesini kapat",
        "flowDebug.yes": "Evet",
        "flowDebug.no": "Hayır",
        "help.howTitle": "Nasıl çalışır",
        "help.howBody": "Bu widget şu anda sadece frontend. Bağlandığında {baseUrl} adresine veri gönderir. Mount sırasında apiBaseUrl ayarlayın.",
        "help.embedTitle": "Gömme",
        "help.embedBody": "chatbot-widget.js dosyasını script etiketiyle ekleyin. ChatbotWidget.mount'u bir hedef öğeyle çağırın veya scripti ekleyerek yüzen baloncuk oluşturun. /chatbot-embed.html iframe'i aynı bundle'ı kullanır.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Tema değerlerini vurgu rengi, arka plan, metin ve köşe yarıçapı için ayarlayın. Konum sol alt veya sağ alt olabilir.",
        "widget.welcomeMessage": "Merhaba! Ben {brandName}. Yeni bir sohbet başlatın.",
        "widget.homeHeroTitle": "{brandName} ile sohbet et",
        "widget.homeHeroSubtitle": "Hızlı yanıtlar, geçmiş ve yardım sayfayı terk etmeden.",
        "widget.auth.startTrialActivate": "Bu chatbotu etkinleştirmek için ücretsiz deneme başlatın.",
        "widget.auth.unauthorized": "Yetkisiz.",
        "widget.auth.unableAuth": "Chatbot doğrulanamadı.",
        "widget.auth.notWorking": "Bu chatbot şu anda çalışmıyor. Lütfen daha sonra deneyin.",
        "widget.auth.startTrialEnable": "Konuşmaları ve akışları etkinleştirmek için ücretsiz deneme başlatın.",
        "widget.auth.activateTitle": "Chatbotu etkinleştir",
        "widget.auth.goToDashboard": "Kontrol paneline git",
        "widget.openChatbot": "Chatbotu aç",
        "widget.conversation.defaultName": "Konuşma {id}",
        "widget.conversation.defaultShort": "Konuşma",
        "widget.conversation.new": "Yeni konuşma",
        "widget.conversation.pending": "Konuşma başlatılıyor...",
        "widget.conversation.openHistory": "Konuşma geçmişini görmek için açın.",
        "widget.handoff.joined": "Bir insan temsilci sohbete katıldı. Artık mesajları gerçek zamanlı gönderip alabilirsiniz.",
        "widget.errors.noResponse": "Yanıt üretemedim. Lütfen tekrar deneyin.",
        "widget.errors.moreContext": "Rezervasyondan önce daha fazla bilgiye ihtiyacım var. Lütfen tekrar deneyin.",
        "widget.errors.meetingBooked": "Toplantınız ayarlandı. Yakında bir takvim daveti alacaksınız.",
        "widget.errors.bookingConfirmFailed": "Üzgünüm, bu zamanı onaylayamadım. Başka birini seçin.",
        "widget.errors.connectFailed": "Üzgünüm, asistanla bağlantı kuramadım. Lütfen biraz sonra tekrar deneyin.",
        "widget.time.justNow": "Az önce",
    },
    ru: {
        "chat.activityProductsFor": "Ищу: {goal}…",
        "chat.activityThinking": "Готовлю ответ…",
        "chat.activityProductDetails": "Проверяю сведения о товаре…",
        "chat.activityProductReview": "Подбираю товары…",
        "chat.activitySending": "Отправляю ваши данные…",
        "chat.activityHandoff": "Запрашиваю помощь человека…",
        "chat.activitySupport": "Читаю инструкции поддержки…",
        "chat.activityKnowledge": "Поиск информации о компании…",
        "chat.activityProducts": "Поиск товаров…",
        "chat.activityAvailability": "Проверка доступности…",
        "chat.activityBooking": "Создание бронирования…",
        "chat.activitySaving": "Сохранение информации…",
        "tab.home": "Главная",
        "tab.history": "История",
        "tab.help": "Помощь",
        "home.welcome": "Добро пожаловать",
        "home.startFlowChatWith": "Начать чат потока с {brandName}",
        "home.latestConversation": "Последний разговор",
        "chat.placeholder": "Спросите что угодно...",
        "chat.send": "Отправить сообщение",
        "chat.retryHint": "Повтор отправит последнее сообщение снова.",
        "chat.retry": "Повторить",
        "chat.noAvailableTimes": "Сейчас нет доступных времён.",
        "chat.slots": "{count} слотов",
        "chat.bookedFor": "Забронировано на {start} - {end}",
        "chat.unableToConfirm": "Не удалось подтвердить этот слот. Попробуйте другой.",
        "chat.timezone": "Часовой пояс: {timezone}",
        "chat.durationMinutes": "{minutes} мин",
        "chat.bookingPending": "Бронирование...",
        "chat.booked": "Забронировано",
        "chat.confirmBooking": "Подтвердить бронирование",
        "chat.you": "Вы",
        "chat.support": "Поддержка",
        "history.rename": "Переименовать",
        "history.delete": "Удалить",
        "history.deleteTitle": "Удалить разговор?",
        "history.deleteBody": "Это удалит разговор из истории. Действие нельзя отменить.",
        "history.cancel": "Отмена",
        "history.confirmDelete": "Удалить",
        "consent.title": "Уведомление о конфиденциальности",
        "consent.body": "Перед чатом с {brandName} подтвердите нашу политику конфиденциальности.",
        "consent.cta": "Согласен и хочу чатиться",
        "header.back": "Назад",
        "header.flowReasoning": "Обоснование потока",
        "header.minimize": "Свернуть чатбота",
        "closedFlows.dismiss": "Скрыть предложения потока",
        "flowDebug.title": "Обоснование потока",
        "flowDebug.noActiveFlow": "Нет активного потока",
        "flowDebug.notUpdated": "Еще не обновлено",
        "flowDebug.status": "Статус",
        "flowDebug.conversationId": "ID разговора",
        "flowDebug.flowRunId": "ID запуска потока",
        "flowDebug.selectedFlowId": "Выбранный ID потока",
        "flowDebug.completion": "Завершение",
        "flowDebug.isComplete": "Завершено",
        "flowDebug.lastUpdated": "Последнее обновление",
        "flowDebug.missingFields": "Отсутствующие поля",
        "flowDebug.noMissingFields": "Нет отсутствующих полей.",
        "flowDebug.validationIssues": "Проблемы валидации",
        "flowDebug.unknownField": "Неизвестное поле",
        "flowDebug.noDetails": "Нет деталей.",
        "flowDebug.noValidationIssues": "Нет проблем валидации.",
        "flowDebug.routerNotes": "Заметки маршрутизатора",
        "flowDebug.noRouterDetails": "Деталей маршрутизатора пока нет.",
        "flowDebug.close": "Закрыть обоснование потока",
        "flowDebug.yes": "Да",
        "flowDebug.no": "Нет",
        "help.howTitle": "Как это работает",
        "help.howBody": "Этот виджет сейчас только frontend. При подключении он отправляет данные на {baseUrl}. Настройте apiBaseUrl при монтировании.",
        "help.embedTitle": "Встраивание",
        "help.embedBody": "Добавьте chatbot-widget.js через script tag. Вызовите ChatbotWidget.mount с целевым элементом или добавьте скрипт для плавающего пузыря. Iframe на /chatbot-embed.html использует тот же bundle.",
        "help.themeTitle": "Тема",
        "help.themeBody": "Настройте значения темы для акцентного цвета, фона, текста и радиуса углов. Положение может быть снизу слева или справа.",
        "widget.welcomeMessage": "Привет! Я {brandName}. Начните новый чат для помощи или продолжения.",
        "widget.homeHeroTitle": "Чат с {brandName}",
        "widget.homeHeroSubtitle": "Быстрые ответы, история и помощь без выхода со страницы.",
        "widget.auth.startTrialActivate": "Начните бесплатный пробный период, чтобы активировать этого чатбота.",
        "widget.auth.unauthorized": "Не авторизовано.",
        "widget.auth.unableAuth": "Не удалось аутентифицировать чатбота.",
        "widget.auth.notWorking": "Этот чатбот сейчас не работает. Попробуйте позже.",
        "widget.auth.startTrialEnable": "Начните бесплатный пробный период, чтобы включить разговоры и потоки.",
        "widget.auth.activateTitle": "Активировать чатбота",
        "widget.auth.goToDashboard": "Перейти в панель",
        "widget.openChatbot": "Открыть чатбота",
        "widget.conversation.defaultName": "Разговор {id}",
        "widget.conversation.defaultShort": "Разговор",
        "widget.conversation.new": "Новый разговор",
        "widget.conversation.pending": "Начинаю разговор...",
        "widget.conversation.openHistory": "Откройте, чтобы увидеть историю разговоров.",
        "widget.handoff.joined": "К чату присоединился оператор. Теперь можно отправлять и получать сообщения в реальном времени.",
        "widget.errors.noResponse": "Не удалось создать ответ. Попробуйте снова.",
        "widget.errors.moreContext": "Мне нужно больше контекста перед бронированием. Попробуйте снова.",
        "widget.errors.meetingBooked": "Ваша встреча забронирована. Скоро вы получите приглашение в календарь.",
        "widget.errors.bookingConfirmFailed": "Извините, не удалось подтвердить это время. Выберите другое.",
        "widget.errors.connectFailed": "Извините, возникли проблемы с подключением к ассистенту. Попробуйте снова чуть позже.",
        "widget.time.justNow": "Только что",
    },
    uk: {
        "chat.activityProductsFor": "Шукаю: {goal}…",
        "chat.activityThinking": "Готую відповідь…",
        "chat.activityProductDetails": "Перевіряю відомості про товар…",
        "chat.activityProductReview": "Добираю товари…",
        "chat.activitySending": "Надсилаю ваші дані…",
        "chat.activityHandoff": "Запитую допомогу людини…",
        "chat.activitySupport": "Читаю інструкції підтримки…",
        "chat.activityKnowledge": "Пошук інформації про компанію…",
        "chat.activityProducts": "Пошук товарів…",
        "chat.activityAvailability": "Перевірка доступності…",
        "chat.activityBooking": "Створення бронювання…",
        "chat.activitySaving": "Збереження інформації…",
        "tab.home": "Головна",
        "tab.history": "Історія",
        "tab.help": "Допомога",
        "home.welcome": "Ласкаво просимо",
        "home.startFlowChatWith": "Почати чат потоку з {brandName}",
        "home.latestConversation": "Остання розмова",
        "chat.placeholder": "Запитайте будь-що...",
        "chat.send": "Надіслати повідомлення",
        "chat.retryHint": "Повторення надішле ваше останнє повідомлення.",
        "chat.retry": "Повторити",
        "chat.noAvailableTimes": "Наразі немає доступних слотів.",
        "chat.slots": "{count} слотів",
        "chat.bookedFor": "Заброньовано на {start} - {end}",
        "chat.unableToConfirm": "Неможливо підтвердити цей слот. Спробуйте інший.",
        "chat.timezone": "Часовий пояс: {timezone}",
        "chat.durationMinutes": "{minutes} хв",
        "chat.bookingPending": "Бронювання...",
        "chat.booked": "Заброньовано",
        "chat.confirmBooking": "Підтвердити бронювання",
        "chat.you": "Ви",
        "chat.support": "Підтримка",
        "history.rename": "Перейменувати",
        "history.delete": "Видалити",
        "history.deleteTitle": "Видалити розмову?",
        "history.deleteBody": "Це видалить розмову з історії. Дію не можна скасувати.",
        "history.cancel": "Скасувати",
        "history.confirmDelete": "Видалити",
        "consent.title": "Повідомлення про конфіденційність",
        "consent.body": "Перш ніж спілкуватися з {brandName}, погодьтеся з нашою політикою конфіденційності.",
        "consent.cta": "Я згоден і хочу спілкуватися",
        "header.back": "Назад",
        "header.flowReasoning": "Обґрунтування потоку",
        "header.minimize": "Згорнути чатбота",
        "closedFlows.dismiss": "Відхилити пропозиції потоків",
        "flowDebug.title": "Обґрунтування потоку",
        "flowDebug.noActiveFlow": "Немає активного потоку",
        "flowDebug.notUpdated": "Ще не оновлено",
        "flowDebug.status": "Статус",
        "flowDebug.conversationId": "ID розмови",
        "flowDebug.flowRunId": "ID запуску потоку",
        "flowDebug.selectedFlowId": "Вибраний ID потоку",
        "flowDebug.completion": "Завершення",
        "flowDebug.isComplete": "Завершено",
        "flowDebug.lastUpdated": "Останнє оновлення",
        "flowDebug.missingFields": "Відсутні поля",
        "flowDebug.noMissingFields": "Немає відсутніх полів.",
        "flowDebug.validationIssues": "Проблеми валідації",
        "flowDebug.unknownField": "Невідоме поле",
        "flowDebug.noDetails": "Без деталей.",
        "flowDebug.noValidationIssues": "Немає проблем валідації.",
        "flowDebug.routerNotes": "Нотатки маршрутизатора",
        "flowDebug.noRouterDetails": "Поки що немає деталей маршрутизатора.",
        "flowDebug.close": "Закрити обґрунтування потоку",
        "flowDebug.yes": "Так",
        "flowDebug.no": "Ні",
        "help.howTitle": "Як це працює",
        "help.howBody": "Цей віджет зараз лише фронтенд. Коли підключено, він надсилає дані на {baseUrl}. Налаштуйте apiBaseUrl під час монтування.",
        "help.embedTitle": "Вбудовування",
        "help.embedBody": "Додайте chatbot-widget.js через script tag. Викличте ChatbotWidget.mount з цільовим елементом або додайте скрипт для плаваючої бульбашки. Iframe на /chatbot-embed.html використовує той самий bundle.",
        "help.themeTitle": "Тема",
        "help.themeBody": "Налаштуйте значення теми для акцентного кольору, фону, тексту та радіусу кутів. Позиція може бути зліва або справа внизу.",
        "widget.welcomeMessage": "Привіт! Я {brandName}. Почніть новий чат для допомоги або продовження.",
        "widget.homeHeroTitle": "Чат з {brandName}",
        "widget.homeHeroSubtitle": "Швидкі відповіді, історія та допомога без виходу зі сторінки.",
        "widget.auth.startTrialActivate": "Почніть безкоштовний пробний період, щоб активувати цей чатбот.",
        "widget.auth.unauthorized": "Не авторизовано.",
        "widget.auth.unableAuth": "Не вдалося автентифікувати чатбота.",
        "widget.auth.notWorking": "Цей чатбот зараз не працює. Спробуйте пізніше.",
        "widget.auth.startTrialEnable": "Почніть безкоштовний пробний період, щоб увімкнути розмови та потоки.",
        "widget.auth.activateTitle": "Активувати чатбота",
        "widget.auth.goToDashboard": "Перейти до панелі",
        "widget.openChatbot": "Відкрити чатбота",
        "widget.conversation.defaultName": "Розмова {id}",
        "widget.conversation.defaultShort": "Розмова",
        "widget.conversation.new": "Нова розмова",
        "widget.conversation.pending": "Починаю розмову...",
        "widget.conversation.openHistory": "Відкрийте, щоб переглянути історію розмов.",
        "widget.handoff.joined": "До чату приєднався агент. Тепер ви можете надсилати й отримувати повідомлення в реальному часі.",
        "widget.errors.noResponse": "Не вдалося створити відповідь. Спробуйте ще раз.",
        "widget.errors.moreContext": "Потрібно більше контексту перед бронюванням. Спробуйте ще раз.",
        "widget.errors.meetingBooked": "Вашу зустріч заброньовано. Незабаром ви отримаєте запрошення в календар.",
        "widget.errors.bookingConfirmFailed": "Вибачте, не вдалося підтвердити час. Оберіть інший.",
        "widget.errors.connectFailed": "Вибачте, проблеми з підключенням до асистента. Спробуйте ще раз за мить.",
        "widget.time.justNow": "Щойно",
    },
    ar: {
        "chat.activityProductsFor": "أبحث عن {goal}…",
        "chat.activityThinking": "أجهّز الرد…",
        "chat.activityProductDetails": "أتحقق من تفاصيل المنتج…",
        "chat.activityProductReview": "أراجع المنتجات…",
        "chat.activitySending": "أرسل معلوماتك…",
        "chat.activityHandoff": "أطلب مساعدة بشرية…",
        "chat.activitySupport": "أقرأ إرشادات الدعم…",
        "chat.activityKnowledge": "جارٍ البحث عن معلومات الشركة…",
        "chat.activityProducts": "جارٍ البحث عن المنتجات…",
        "chat.activityAvailability": "جارٍ التحقق من التوفر…",
        "chat.activityBooking": "جارٍ إنشاء الحجز…",
        "chat.activitySaving": "جارٍ حفظ المعلومات…",
        "tab.home": "الرئيسية",
        "tab.history": "السجل",
        "tab.help": "المساعدة",
        "home.welcome": "مرحبًا",
        "home.startFlowChatWith": "ابدأ محادثة التدفق مع {brandName}",
        "home.latestConversation": "آخر محادثة",
        "chat.placeholder": "اسأل أي شيء...",
        "chat.send": "إرسال رسالة",
        "chat.retryHint": "إعادة المحاولة سترسل آخر رسالة مرة أخرى.",
        "chat.retry": "إعادة المحاولة",
        "chat.noAvailableTimes": "لا توجد مواعيد متاحة الآن.",
        "chat.slots": "{count} مواعيد",
        "chat.bookedFor": "محجوز لـ {start} - {end}",
        "chat.unableToConfirm": "تعذر تأكيد هذا الموعد. جرّب موعدًا آخر.",
        "chat.timezone": "المنطقة الزمنية: {timezone}",
        "chat.durationMinutes": "{minutes} دقيقة",
        "chat.bookingPending": "جارٍ الحجز...",
        "chat.booked": "محجوز",
        "chat.confirmBooking": "تأكيد الحجز",
        "chat.you": "أنت",
        "chat.support": "الدعم",
        "history.rename": "إعادة التسمية",
        "history.delete": "حذف",
        "history.deleteTitle": "حذف المحادثة؟",
        "history.deleteBody": "سيؤدي هذا إلى إزالة المحادثة من السجل. لا يمكن التراجع.",
        "history.cancel": "إلغاء",
        "history.confirmDelete": "حذف",
        "consent.title": "إشعار الخصوصية",
        "consent.body": "قبل الدردشة مع {brandName}، يرجى الموافقة على سياسة الخصوصية.",
        "consent.cta": "أوافق وأريد الدردشة",
        "header.back": "رجوع",
        "header.flowReasoning": "مبررات التدفق",
        "header.minimize": "تصغير الشات بوت",
        "closedFlows.dismiss": "إخفاء اقتراحات التدفق",
        "flowDebug.title": "مبررات التدفق",
        "flowDebug.noActiveFlow": "لا يوجد تدفق نشط",
        "flowDebug.notUpdated": "لم يتم التحديث بعد",
        "flowDebug.status": "الحالة",
        "flowDebug.conversationId": "معرّف المحادثة",
        "flowDebug.flowRunId": "معرّف تشغيل التدفق",
        "flowDebug.selectedFlowId": "معرّف التدفق المحدد",
        "flowDebug.completion": "الإكمال",
        "flowDebug.isComplete": "مكتمل",
        "flowDebug.lastUpdated": "آخر تحديث",
        "flowDebug.missingFields": "حقول مفقودة",
        "flowDebug.noMissingFields": "لا توجد حقول مفقودة.",
        "flowDebug.validationIssues": "مشكلات التحقق",
        "flowDebug.unknownField": "حقل غير معروف",
        "flowDebug.noDetails": "لا توجد تفاصيل.",
        "flowDebug.noValidationIssues": "لا توجد مشكلات تحقق.",
        "flowDebug.routerNotes": "ملاحظات الموجّه",
        "flowDebug.noRouterDetails": "لا توجد تفاصيل للموجّه بعد.",
        "flowDebug.close": "إغلاق مبررات التدفق",
        "flowDebug.yes": "نعم",
        "flowDebug.no": "لا",
        "help.howTitle": "كيف يعمل",
        "help.howBody": "هذا الودجت واجهة أمامية فقط حاليًا. عند الاتصال، سيرسل البيانات إلى {baseUrl}. قم بإعداد apiBaseUrl عند التركيب.",
        "help.embedTitle": "التضمين",
        "help.embedBody": "قم بتضمين chatbot-widget.js عبر وسم script. استدعِ ChatbotWidget.mount مع عنصر الهدف أو أضف السكربت لإنشاء فقاعة عائمة. يستخدم iframe في /chatbot-embed.html نفس الحزمة.",
        "help.themeTitle": "السمة",
        "help.themeBody": "اضبط قيم السمة للون التمييز والخلفية والنص ونصف قطر الزوايا. يمكن أن يكون الموضع أسفل اليسار أو أسفل اليمين.",
        "widget.welcomeMessage": "مرحبًا! أنا {brandName}. ابدأ محادثة جديدة للحصول على المساعدة أو المتابعة.",
        "widget.homeHeroTitle": "تحدث مع {brandName}",
        "widget.homeHeroSubtitle": "إجابات سريعة وسجل ومساعدة دون مغادرة الصفحة.",
        "widget.auth.startTrialActivate": "ابدأ النسخة التجريبية المجانية لتفعيل هذا الشات بوت.",
        "widget.auth.unauthorized": "غير مصرح.",
        "widget.auth.unableAuth": "تعذر التحقق من الشات بوت.",
        "widget.auth.notWorking": "هذا الشات بوت لا يعمل الآن. حاول لاحقًا.",
        "widget.auth.startTrialEnable": "ابدأ النسخة التجريبية المجانية لتفعيل المحادثات والتدفقات.",
        "widget.auth.activateTitle": "تفعيل الشات بوت",
        "widget.auth.goToDashboard": "الانتقال إلى اللوحة",
        "widget.openChatbot": "فتح الشات بوت",
        "widget.conversation.defaultName": "محادثة {id}",
        "widget.conversation.defaultShort": "محادثة",
        "widget.conversation.new": "محادثة جديدة",
        "widget.conversation.pending": "جارٍ بدء المحادثة...",
        "widget.conversation.openHistory": "افتح لعرض سجل المحادثات.",
        "widget.handoff.joined": "انضم وكيل بشري إلى المحادثة. يمكنك الآن إرسال واستقبال الرسائل في الوقت الفعلي.",
        "widget.errors.noResponse": "لم أتمكن من إنشاء رد. حاول مرة أخرى.",
        "widget.errors.moreContext": "أحتاج إلى مزيد من السياق قبل الحجز. حاول مرة أخرى.",
        "widget.errors.meetingBooked": "تم حجز اجتماعك. ستتلقى دعوة تقويم قريبًا.",
        "widget.errors.bookingConfirmFailed": "عذرًا، لم أتمكن من تأكيد هذا الموعد. اختر موعدًا آخر.",
        "widget.errors.connectFailed": "عذرًا، حدثت مشكلة في الاتصال بالمساعد. حاول مرة أخرى بعد قليل.",
        "widget.time.justNow": "الآن",
    },
    he: {
        "chat.activityProductsFor": "מחפש {goal}…",
        "chat.activityThinking": "מכין את התשובה…",
        "chat.activityProductDetails": "בודק את פרטי המוצר…",
        "chat.activityProductReview": "בוחן מוצרים…",
        "chat.activitySending": "שולח את הפרטים שלך…",
        "chat.activityHandoff": "מבקש סיוע אנושי…",
        "chat.activitySupport": "קורא את הנחיות התמיכה…",
        "chat.activityKnowledge": "מחפש מידע על העסק…",
        "chat.activityProducts": "מחפש מוצרים…",
        "chat.activityAvailability": "בודק זמינות…",
        "chat.activityBooking": "יוצר הזמנה…",
        "chat.activitySaving": "שומר מידע…",
        "tab.home": "בית",
        "tab.history": "היסטוריה",
        "tab.help": "עזרה",
        "home.welcome": "ברוך הבא",
        "home.startFlowChatWith": "התחל צ'אט זרימה עם {brandName}",
        "home.latestConversation": "שיחה אחרונה",
        "chat.placeholder": "שאל כל דבר...",
        "chat.send": "שלח הודעה",
        "chat.retryHint": "נסה שוב ישלח את ההודעה האחרונה.",
        "chat.retry": "נסה שוב",
        "chat.noAvailableTimes": "אין זמנים זמינים כרגע.",
        "chat.slots": "{count} זמנים",
        "chat.bookedFor": "הוזמן ל-{start} - {end}",
        "chat.unableToConfirm": "לא ניתן לאשר את הזמן הזה. נסה זמן אחר.",
        "chat.timezone": "אזור זמן: {timezone}",
        "chat.durationMinutes": "{minutes} דקות",
        "chat.bookingPending": "מזמין...",
        "chat.booked": "הוזמן",
        "chat.confirmBooking": "אשר הזמנה",
        "chat.you": "אתה",
        "chat.support": "תמיכה",
        "history.rename": "שינוי שם",
        "history.delete": "מחיקה",
        "history.deleteTitle": "למחוק שיחה?",
        "history.deleteBody": "הפעולה תסיר את השיחה מההיסטוריה. לא ניתן לבטל.",
        "history.cancel": "בטל",
        "history.confirmDelete": "מחק",
        "consent.title": "הודעת פרטיות",
        "consent.body": "לפני שתשוחח עם {brandName}, אנא אשר את מדיניות הפרטיות שלנו.",
        "consent.cta": "אני מסכים ורוצה לשוחח",
        "header.back": "חזרה",
        "header.flowReasoning": "הסבר זרימה",
        "header.minimize": "מזער צ'אטבוט",
        "closedFlows.dismiss": "הסתר הצעות זרימה",
        "flowDebug.title": "הסבר זרימה",
        "flowDebug.noActiveFlow": "אין זרימה פעילה",
        "flowDebug.notUpdated": "עדיין לא עודכן",
        "flowDebug.status": "סטטוס",
        "flowDebug.conversationId": "מזהה שיחה",
        "flowDebug.flowRunId": "מזהה הרצת זרימה",
        "flowDebug.selectedFlowId": "מזהה זרימה שנבחרה",
        "flowDebug.completion": "השלמה",
        "flowDebug.isComplete": "הושלם",
        "flowDebug.lastUpdated": "עודכן לאחרונה",
        "flowDebug.missingFields": "שדות חסרים",
        "flowDebug.noMissingFields": "אין שדות חסרים.",
        "flowDebug.validationIssues": "בעיות ולידציה",
        "flowDebug.unknownField": "שדה לא ידוע",
        "flowDebug.noDetails": "אין פרטים.",
        "flowDebug.noValidationIssues": "אין בעיות ולידציה.",
        "flowDebug.routerNotes": "הערות נתב",
        "flowDebug.noRouterDetails": "עדיין אין פרטי נתב.",
        "flowDebug.close": "סגור הסבר זרימה",
        "flowDebug.yes": "כן",
        "flowDebug.no": "לא",
        "help.howTitle": "איך זה עובד",
        "help.howBody": "הווידג'ט הזה הוא כרגע רק פרונטנד. כשהוא מחובר הוא ישלח נתונים ל-{baseUrl}. הגדר apiBaseUrl בעת ההטמעה.",
        "help.embedTitle": "הטמעה",
        "help.embedBody": "הוסף את chatbot-widget.js באמצעות תג script. קרא ל-ChatbotWidget.mount עם אלמנט יעד או הוסף את הסקריפט ליצירת בועה צפה. ה-iframe ב-/chatbot-embed.html משתמש באותו bundle.",
        "help.themeTitle": "ערכת נושא",
        "help.themeBody": "התאם ערכי ערכת נושא לצבע הדגשה, רקע, טקסט ורדיוס פינות. המיקום יכול להיות למטה שמאל או למטה ימין.",
        "widget.welcomeMessage": "היי! אני {brandName}. התחל צ'אט חדש כדי לקבל עזרה או להמשיך.",
        "widget.homeHeroTitle": "שוחח עם {brandName}",
        "widget.homeHeroSubtitle": "תשובות מהירות, היסטוריה ועזרה בלי לעזוב את העמוד.",
        "widget.auth.startTrialActivate": "התחל תקופת ניסיון חינמית כדי להפעיל את הצ'אטבוט הזה.",
        "widget.auth.unauthorized": "לא מורשה.",
        "widget.auth.unableAuth": "לא ניתן לאמת את הצ'אטבוט.",
        "widget.auth.notWorking": "הצ'אטבוט הזה לא עובד כרגע. נסה מאוחר יותר.",
        "widget.auth.startTrialEnable": "התחל תקופת ניסיון חינמית כדי להפעיל שיחות וזרימות.",
        "widget.auth.activateTitle": "הפעל צ'אטבוט",
        "widget.auth.goToDashboard": "עבור ללוח הבקרה",
        "widget.openChatbot": "פתח צ'אטבוט",
        "widget.conversation.defaultName": "שיחה {id}",
        "widget.conversation.defaultShort": "שיחה",
        "widget.conversation.new": "שיחה חדשה",
        "widget.conversation.pending": "מתחיל שיחה...",
        "widget.conversation.openHistory": "פתח לצפייה בהיסטוריית השיחות.",
        "widget.handoff.joined": "נציג אנושי הצטרף לשיחה. כעת ניתן לשלוח ולקבל הודעות בזמן אמת.",
        "widget.errors.noResponse": "לא הצלחתי ליצור תגובה. נסה שוב.",
        "widget.errors.moreContext": "אני צריך יותר הקשר לפני ההזמנה. נסה שוב.",
        "widget.errors.meetingBooked": "הפגישה שלך הוזמנה. תקבל הזמנה ליומן בקרוב.",
        "widget.errors.bookingConfirmFailed": "מצטער, לא הצלחתי לאשר את הזמן הזה. בחר זמן אחר.",
        "widget.errors.connectFailed": "מצטער, הייתה בעיה להתחבר לעוזר. נסה שוב בעוד רגע.",
        "widget.time.justNow": "זה עתה",
    },
    hi: {
        "chat.activityProductsFor": "{goal} खोज रहा हूँ…",
        "chat.activityThinking": "आपका जवाब तैयार कर रहा हूँ…",
        "chat.activityProductDetails": "उत्पाद का विवरण जाँच रहा हूँ…",
        "chat.activityProductReview": "उत्पादों की समीक्षा कर रहा हूँ…",
        "chat.activitySending": "आपकी जानकारी भेज रहा हूँ…",
        "chat.activityHandoff": "मानवीय सहायता माँग रहा हूँ…",
        "chat.activitySupport": "सहायता निर्देश पढ़ रहा हूँ…",
        "chat.activityKnowledge": "व्यवसाय की जानकारी खोज रहे हैं…",
        "chat.activityProducts": "उत्पाद खोज रहे हैं…",
        "chat.activityAvailability": "उपलब्धता जाँच रहे हैं…",
        "chat.activityBooking": "बुकिंग बना रहे हैं…",
        "chat.activitySaving": "जानकारी सहेज रहे हैं…",
        "tab.home": "होम",
        "tab.history": "इतिहास",
        "tab.help": "मदद",
        "home.welcome": "स्वागत है",
        "home.startFlowChatWith": "{brandName} के साथ फ़्लो चैट शुरू करें",
        "home.latestConversation": "पिछली बातचीत",
        "chat.placeholder": "कुछ भी पूछें...",
        "chat.send": "संदेश भेजें",
        "chat.retryHint": "दोबारा प्रयास करने से आपका पिछला संदेश फिर से भेजा जाएगा।",
        "chat.retry": "दोबारा प्रयास",
        "chat.noAvailableTimes": "अभी कोई उपलब्ध समय नहीं है।",
        "chat.slots": "{count} स्लॉट",
        "chat.bookedFor": "{start} - {end} के लिए बुक किया गया",
        "chat.unableToConfirm": "इस स्लॉट की पुष्टि नहीं हो सकी। कृपया दूसरा चुनें।",
        "chat.timezone": "समय क्षेत्र: {timezone}",
        "chat.durationMinutes": "{minutes} मिनट",
        "chat.bookingPending": "बुकिंग हो रही है...",
        "chat.booked": "बुक हो गया",
        "chat.confirmBooking": "बुकिंग की पुष्टि करें",
        "chat.you": "आप",
        "chat.support": "सपोर्ट",
        "history.rename": "नाम बदलें",
        "history.delete": "हटाएँ",
        "history.deleteTitle": "बातचीत हटाएँ?",
        "history.deleteBody": "यह बातचीत को इतिहास से हटा देगा। इसे वापस नहीं किया जा सकता।",
        "history.cancel": "रद्द करें",
        "history.confirmDelete": "हटाएँ",
        "consent.title": "गोपनीयता सूचना",
        "consent.body": "{brandName} से चैट करने से पहले हमारी गोपनीयता नीति को स्वीकार करें।",
        "consent.cta": "मैं सहमत हूँ और चैट करना चाहता हूँ",
        "header.back": "वापस",
        "header.flowReasoning": "फ़्लो कारण",
        "header.minimize": "चैटबॉट छोटा करें",
        "closedFlows.dismiss": "फ़्लो सुझाव हटाएँ",
        "flowDebug.title": "फ़्लो कारण",
        "flowDebug.noActiveFlow": "कोई सक्रिय फ़्लो नहीं",
        "flowDebug.notUpdated": "अभी अपडेट नहीं हुआ",
        "flowDebug.status": "स्थिति",
        "flowDebug.conversationId": "बातचीत आईडी",
        "flowDebug.flowRunId": "फ़्लो रन आईडी",
        "flowDebug.selectedFlowId": "चयनित फ़्लो आईडी",
        "flowDebug.completion": "पूर्णता",
        "flowDebug.isComplete": "पूर्ण है",
        "flowDebug.lastUpdated": "अंतिम अपडेट",
        "flowDebug.missingFields": "गायब फ़ील्ड",
        "flowDebug.noMissingFields": "कोई गायब फ़ील्ड नहीं।",
        "flowDebug.validationIssues": "मान्यकरण समस्याएँ",
        "flowDebug.unknownField": "अज्ञात फ़ील्ड",
        "flowDebug.noDetails": "कोई विवरण नहीं।",
        "flowDebug.noValidationIssues": "कोई मान्यकरण समस्या नहीं।",
        "flowDebug.routerNotes": "राउटर नोट्स",
        "flowDebug.noRouterDetails": "अभी कोई राउटर विवरण नहीं है।",
        "flowDebug.close": "फ़्लो कारण बंद करें",
        "flowDebug.yes": "हाँ",
        "flowDebug.no": "नहीं",
        "help.howTitle": "यह कैसे काम करता है",
        "help.howBody": "यह विजेट अभी केवल फ्रंटएंड है। कनेक्ट होने पर यह {baseUrl} पर डेटा भेजेगा। माउंट करते समय apiBaseUrl सेट करें।",
        "help.embedTitle": "एम्बेड",
        "help.embedBody": "chatbot-widget.js को script टैग से शामिल करें। ChatbotWidget.mount को लक्ष्य तत्व के साथ कॉल करें या स्क्रिप्ट जोड़कर फ्लोटिंग बबल बनाएँ। /chatbot-embed.html iframe वही bundle उपयोग करता है।",
        "help.themeTitle": "थीम",
        "help.themeBody": "एक्सेंट रंग, बैकग्राउंड, टेक्स्ट और कोने के रेडियस के लिए थीम मान समायोजित करें। स्थिति नीचे-बाएँ या नीचे-दाएँ हो सकती है।",
        "widget.welcomeMessage": "नमस्ते! मैं {brandName} हूँ। मदद के लिए नया चैट शुरू करें या जारी रखें।",
        "widget.homeHeroTitle": "{brandName} के साथ चैट करें",
        "widget.homeHeroSubtitle": "तेज़ जवाब, इतिहास और मदद बिना पेज छोड़े।",
        "widget.auth.startTrialActivate": "इस चैटबॉट को सक्रिय करने के लिए मुफ्त ट्रायल शुरू करें।",
        "widget.auth.unauthorized": "अनधिकृत।",
        "widget.auth.unableAuth": "चैटबॉट प्रमाणित नहीं हो सका।",
        "widget.auth.notWorking": "यह चैटबॉट अभी काम नहीं कर रहा। बाद में प्रयास करें।",
        "widget.auth.startTrialEnable": "बातचीत और फ़्लो सक्षम करने के लिए मुफ्त ट्रायल शुरू करें।",
        "widget.auth.activateTitle": "चैटबॉट सक्रिय करें",
        "widget.auth.goToDashboard": "डैशबोर्ड पर जाएँ",
        "widget.openChatbot": "चैटबॉट खोलें",
        "widget.conversation.defaultName": "बातचीत {id}",
        "widget.conversation.defaultShort": "बातचीत",
        "widget.conversation.new": "नई बातचीत",
        "widget.conversation.pending": "बातचीत शुरू हो रही है...",
        "widget.conversation.openHistory": "बातचीत इतिहास देखने के लिए खोलें।",
        "widget.handoff.joined": "एक मानव एजेंट चैट में शामिल हुआ है। अब आप वास्तविक समय में संदेश भेज और प्राप्त कर सकते हैं।",
        "widget.errors.noResponse": "मैं प्रतिक्रिया नहीं बना सका। कृपया पुनः प्रयास करें।",
        "widget.errors.moreContext": "बुकिंग से पहले मुझे अधिक संदर्भ चाहिए। कृपया पुनः प्रयास करें।",
        "widget.errors.meetingBooked": "आपकी बैठक बुक हो गई है। आपको जल्द ही कैलेंडर आमंत्रण मिलेगा।",
        "widget.errors.bookingConfirmFailed": "माफ़ करें, मैं उस स्लॉट की पुष्टि नहीं कर सका। कृपया दूसरा चुनें।",
        "widget.errors.connectFailed": "माफ़ करें, सहायक से कनेक्ट करने में समस्या हुई। थोड़ी देर बाद पुनः प्रयास करें।",
        "widget.time.justNow": "अभी-अभी",
    },
    bn: {
        "chat.activityProductsFor": "{goal} খুঁজছি…",
        "chat.activityThinking": "আপনার উত্তর প্রস্তুত করছি…",
        "chat.activityProductDetails": "পণ্যের বিবরণ যাচাই করছি…",
        "chat.activityProductReview": "পণ্য পর্যালোচনা করছি…",
        "chat.activitySending": "আপনার তথ্য পাঠাচ্ছি…",
        "chat.activityHandoff": "মানুষের সহায়তা চাইছি…",
        "chat.activitySupport": "সহায়তার নির্দেশনা পড়ছি…",
        "chat.activityKnowledge": "ব্যবসার তথ্য খোঁজা হচ্ছে…",
        "chat.activityProducts": "পণ্য খোঁজা হচ্ছে…",
        "chat.activityAvailability": "প্রাপ্যতা যাচাই করা হচ্ছে…",
        "chat.activityBooking": "বুকিং তৈরি করা হচ্ছে…",
        "chat.activitySaving": "তথ্য সংরক্ষণ করা হচ্ছে…",
        "tab.home": "হোম",
        "tab.history": "ইতিহাস",
        "tab.help": "সহায়তা",
        "home.welcome": "স্বাগতম",
        "home.startFlowChatWith": "{brandName} এর সাথে ফ্লো চ্যাট শুরু করুন",
        "home.latestConversation": "সর্বশেষ আলাপ",
        "chat.placeholder": "যেকোনো কিছু জিজ্ঞাসা করুন...",
        "chat.send": "বার্তা পাঠান",
        "chat.retryHint": "আবার চেষ্টা করলে শেষ বার্তাটি আবার পাঠানো হবে।",
        "chat.retry": "আবার চেষ্টা",
        "chat.noAvailableTimes": "এখন কোনো সময় উপলব্ধ নেই।",
        "chat.slots": "{count} সময়",
        "chat.bookedFor": "{start} - {end} এর জন্য বুক করা হয়েছে",
        "chat.unableToConfirm": "এই সময়টি নিশ্চিত করা যায়নি। অন্যটি চেষ্টা করুন।",
        "chat.timezone": "টাইমজোন: {timezone}",
        "chat.durationMinutes": "{minutes} মিনিট",
        "chat.bookingPending": "বুকিং চলছে...",
        "chat.booked": "বুক করা হয়েছে",
        "chat.confirmBooking": "বুকিং নিশ্চিত করুন",
        "chat.you": "আপনি",
        "chat.support": "সাপোর্ট",
        "history.rename": "নাম বদলান",
        "history.delete": "মুছুন",
        "history.deleteTitle": "আলাপ মুছবেন?",
        "history.deleteBody": "এটি ইতিহাস থেকে আলাপটি মুছে দেবে। ফেরানো যাবে না।",
        "history.cancel": "বাতিল",
        "history.confirmDelete": "মুছুন",
        "consent.title": "গোপনীয়তা বিজ্ঞপ্তি",
        "consent.body": "{brandName} এর সাথে চ্যাট করার আগে আমাদের গোপনীয়তা নীতিতে সম্মতি দিন।",
        "consent.cta": "আমি সম্মত এবং চ্যাট করতে চাই",
        "header.back": "পেছনে",
        "header.flowReasoning": "ফ্লো ব্যাখ্যা",
        "header.minimize": "চ্যাটবট ছোট করুন",
        "closedFlows.dismiss": "ফ্লো প্রস্তাব বাদ দিন",
        "flowDebug.title": "ফ্লো ব্যাখ্যা",
        "flowDebug.noActiveFlow": "কোনো সক্রিয় ফ্লো নেই",
        "flowDebug.notUpdated": "এখনও আপডেট হয়নি",
        "flowDebug.status": "স্ট্যাটাস",
        "flowDebug.conversationId": "আলাপ আইডি",
        "flowDebug.flowRunId": "ফ্লো রান আইডি",
        "flowDebug.selectedFlowId": "নির্বাচিত ফ্লো আইডি",
        "flowDebug.completion": "সম্পন্ন",
        "flowDebug.isComplete": "সম্পন্ন",
        "flowDebug.lastUpdated": "সর্বশেষ আপডেট",
        "flowDebug.missingFields": "অনুপস্থিত ফিল্ড",
        "flowDebug.noMissingFields": "কোনো অনুপস্থিত ফিল্ড নেই।",
        "flowDebug.validationIssues": "ভ্যালিডেশন সমস্যা",
        "flowDebug.unknownField": "অজানা ফিল্ড",
        "flowDebug.noDetails": "কোনো বিবরণ নেই।",
        "flowDebug.noValidationIssues": "কোনো ভ্যালিডেশন সমস্যা নেই।",
        "flowDebug.routerNotes": "রাউটার নোট",
        "flowDebug.noRouterDetails": "এখনও কোনো রাউটার বিস্তারিত নেই।",
        "flowDebug.close": "ফ্লো ব্যাখ্যা বন্ধ করুন",
        "flowDebug.yes": "হ্যাঁ",
        "flowDebug.no": "না",
        "help.howTitle": "কিভাবে কাজ করে",
        "help.howBody": "এই উইজেটটি এখন শুধু ফ্রন্টএন্ড। সংযুক্ত হলে এটি {baseUrl} এ ডেটা পাঠাবে। মাউন্ট করার সময় apiBaseUrl সেট করুন।",
        "help.embedTitle": "এম্বেড",
        "help.embedBody": "script ট্যাগ দিয়ে chatbot-widget.js যোগ করুন। লক্ষ্য উপাদানসহ ChatbotWidget.mount কল করুন বা স্ক্রিপ্ট যোগ করে ভাসমান বুদবুদ তৈরি করুন। /chatbot-embed.html iframe একই bundle ব্যবহার করে।",
        "help.themeTitle": "থিম",
        "help.themeBody": "অ্যাকসেন্ট রঙ, ব্যাকগ্রাউন্ড, টেক্সট ও কোণার রেডিয়াসের জন্য থিম মান সমন্বয় করুন। অবস্থান নিচে-বাম বা নিচে-ডান হতে পারে।",
        "widget.welcomeMessage": "হাই! আমি {brandName}. সাহায্যের জন্য নতুন চ্যাট শুরু করুন বা চালিয়ে যান।",
        "widget.homeHeroTitle": "{brandName} এর সাথে চ্যাট করুন",
        "widget.homeHeroSubtitle": "দ্রুত উত্তর, ইতিহাস ও সাহায্য পেজ ছাড়াই।",
        "widget.auth.startTrialActivate": "এই চ্যাটবট সক্রিয় করতে ফ্রি ট্রায়াল শুরু করুন।",
        "widget.auth.unauthorized": "অননুমোদিত।",
        "widget.auth.unableAuth": "চ্যাটবট প্রমাণীকরণ করা যায়নি।",
        "widget.auth.notWorking": "এই চ্যাটবট এখন কাজ করছে না। পরে চেষ্টা করুন।",
        "widget.auth.startTrialEnable": "আলাপ ও ফ্লো সক্রিয় করতে ফ্রি ট্রায়াল শুরু করুন।",
        "widget.auth.activateTitle": "চ্যাটবট সক্রিয় করুন",
        "widget.auth.goToDashboard": "ড্যাশবোর্ডে যান",
        "widget.openChatbot": "চ্যাটবট খুলুন",
        "widget.conversation.defaultName": "আলাপ {id}",
        "widget.conversation.defaultShort": "আলাপ",
        "widget.conversation.new": "নতুন আলাপ",
        "widget.conversation.pending": "আলাপ শুরু হচ্ছে...",
        "widget.conversation.openHistory": "আলাপের ইতিহাস দেখতে খুলুন।",
        "widget.handoff.joined": "একজন মানব এজেন্ট চ্যাটে যোগ দিয়েছেন। এখন আপনি রিয়েলটাইমে বার্তা পাঠাতে ও পেতে পারেন।",
        "widget.errors.noResponse": "আমি কোনো উত্তর তৈরি করতে পারিনি। আবার চেষ্টা করুন।",
        "widget.errors.moreContext": "বুকিংয়ের আগে আরও তথ্য দরকার। আবার চেষ্টা করুন।",
        "widget.errors.meetingBooked": "আপনার মিটিং বুক করা হয়েছে। শিগগিরই ক্যালেন্ডার ইনভাইট পাবেন।",
        "widget.errors.bookingConfirmFailed": "দুঃখিত, আমি ওই সময়টি নিশ্চিত করতে পারিনি। অন্যটি বেছে নিন।",
        "widget.errors.connectFailed": "দুঃখিত, সহকারীর সাথে সংযোগে সমস্যা হয়েছে। একটু পর আবার চেষ্টা করুন।",
        "widget.time.justNow": "এইমাত্র",
    },
    ur: {
        "chat.activityProductsFor": "{goal} تلاش کر رہا ہوں…",
        "chat.activityThinking": "آپ کا جواب تیار کر رہا ہوں…",
        "chat.activityProductDetails": "مصنوعات کی تفصیلات جانچ رہا ہوں…",
        "chat.activityProductReview": "مصنوعات کا جائزہ لے رہا ہوں…",
        "chat.activitySending": "آپ کی معلومات بھیج رہا ہوں…",
        "chat.activityHandoff": "انسانی مدد کی درخواست کر رہا ہوں…",
        "chat.activitySupport": "معاونت کی ہدایات پڑھ رہا ہوں…",
        "chat.activityKnowledge": "کاروبار کی معلومات تلاش ہو رہی ہیں…",
        "chat.activityProducts": "مصنوعات تلاش ہو رہی ہیں…",
        "chat.activityAvailability": "دستیابی چیک ہو رہی ہے…",
        "chat.activityBooking": "بکنگ بنائی جا رہی ہے…",
        "chat.activitySaving": "معلومات محفوظ ہو رہی ہیں…",
        "tab.home": "ہوم",
        "tab.history": "تاریخچہ",
        "tab.help": "مدد",
        "home.welcome": "خوش آمدید",
        "home.startFlowChatWith": "{brandName} کے ساتھ فلو چیٹ شروع کریں",
        "home.latestConversation": "آخری گفتگو",
        "chat.placeholder": "کچھ بھی پوچھیں...",
        "chat.send": "پیغام بھیجیں",
        "chat.retryHint": "دوبارہ کوشش آپ کا آخری پیغام دوبارہ بھیجے گی۔",
        "chat.retry": "دوبارہ کوشش",
        "chat.noAvailableTimes": "اس وقت کوئی وقت دستیاب نہیں۔",
        "chat.slots": "{count} اوقات",
        "chat.bookedFor": "{start} - {end} کے لیے بک کیا گیا",
        "chat.unableToConfirm": "اس وقت کی تصدیق نہیں ہو سکی۔ دوسرا وقت آزمائیں۔",
        "chat.timezone": "ٹائم زون: {timezone}",
        "chat.durationMinutes": "{minutes} منٹ",
        "chat.bookingPending": "بکنگ ہو رہی ہے...",
        "chat.booked": "بک ہو گیا",
        "chat.confirmBooking": "بکنگ کی تصدیق کریں",
        "chat.you": "آپ",
        "chat.support": "سپورٹ",
        "history.rename": "نام تبدیل کریں",
        "history.delete": "حذف کریں",
        "history.deleteTitle": "گفتگو حذف کریں؟",
        "history.deleteBody": "یہ گفتگو کو تاریخچے سے ہٹا دے گا۔ واپس نہیں ہو سکتا۔",
        "history.cancel": "منسوخ",
        "history.confirmDelete": "حذف کریں",
        "consent.title": "رازداری کی اطلاع",
        "consent.body": "{brandName} کے ساتھ چیٹ کرنے سے پہلے ہماری رازداری کی پالیسی منظور کریں۔",
        "consent.cta": "میں متفق ہوں اور چیٹ کرنا چاہتا ہوں",
        "header.back": "واپس",
        "header.flowReasoning": "فلو کی وجہ",
        "header.minimize": "چیٹ بوٹ چھوٹا کریں",
        "closedFlows.dismiss": "فلو تجاویز ہٹا دیں",
        "flowDebug.title": "فلو کی وجہ",
        "flowDebug.noActiveFlow": "کوئی فعال فلو نہیں",
        "flowDebug.notUpdated": "ابھی اپ ڈیٹ نہیں ہوا",
        "flowDebug.status": "اسٹیٹس",
        "flowDebug.conversationId": "گفتگو آئی ڈی",
        "flowDebug.flowRunId": "فلو رن آئی ڈی",
        "flowDebug.selectedFlowId": "منتخب فلو آئی ڈی",
        "flowDebug.completion": "تکمیل",
        "flowDebug.isComplete": "مکمل ہے",
        "flowDebug.lastUpdated": "آخری اپ ڈیٹ",
        "flowDebug.missingFields": "گمشدہ فیلڈز",
        "flowDebug.noMissingFields": "کوئی گمشدہ فیلڈ نہیں۔",
        "flowDebug.validationIssues": "ویلیڈیشن مسائل",
        "flowDebug.unknownField": "نامعلوم فیلڈ",
        "flowDebug.noDetails": "کوئی تفصیل نہیں۔",
        "flowDebug.noValidationIssues": "کوئی ویلیڈیشن مسئلہ نہیں۔",
        "flowDebug.routerNotes": "روٹر نوٹس",
        "flowDebug.noRouterDetails": "ابھی کوئی روٹر تفصیلات نہیں۔",
        "flowDebug.close": "فلو کی وجہ بند کریں",
        "flowDebug.yes": "ہاں",
        "flowDebug.no": "نہیں",
        "help.howTitle": "یہ کیسے کام کرتا ہے",
        "help.howBody": "یہ وِجٹ فی الحال صرف فرنٹ اینڈ ہے۔ کنیکٹ ہونے پر یہ {baseUrl} پر ڈیٹا بھیجے گا۔ ماؤنٹ کرتے وقت apiBaseUrl سیٹ کریں۔",
        "help.embedTitle": "ایمبیڈ",
        "help.embedBody": "chatbot-widget.js کو script ٹیگ کے ذریعے شامل کریں۔ ChatbotWidget.mount کو ہدف عنصر کے ساتھ کال کریں یا فلوٹنگ ببل کے لیے اسکرپٹ شامل کریں۔ /chatbot-embed.html والا iframe وہی bundle استعمال کرتا ہے۔",
        "help.themeTitle": "تھیم",
        "help.themeBody": "ایکسینٹ رنگ، بیک گراؤنڈ، ٹیکسٹ اور کونے کے ریڈیئس کے لیے تھیم ویلیوز ایڈجسٹ کریں۔ پوزیشن نیچے بائیں یا نیچے دائیں ہو سکتی ہے۔",
        "widget.welcomeMessage": "ہیلو! میں {brandName} ہوں۔ مدد کے لیے نیا چیٹ شروع کریں یا جاری رکھیں۔",
        "widget.homeHeroTitle": "{brandName} کے ساتھ چیٹ کریں",
        "widget.homeHeroSubtitle": "تیز جوابات، تاریخچہ اور مدد بغیر صفحہ چھوڑے۔",
        "widget.auth.startTrialActivate": "اس چیٹ بوٹ کو فعال کرنے کے لیے مفت ٹرائل شروع کریں۔",
        "widget.auth.unauthorized": "غیر مجاز۔",
        "widget.auth.unableAuth": "چیٹ بوٹ کی تصدیق نہیں ہو سکی۔",
        "widget.auth.notWorking": "یہ چیٹ بوٹ ابھی کام نہیں کر رہا۔ بعد میں کوشش کریں۔",
        "widget.auth.startTrialEnable": "گفتگو اور فلو فعال کرنے کے لیے مفت ٹرائل شروع کریں۔",
        "widget.auth.activateTitle": "چیٹ بوٹ فعال کریں",
        "widget.auth.goToDashboard": "ڈیش بورڈ پر جائیں",
        "widget.openChatbot": "چیٹ بوٹ کھولیں",
        "widget.conversation.defaultName": "گفتگو {id}",
        "widget.conversation.defaultShort": "گفتگو",
        "widget.conversation.new": "نئی گفتگو",
        "widget.conversation.pending": "گفتگو شروع ہو رہی ہے...",
        "widget.conversation.openHistory": "گفتگو کی تاریخ دیکھنے کے لیے کھولیں۔",
        "widget.handoff.joined": "ایک انسانی ایجنٹ چیٹ میں شامل ہوا ہے۔ اب آپ حقیقی وقت میں پیغامات بھیج اور وصول کر سکتے ہیں۔",
        "widget.errors.noResponse": "میں جواب تیار نہیں کر سکا۔ دوبارہ کوشش کریں۔",
        "widget.errors.moreContext": "بکنگ سے پہلے مزید سیاق و سباق درکار ہے۔ دوبارہ کوشش کریں۔",
        "widget.errors.meetingBooked": "آپ کی میٹنگ بک ہو گئی ہے۔ آپ کو جلد ہی کیلنڈر انوائٹ ملے گا۔",
        "widget.errors.bookingConfirmFailed": "معذرت، میں اس وقت کی تصدیق نہیں کر سکا۔ دوسرا منتخب کریں۔",
        "widget.errors.connectFailed": "معذرت، اسسٹنٹ سے کنیکٹ کرنے میں مسئلہ ہوا۔ کچھ دیر بعد دوبارہ کوشش کریں۔",
        "widget.time.justNow": "ابھی ابھی",
    },
    zh: {
        "chat.activityProductsFor": "正在寻找{goal}…",
        "chat.activityThinking": "正在准备回复…",
        "chat.activityProductDetails": "正在核实产品详情…",
        "chat.activityProductReview": "正在筛选产品…",
        "chat.activitySending": "正在发送您的信息…",
        "chat.activityHandoff": "正在请求人工协助…",
        "chat.activitySupport": "正在阅读支持指南…",
        "chat.activityKnowledge": "正在搜索商家信息…",
        "chat.activityProducts": "正在查找产品…",
        "chat.activityAvailability": "正在检查可用时间…",
        "chat.activityBooking": "正在创建预约…",
        "chat.activitySaving": "正在保存信息…",
        "tab.home": "主页",
        "tab.history": "历史",
        "tab.help": "帮助",
        "home.welcome": "欢迎",
        "home.startFlowChatWith": "开始与 {brandName} 的流程聊天",
        "home.latestConversation": "最近的对话",
        "chat.placeholder": "随便问点什么...",
        "chat.send": "发送消息",
        "chat.retryHint": "重试将重新发送上一条消息。",
        "chat.retry": "重试",
        "chat.noAvailableTimes": "目前没有可用时间。",
        "chat.slots": "{count} 个时段",
        "chat.bookedFor": "已预订：{start} - {end}",
        "chat.unableToConfirm": "无法确认此时段。请尝试其他时间。",
        "chat.timezone": "时区：{timezone}",
        "chat.durationMinutes": "{minutes} 分钟",
        "chat.bookingPending": "正在预订...",
        "chat.booked": "已预订",
        "chat.confirmBooking": "确认预订",
        "chat.you": "你",
        "chat.support": "支持",
        "history.rename": "重命名",
        "history.delete": "删除",
        "history.deleteTitle": "删除对话？",
        "history.deleteBody": "这将从历史中移除对话。无法撤销。",
        "history.cancel": "取消",
        "history.confirmDelete": "删除",
        "consent.title": "隐私提示",
        "consent.body": "在与 {brandName} 聊天前，请同意我们的隐私政策。",
        "consent.cta": "我同意并想聊天",
        "header.back": "返回",
        "header.flowReasoning": "流程说明",
        "header.minimize": "最小化聊天机器人",
        "closedFlows.dismiss": "忽略流程建议",
        "flowDebug.title": "流程说明",
        "flowDebug.noActiveFlow": "没有活动流程",
        "flowDebug.notUpdated": "尚未更新",
        "flowDebug.status": "状态",
        "flowDebug.conversationId": "对话 ID",
        "flowDebug.flowRunId": "流程运行 ID",
        "flowDebug.selectedFlowId": "已选流程 ID",
        "flowDebug.completion": "完成情况",
        "flowDebug.isComplete": "已完成",
        "flowDebug.lastUpdated": "最后更新",
        "flowDebug.missingFields": "缺失字段",
        "flowDebug.noMissingFields": "没有缺失字段。",
        "flowDebug.validationIssues": "验证问题",
        "flowDebug.unknownField": "未知字段",
        "flowDebug.noDetails": "无详细信息。",
        "flowDebug.noValidationIssues": "没有验证问题。",
        "flowDebug.routerNotes": "路由备注",
        "flowDebug.noRouterDetails": "尚无路由详情。",
        "flowDebug.close": "关闭流程说明",
        "flowDebug.yes": "是",
        "flowDebug.no": "否",
        "help.howTitle": "工作原理",
        "help.howBody": "该组件目前仅前端。连接后将把数据发送到 {baseUrl}。挂载时配置 apiBaseUrl。",
        "help.embedTitle": "嵌入",
        "help.embedBody": "通过 script 标签引入 chatbot-widget.js。使用目标元素调用 ChatbotWidget.mount，或直接引入脚本生成浮动气泡。/chatbot-embed.html 中的 iframe 使用同一 bundle。",
        "help.themeTitle": "主题",
        "help.themeBody": "调整主题的强调色、背景、文本和圆角半径。位置可为左下或右下。",
        "widget.welcomeMessage": "你好！我是 {brandName}。开始新的对话获取帮助或继续之前的内容。",
        "widget.homeHeroTitle": "与 {brandName} 聊天",
        "widget.homeHeroSubtitle": "快速回答、历史记录和帮助，无需离开页面。",
        "widget.auth.startTrialActivate": "开始免费试用以激活该聊天机器人。",
        "widget.auth.unauthorized": "未授权。",
        "widget.auth.unableAuth": "无法验证聊天机器人。",
        "widget.auth.notWorking": "该聊天机器人当前不可用，请稍后再试。",
        "widget.auth.startTrialEnable": "开始免费试用以启用对话和流程。",
        "widget.auth.activateTitle": "激活聊天机器人",
        "widget.auth.goToDashboard": "前往仪表板",
        "widget.openChatbot": "打开聊天机器人",
        "widget.conversation.defaultName": "对话 {id}",
        "widget.conversation.defaultShort": "对话",
        "widget.conversation.new": "新对话",
        "widget.conversation.pending": "正在开始对话...",
        "widget.conversation.openHistory": "打开查看对话历史。",
        "widget.handoff.joined": "人工客服已加入。你现在可以实时发送和接收消息。",
        "widget.errors.noResponse": "无法生成回复。请再试一次。",
        "widget.errors.moreContext": "预订前需要更多信息，请再试一次。",
        "widget.errors.meetingBooked": "会议已预订。你将很快收到日历邀请。",
        "widget.errors.bookingConfirmFailed": "抱歉，无法确认该时段。请选择其他时间。",
        "widget.errors.connectFailed": "抱歉，连接助手时出现问题。请稍后再试。",
        "widget.time.justNow": "刚刚",
    },
    "zh-cn": {
        "chat.activityProductsFor": "正在寻找{goal}…",
        "chat.activityThinking": "正在准备回复…",
        "chat.activityProductDetails": "正在核实产品详情…",
        "chat.activityProductReview": "正在筛选产品…",
        "chat.activitySending": "正在发送您的信息…",
        "chat.activityHandoff": "正在请求人工协助…",
        "chat.activitySupport": "正在阅读支持指南…",
        "tab.home": "主页",
        "tab.history": "历史",
        "tab.help": "帮助",
        "home.welcome": "欢迎",
        "home.startFlowChatWith": "开始与 {brandName} 的流程聊天",
        "home.latestConversation": "最近的对话",
        "chat.placeholder": "随便问点什么...",
        "chat.send": "发送消息",
        "chat.retryHint": "重试将重新发送上一条消息。",
        "chat.retry": "重试",
        "chat.noAvailableTimes": "目前没有可用时间。",
        "chat.slots": "{count} 个时段",
        "chat.bookedFor": "已预订：{start} - {end}",
        "chat.unableToConfirm": "无法确认此时段。请尝试其他时间。",
        "chat.timezone": "时区：{timezone}",
        "chat.durationMinutes": "{minutes} 分钟",
        "chat.bookingPending": "正在预订...",
        "chat.booked": "已预订",
        "chat.confirmBooking": "确认预订",
        "chat.you": "你",
        "chat.support": "支持",
        "history.rename": "重命名",
        "history.delete": "删除",
        "history.deleteTitle": "删除对话？",
        "history.deleteBody": "这将从历史中移除对话。无法撤销。",
        "history.cancel": "取消",
        "history.confirmDelete": "删除",
        "consent.title": "隐私提示",
        "consent.body": "在与 {brandName} 聊天前，请同意我们的隐私政策。",
        "consent.cta": "我同意并想聊天",
        "header.back": "返回",
        "header.flowReasoning": "流程说明",
        "header.minimize": "最小化聊天机器人",
        "closedFlows.dismiss": "忽略流程建议",
        "flowDebug.title": "流程说明",
        "flowDebug.noActiveFlow": "没有活动流程",
        "flowDebug.notUpdated": "尚未更新",
        "flowDebug.status": "状态",
        "flowDebug.conversationId": "对话 ID",
        "flowDebug.flowRunId": "流程运行 ID",
        "flowDebug.selectedFlowId": "已选流程 ID",
        "flowDebug.completion": "完成情况",
        "flowDebug.isComplete": "已完成",
        "flowDebug.lastUpdated": "最后更新",
        "flowDebug.missingFields": "缺失字段",
        "flowDebug.noMissingFields": "没有缺失字段。",
        "flowDebug.validationIssues": "验证问题",
        "flowDebug.unknownField": "未知字段",
        "flowDebug.noDetails": "无详细信息。",
        "flowDebug.noValidationIssues": "没有验证问题。",
        "flowDebug.routerNotes": "路由备注",
        "flowDebug.noRouterDetails": "尚无路由详情。",
        "flowDebug.close": "关闭流程说明",
        "flowDebug.yes": "是",
        "flowDebug.no": "否",
        "help.howTitle": "工作原理",
        "help.howBody": "该组件目前仅前端。连接后将把数据发送到 {baseUrl}。挂载时配置 apiBaseUrl。",
        "help.embedTitle": "嵌入",
        "help.embedBody": "通过 script 标签引入 chatbot-widget.js。使用目标元素调用 ChatbotWidget.mount，或直接引入脚本生成浮动气泡。/chatbot-embed.html 中的 iframe 使用同一 bundle。",
        "help.themeTitle": "主题",
        "help.themeBody": "调整主题的强调色、背景、文本和圆角半径。位置可为左下或右下。",
        "widget.welcomeMessage": "你好！我是 {brandName}。开始新的对话获取帮助或继续之前的内容。",
        "widget.homeHeroTitle": "与 {brandName} 聊天",
        "widget.homeHeroSubtitle": "快速回答、历史记录和帮助，无需离开页面。",
        "widget.auth.startTrialActivate": "开始免费试用以激活该聊天机器人。",
        "widget.auth.unauthorized": "未授权。",
        "widget.auth.unableAuth": "无法验证聊天机器人。",
        "widget.auth.notWorking": "该聊天机器人当前不可用，请稍后再试。",
        "widget.auth.startTrialEnable": "开始免费试用以启用对话和流程。",
        "widget.auth.activateTitle": "激活聊天机器人",
        "widget.auth.goToDashboard": "前往仪表板",
        "widget.openChatbot": "打开聊天机器人",
        "widget.conversation.defaultName": "对话 {id}",
        "widget.conversation.defaultShort": "对话",
        "widget.conversation.new": "新对话",
        "widget.conversation.pending": "正在开始对话...",
        "widget.conversation.openHistory": "打开查看对话历史。",
        "widget.handoff.joined": "人工客服已加入。你现在可以实时发送和接收消息。",
        "widget.errors.noResponse": "无法生成回复。请再试一次。",
        "widget.errors.moreContext": "预订前需要更多信息，请再试一次。",
        "widget.errors.meetingBooked": "会议已预订。你将很快收到日历邀请。",
        "widget.errors.bookingConfirmFailed": "抱歉，无法确认该时段。请选择其他时间。",
        "widget.errors.connectFailed": "抱歉，连接助手时出现问题。请稍后再试。",
        "widget.time.justNow": "刚刚",
    },
    "zh-tw": {
        "chat.activityProductsFor": "正在尋找{goal}…",
        "chat.activityThinking": "正在準備回覆…",
        "chat.activityProductDetails": "正在核實產品詳情…",
        "chat.activityProductReview": "正在篩選產品…",
        "chat.activitySending": "正在傳送您的資訊…",
        "chat.activityHandoff": "正在請求人工協助…",
        "chat.activitySupport": "正在閱讀支援指南…",
        "tab.home": "首頁",
        "tab.history": "歷史",
        "tab.help": "說明",
        "home.welcome": "歡迎",
        "home.startFlowChatWith": "開始與 {brandName} 的流程聊天",
        "home.latestConversation": "最近的對話",
        "chat.placeholder": "隨便問點什麼...",
        "chat.send": "傳送訊息",
        "chat.retryHint": "重試會重新傳送上一則訊息。",
        "chat.retry": "重試",
        "chat.noAvailableTimes": "目前沒有可用時段。",
        "chat.slots": "{count} 個時段",
        "chat.bookedFor": "已預約：{start} - {end}",
        "chat.unableToConfirm": "無法確認此時段。請嘗試其他時間。",
        "chat.timezone": "時區：{timezone}",
        "chat.durationMinutes": "{minutes} 分鐘",
        "chat.bookingPending": "正在預約...",
        "chat.booked": "已預約",
        "chat.confirmBooking": "確認預約",
        "chat.you": "你",
        "chat.support": "支援",
        "history.rename": "重新命名",
        "history.delete": "刪除",
        "history.deleteTitle": "刪除對話？",
        "history.deleteBody": "這會從歷史中移除對話。無法復原。",
        "history.cancel": "取消",
        "history.confirmDelete": "刪除",
        "consent.title": "隱私提示",
        "consent.body": "在與 {brandName} 聊天前，請同意我們的隱私政策。",
        "consent.cta": "我同意並想聊天",
        "header.back": "返回",
        "header.flowReasoning": "流程說明",
        "header.minimize": "最小化聊天機器人",
        "closedFlows.dismiss": "忽略流程建議",
        "flowDebug.title": "流程說明",
        "flowDebug.noActiveFlow": "沒有活動流程",
        "flowDebug.notUpdated": "尚未更新",
        "flowDebug.status": "狀態",
        "flowDebug.conversationId": "對話 ID",
        "flowDebug.flowRunId": "流程執行 ID",
        "flowDebug.selectedFlowId": "已選流程 ID",
        "flowDebug.completion": "完成狀況",
        "flowDebug.isComplete": "已完成",
        "flowDebug.lastUpdated": "最後更新",
        "flowDebug.missingFields": "缺少欄位",
        "flowDebug.noMissingFields": "沒有缺少欄位。",
        "flowDebug.validationIssues": "驗證問題",
        "flowDebug.unknownField": "未知欄位",
        "flowDebug.noDetails": "沒有詳細資訊。",
        "flowDebug.noValidationIssues": "沒有驗證問題。",
        "flowDebug.routerNotes": "路由備註",
        "flowDebug.noRouterDetails": "尚無路由詳情。",
        "flowDebug.close": "關閉流程說明",
        "flowDebug.yes": "是",
        "flowDebug.no": "否",
        "help.howTitle": "如何運作",
        "help.howBody": "此元件目前僅前端。連線時會將資料送到 {baseUrl}。掛載時設定 apiBaseUrl。",
        "help.embedTitle": "嵌入",
        "help.embedBody": "使用 script 標籤加入 chatbot-widget.js。用目標元素呼叫 ChatbotWidget.mount，或直接加入腳本建立浮動泡泡。/chatbot-embed.html 的 iframe 使用相同 bundle。",
        "help.themeTitle": "主題",
        "help.themeBody": "調整主題的強調色、背景、文字與圓角半徑。位置可為左下或右下。",
        "widget.welcomeMessage": "你好！我是 {brandName}。開始新的對話以取得協助或繼續。",
        "widget.homeHeroTitle": "與 {brandName} 聊天",
        "widget.homeHeroSubtitle": "快速回答、歷史與協助，不用離開頁面。",
        "widget.auth.startTrialActivate": "開始免費試用以啟用此聊天機器人。",
        "widget.auth.unauthorized": "未授權。",
        "widget.auth.unableAuth": "無法驗證聊天機器人。",
        "widget.auth.notWorking": "此聊天機器人目前無法使用，請稍後再試。",
        "widget.auth.startTrialEnable": "開始免費試用以啟用對話與流程。",
        "widget.auth.activateTitle": "啟用聊天機器人",
        "widget.auth.goToDashboard": "前往儀表板",
        "widget.openChatbot": "開啟聊天機器人",
        "widget.conversation.defaultName": "對話 {id}",
        "widget.conversation.defaultShort": "對話",
        "widget.conversation.new": "新對話",
        "widget.conversation.pending": "正在開始對話...",
        "widget.conversation.openHistory": "開啟以查看對話歷史。",
        "widget.handoff.joined": "人工客服已加入。你現在可以即時發送與接收訊息。",
        "widget.errors.noResponse": "無法產生回覆。請再試一次。",
        "widget.errors.moreContext": "預約前需要更多資訊，請再試一次。",
        "widget.errors.meetingBooked": "您的會議已預約。您將很快收到行事曆邀請。",
        "widget.errors.bookingConfirmFailed": "抱歉，無法確認該時段。請選擇其他時間。",
        "widget.errors.connectFailed": "抱歉，連線到助理時出現問題。請稍後再試。",
        "widget.time.justNow": "剛剛",
    },
    ja: {
        "chat.activityProductsFor": "{goal}を探しています…",
        "chat.activityThinking": "回答を準備しています…",
        "chat.activityProductDetails": "商品の詳細を確認しています…",
        "chat.activityProductReview": "商品を選んでいます…",
        "chat.activitySending": "お客様の情報を送信しています…",
        "chat.activityHandoff": "担当者のサポートを依頼しています…",
        "chat.activitySupport": "サポート手順を読んでいます…",
        "chat.activityKnowledge": "事業情報を検索中…",
        "chat.activityProducts": "商品を検索中…",
        "chat.activityAvailability": "空き状況を確認中…",
        "chat.activityBooking": "予約を作成中…",
        "chat.activitySaving": "情報を保存中…",
        "tab.home": "ホーム",
        "tab.history": "履歴",
        "tab.help": "ヘルプ",
        "home.welcome": "ようこそ",
        "home.startFlowChatWith": "{brandName} とのフローチャットを開始",
        "home.latestConversation": "最新の会話",
        "chat.placeholder": "何でも聞いてください...",
        "chat.send": "メッセージを送信",
        "chat.retryHint": "再試行すると最後のメッセージが再送信されます。",
        "chat.retry": "再試行",
        "chat.noAvailableTimes": "現在利用可能な時間はありません。",
        "chat.slots": "{count} 件",
        "chat.bookedFor": "{start} - {end} で予約済み",
        "chat.unableToConfirm": "この時間を確認できませんでした。別の時間を試してください。",
        "chat.timezone": "タイムゾーン: {timezone}",
        "chat.durationMinutes": "{minutes} 分",
        "chat.bookingPending": "予約中...",
        "chat.booked": "予約済み",
        "chat.confirmBooking": "予約を確認",
        "chat.you": "あなた",
        "chat.support": "サポート",
        "history.rename": "名前を変更",
        "history.delete": "削除",
        "history.deleteTitle": "会話を削除しますか？",
        "history.deleteBody": "これにより履歴から会話が削除されます。元に戻せません。",
        "history.cancel": "キャンセル",
        "history.confirmDelete": "削除",
        "consent.title": "プライバシー通知",
        "consent.body": "{brandName} とチャットする前に、プライバシーポリシーに同意してください。",
        "consent.cta": "同意してチャットする",
        "header.back": "戻る",
        "header.flowReasoning": "フローの理由",
        "header.minimize": "チャットボットを最小化",
        "closedFlows.dismiss": "フローの提案を閉じる",
        "flowDebug.title": "フローの理由",
        "flowDebug.noActiveFlow": "アクティブなフローなし",
        "flowDebug.notUpdated": "まだ更新されていません",
        "flowDebug.status": "ステータス",
        "flowDebug.conversationId": "会話ID",
        "flowDebug.flowRunId": "フロー実行ID",
        "flowDebug.selectedFlowId": "選択されたフローID",
        "flowDebug.completion": "完了",
        "flowDebug.isComplete": "完了",
        "flowDebug.lastUpdated": "最終更新",
        "flowDebug.missingFields": "不足フィールド",
        "flowDebug.noMissingFields": "不足フィールドはありません。",
        "flowDebug.validationIssues": "検証の問題",
        "flowDebug.unknownField": "不明なフィールド",
        "flowDebug.noDetails": "詳細はありません。",
        "flowDebug.noValidationIssues": "検証の問題はありません。",
        "flowDebug.routerNotes": "ルーターノート",
        "flowDebug.noRouterDetails": "ルーターの詳細はまだありません。",
        "flowDebug.close": "フローの理由を閉じる",
        "flowDebug.yes": "はい",
        "flowDebug.no": "いいえ",
        "help.howTitle": "仕組み",
        "help.howBody": "このウィジェットは現在フロントエンドのみです。接続時に {baseUrl} にデータを送信します。マウント時に apiBaseUrl を設定してください。",
        "help.embedTitle": "埋め込み",
        "help.embedBody": "chatbot-widget.js を script タグで読み込みます。ターゲット要素で ChatbotWidget.mount を呼び出すか、スクリプトを追加してフローティングバブルを作成します。/chatbot-embed.html の iframe は同じ bundle を使用します。",
        "help.themeTitle": "テーマ",
        "help.themeBody": "アクセントカラー、背景、テキスト、角丸半径のテーマ値を調整します。位置は左下または右下にできます。",
        "widget.welcomeMessage": "こんにちは！私は {brandName} です。新しいチャットを始めるか、続きから再開できます。",
        "widget.homeHeroTitle": "{brandName} とチャット",
        "widget.homeHeroSubtitle": "素早い回答、履歴、ヘルプをページを離れずに確認できます。",
        "widget.auth.startTrialActivate": "このチャットボットを有効化するために無料トライアルを開始してください。",
        "widget.auth.unauthorized": "未認証です。",
        "widget.auth.unableAuth": "チャットボットを認証できません。",
        "widget.auth.notWorking": "このチャットボットは現在動作していません。後でもう一度試してください。",
        "widget.auth.startTrialEnable": "会話とフローを有効化するために無料トライアルを開始してください。",
        "widget.auth.activateTitle": "チャットボットを有効化",
        "widget.auth.goToDashboard": "ダッシュボードへ",
        "widget.openChatbot": "チャットボットを開く",
        "widget.conversation.defaultName": "会話 {id}",
        "widget.conversation.defaultShort": "会話",
        "widget.conversation.new": "新しい会話",
        "widget.conversation.pending": "会話を開始しています...",
        "widget.conversation.openHistory": "開いて会話履歴を表示します。",
        "widget.handoff.joined": "担当者がチャットに参加しました。リアルタイムで送受信できます。",
        "widget.errors.noResponse": "回答を生成できませんでした。もう一度お試しください。",
        "widget.errors.moreContext": "予約の前にもう少し情報が必要です。もう一度お試しください。",
        "widget.errors.meetingBooked": "ミーティングが予約されました。まもなくカレンダー招待が届きます。",
        "widget.errors.bookingConfirmFailed": "申し訳ありませんが、その時間を確認できませんでした。別の時間を選んでください。",
        "widget.errors.connectFailed": "申し訳ありませんが、アシスタントへの接続に問題がありました。少ししてからもう一度お試しください。",
        "widget.time.justNow": "たった今",
    },
    ko: {
        "chat.activityProductsFor": "{goal} 검색 중…",
        "chat.activityThinking": "답변을 준비하고 있어요…",
        "chat.activityProductDetails": "제품 세부 정보를 확인하고 있어요…",
        "chat.activityProductReview": "제품을 검토하고 있어요…",
        "chat.activitySending": "고객님의 정보를 보내고 있어요…",
        "chat.activityHandoff": "상담원 도움을 요청하고 있어요…",
        "chat.activitySupport": "지원 안내를 읽고 있어요…",
        "chat.activityKnowledge": "업체 정보 검색 중…",
        "chat.activityProducts": "제품 검색 중…",
        "chat.activityAvailability": "예약 가능 시간 확인 중…",
        "chat.activityBooking": "예약 생성 중…",
        "chat.activitySaving": "정보 저장 중…",
        "tab.home": "홈",
        "tab.history": "기록",
        "tab.help": "도움말",
        "home.welcome": "환영합니다",
        "home.startFlowChatWith": "{brandName}와 플로우 채팅 시작",
        "home.latestConversation": "최근 대화",
        "chat.placeholder": "무엇이든 질문하세요...",
        "chat.send": "메시지 보내기",
        "chat.retryHint": "다시 시도하면 마지막 메시지가 재전송됩니다.",
        "chat.retry": "다시 시도",
        "chat.noAvailableTimes": "현재 가능한 시간이 없습니다.",
        "chat.slots": "{count}개 슬롯",
        "chat.bookedFor": "{start} - {end} 예약됨",
        "chat.unableToConfirm": "이 시간을 확인할 수 없습니다. 다른 시간을 선택하세요.",
        "chat.timezone": "시간대: {timezone}",
        "chat.durationMinutes": "{minutes}분",
        "chat.bookingPending": "예약 중...",
        "chat.booked": "예약됨",
        "chat.confirmBooking": "예약 확인",
        "chat.you": "나",
        "chat.support": "지원",
        "history.rename": "이름 변경",
        "history.delete": "삭제",
        "history.deleteTitle": "대화를 삭제할까요?",
        "history.deleteBody": "이 작업은 대화를 기록에서 제거합니다. 되돌릴 수 없습니다.",
        "history.cancel": "취소",
        "history.confirmDelete": "삭제",
        "consent.title": "개인정보 안내",
        "consent.body": "{brandName}와 대화하기 전에 개인정보 처리방침에 동의해 주세요.",
        "consent.cta": "동의하고 대화하기",
        "header.back": "뒤로",
        "header.flowReasoning": "플로우 설명",
        "header.minimize": "챗봇 최소화",
        "closedFlows.dismiss": "플로우 제안 닫기",
        "flowDebug.title": "플로우 설명",
        "flowDebug.noActiveFlow": "활성 플로우 없음",
        "flowDebug.notUpdated": "아직 업데이트되지 않음",
        "flowDebug.status": "상태",
        "flowDebug.conversationId": "대화 ID",
        "flowDebug.flowRunId": "플로우 실행 ID",
        "flowDebug.selectedFlowId": "선택된 플로우 ID",
        "flowDebug.completion": "완료",
        "flowDebug.isComplete": "완료됨",
        "flowDebug.lastUpdated": "마지막 업데이트",
        "flowDebug.missingFields": "누락된 필드",
        "flowDebug.noMissingFields": "누락된 필드 없음.",
        "flowDebug.validationIssues": "유효성 문제",
        "flowDebug.unknownField": "알 수 없는 필드",
        "flowDebug.noDetails": "세부 정보 없음.",
        "flowDebug.noValidationIssues": "유효성 문제 없음.",
        "flowDebug.routerNotes": "라우터 메모",
        "flowDebug.noRouterDetails": "라우터 세부 정보 없음.",
        "flowDebug.close": "플로우 설명 닫기",
        "flowDebug.yes": "예",
        "flowDebug.no": "아니오",
        "help.howTitle": "작동 방식",
        "help.howBody": "이 위젯은 현재 프론트엔드 전용입니다. 연결되면 {baseUrl}로 데이터를 전송합니다. 마운트 시 apiBaseUrl을 설정하세요.",
        "help.embedTitle": "임베드",
        "help.embedBody": "script 태그로 chatbot-widget.js를 포함하세요. ChatbotWidget.mount를 대상 요소로 호출하거나 스크립트를 추가해 플로팅 버블을 만듭니다. /chatbot-embed.html iframe은 같은 번들을 사용합니다.",
        "help.themeTitle": "테마",
        "help.themeBody": "강조색, 배경, 텍스트, 모서리 반경을 테마 값으로 조정하세요. 위치는 좌하단 또는 우하단이 될 수 있습니다.",
        "widget.welcomeMessage": "안녕하세요! 저는 {brandName}입니다. 새 대화를 시작하거나 이어서 진행하세요.",
        "widget.homeHeroTitle": "{brandName}와 채팅하기",
        "widget.homeHeroSubtitle": "빠른 답변, 기록, 도움말을 페이지를 떠나지 않고 확인하세요.",
        "widget.auth.startTrialActivate": "이 챗봇을 활성화하려면 무료 체험을 시작하세요.",
        "widget.auth.unauthorized": "인증되지 않았습니다.",
        "widget.auth.unableAuth": "챗봇을 인증할 수 없습니다.",
        "widget.auth.notWorking": "이 챗봇은 현재 작동하지 않습니다. 나중에 다시 시도하세요.",
        "widget.auth.startTrialEnable": "대화와 플로우를 활성화하려면 무료 체험을 시작하세요.",
        "widget.auth.activateTitle": "챗봇 활성화",
        "widget.auth.goToDashboard": "대시보드로 이동",
        "widget.openChatbot": "챗봇 열기",
        "widget.conversation.defaultName": "대화 {id}",
        "widget.conversation.defaultShort": "대화",
        "widget.conversation.new": "새 대화",
        "widget.conversation.pending": "대화를 시작하는 중...",
        "widget.conversation.openHistory": "열어 대화 기록을 확인하세요.",
        "widget.handoff.joined": "상담원이 채팅에 참여했습니다. 이제 실시간으로 메시지를 주고받을 수 있습니다.",
        "widget.errors.noResponse": "응답을 생성하지 못했습니다. 다시 시도하세요.",
        "widget.errors.moreContext": "예약 전에 더 많은 정보가 필요합니다. 다시 시도하세요.",
        "widget.errors.meetingBooked": "회의가 예약되었습니다. 곧 일정 초대가 도착합니다.",
        "widget.errors.bookingConfirmFailed": "죄송합니다. 해당 시간을 확인할 수 없습니다. 다른 시간을 선택하세요.",
        "widget.errors.connectFailed": "죄송합니다. 어시스턴트와의 연결에 문제가 있었습니다. 잠시 후 다시 시도하세요.",
        "widget.time.justNow": "방금",
    },
    vi: {
        "chat.activityProductsFor": "Đang tìm {goal}…",
        "chat.activityThinking": "Đang chuẩn bị câu trả lời…",
        "chat.activityProductDetails": "Đang kiểm tra chi tiết sản phẩm…",
        "chat.activityProductReview": "Đang xem xét sản phẩm…",
        "chat.activitySending": "Đang gửi thông tin của bạn…",
        "chat.activityHandoff": "Đang yêu cầu hỗ trợ từ nhân viên…",
        "chat.activitySupport": "Đang đọc hướng dẫn hỗ trợ…",
        "chat.activityKnowledge": "Đang tìm thông tin doanh nghiệp…",
        "chat.activityProducts": "Đang tìm sản phẩm…",
        "chat.activityAvailability": "Đang kiểm tra lịch trống…",
        "chat.activityBooking": "Đang tạo lịch hẹn…",
        "chat.activitySaving": "Đang lưu thông tin…",
        "tab.home": "Trang chủ",
        "tab.history": "Lịch sử",
        "tab.help": "Trợ giúp",
        "home.welcome": "Chào mừng",
        "home.startFlowChatWith": "Bắt đầu chat luồng với {brandName}",
        "home.latestConversation": "Cuộc trò chuyện gần nhất",
        "chat.placeholder": "Hỏi bất cứ điều gì...",
        "chat.send": "Gửi tin nhắn",
        "chat.retryHint": "Thử lại sẽ gửi lại tin nhắn cuối.",
        "chat.retry": "Thử lại",
        "chat.noAvailableTimes": "Hiện không có thời gian trống.",
        "chat.slots": "{count} khung giờ",
        "chat.bookedFor": "Đã đặt cho {start} - {end}",
        "chat.unableToConfirm": "Không thể xác nhận khung giờ này. Hãy chọn thời gian khác.",
        "chat.timezone": "Múi giờ: {timezone}",
        "chat.durationMinutes": "{minutes} phút",
        "chat.bookingPending": "Đang đặt lịch...",
        "chat.booked": "Đã đặt",
        "chat.confirmBooking": "Xác nhận đặt lịch",
        "chat.you": "Bạn",
        "chat.support": "Hỗ trợ",
        "history.rename": "Đổi tên",
        "history.delete": "Xóa",
        "history.deleteTitle": "Xóa cuộc trò chuyện?",
        "history.deleteBody": "Thao tác này sẽ xóa cuộc trò chuyện khỏi lịch sử. Không thể hoàn tác.",
        "history.cancel": "Hủy",
        "history.confirmDelete": "Xóa",
        "consent.title": "Thông báo quyền riêng tư",
        "consent.body": "Trước khi chat với {brandName}, vui lòng đồng ý chính sách quyền riêng tư.",
        "consent.cta": "Tôi đồng ý và muốn chat",
        "header.back": "Quay lại",
        "header.flowReasoning": "Lý do luồng",
        "header.minimize": "Thu nhỏ chatbot",
        "closedFlows.dismiss": "Bỏ qua gợi ý luồng",
        "flowDebug.title": "Lý do luồng",
        "flowDebug.noActiveFlow": "Không có luồng đang hoạt động",
        "flowDebug.notUpdated": "Chưa được cập nhật",
        "flowDebug.status": "Trạng thái",
        "flowDebug.conversationId": "ID cuộc trò chuyện",
        "flowDebug.flowRunId": "ID chạy luồng",
        "flowDebug.selectedFlowId": "ID luồng được chọn",
        "flowDebug.completion": "Hoàn tất",
        "flowDebug.isComplete": "Đã hoàn tất",
        "flowDebug.lastUpdated": "Cập nhật lần cuối",
        "flowDebug.missingFields": "Thiếu trường",
        "flowDebug.noMissingFields": "Không thiếu trường nào.",
        "flowDebug.validationIssues": "Lỗi xác thực",
        "flowDebug.unknownField": "Trường không xác định",
        "flowDebug.noDetails": "Không có chi tiết.",
        "flowDebug.noValidationIssues": "Không có lỗi xác thực.",
        "flowDebug.routerNotes": "Ghi chú bộ định tuyến",
        "flowDebug.noRouterDetails": "Chưa có chi tiết bộ định tuyến.",
        "flowDebug.close": "Đóng lý do luồng",
        "flowDebug.yes": "Có",
        "flowDebug.no": "Không",
        "help.howTitle": "Cách hoạt động",
        "help.howBody": "Widget này hiện chỉ ở frontend. Khi kết nối, nó sẽ gửi dữ liệu đến {baseUrl}. Cấu hình apiBaseUrl khi mount.",
        "help.embedTitle": "Nhúng",
        "help.embedBody": "Nhúng chatbot-widget.js qua thẻ script. Gọi ChatbotWidget.mount với phần tử mục tiêu hoặc thêm script để tạo bong bóng nổi. Iframe tại /chatbot-embed.html dùng cùng bundle.",
        "help.themeTitle": "Giao diện",
        "help.themeBody": "Điều chỉnh màu nhấn, nền, chữ và bo góc. Vị trí có thể là dưới-trái hoặc dưới-phải.",
        "widget.welcomeMessage": "Xin chào! Tôi là {brandName}. Bắt đầu chat mới để tìm trợ giúp hoặc tiếp tục.",
        "widget.homeHeroTitle": "Chat với {brandName}",
        "widget.homeHeroSubtitle": "Câu trả lời nhanh, lịch sử và trợ giúp mà không rời trang.",
        "widget.auth.startTrialActivate": "Bắt đầu dùng thử miễn phí để kích hoạt chatbot này.",
        "widget.auth.unauthorized": "Không được ủy quyền.",
        "widget.auth.unableAuth": "Không thể xác thực chatbot.",
        "widget.auth.notWorking": "Chatbot này hiện không hoạt động. Hãy thử lại sau.",
        "widget.auth.startTrialEnable": "Bắt đầu dùng thử miễn phí để bật hội thoại và luồng.",
        "widget.auth.activateTitle": "Kích hoạt chatbot",
        "widget.auth.goToDashboard": "Đi tới bảng điều khiển",
        "widget.openChatbot": "Mở chatbot",
        "widget.conversation.defaultName": "Cuộc trò chuyện {id}",
        "widget.conversation.defaultShort": "Cuộc trò chuyện",
        "widget.conversation.new": "Cuộc trò chuyện mới",
        "widget.conversation.pending": "Đang bắt đầu cuộc trò chuyện...",
        "widget.conversation.openHistory": "Mở để xem lịch sử cuộc trò chuyện.",
        "widget.handoff.joined": "Một nhân viên đã tham gia cuộc trò chuyện. Bạn có thể gửi và nhận tin nhắn theo thời gian thực.",
        "widget.errors.noResponse": "Tôi không thể tạo phản hồi. Vui lòng thử lại.",
        "widget.errors.moreContext": "Tôi cần thêm ngữ cảnh trước khi đặt lịch. Vui lòng thử lại.",
        "widget.errors.meetingBooked": "Cuộc hẹn của bạn đã được đặt. Bạn sẽ sớm nhận được lời mời lịch.",
        "widget.errors.bookingConfirmFailed": "Xin lỗi, tôi không thể xác nhận khung giờ đó. Hãy chọn thời gian khác.",
        "widget.errors.connectFailed": "Xin lỗi, tôi gặp sự cố khi kết nối với trợ lý. Vui lòng thử lại sau.",
        "widget.time.justNow": "Vừa xong",
    },
    th: {
        "chat.activityProductsFor": "กำลังค้นหา {goal}…",
        "chat.activityThinking": "กำลังเตรียมคำตอบ…",
        "chat.activityProductDetails": "กำลังตรวจสอบรายละเอียดสินค้า…",
        "chat.activityProductReview": "กำลังพิจารณาสินค้า…",
        "chat.activitySending": "กำลังส่งข้อมูลของคุณ…",
        "chat.activityHandoff": "กำลังขอความช่วยเหลือจากเจ้าหน้าที่…",
        "chat.activitySupport": "กำลังอ่านคำแนะนำการช่วยเหลือ…",
        "chat.activityKnowledge": "กำลังค้นหาข้อมูลธุรกิจ…",
        "chat.activityProducts": "กำลังค้นหาผลิตภัณฑ์…",
        "chat.activityAvailability": "กำลังตรวจสอบเวลาว่าง…",
        "chat.activityBooking": "กำลังสร้างการจอง…",
        "chat.activitySaving": "กำลังบันทึกข้อมูล…",
        "tab.home": "หน้าแรก",
        "tab.history": "ประวัติ",
        "tab.help": "ช่วยเหลือ",
        "home.welcome": "ยินดีต้อนรับ",
        "home.startFlowChatWith": "เริ่มแชทโฟลว์กับ {brandName}",
        "home.latestConversation": "บทสนทนาล่าสุด",
        "chat.placeholder": "ถามอะไรก็ได้...",
        "chat.send": "ส่งข้อความ",
        "chat.retryHint": "ลองใหม่จะส่งข้อความล่าสุดอีกครั้ง",
        "chat.retry": "ลองใหม่",
        "chat.noAvailableTimes": "ไม่มีเวลาว่างในขณะนี้",
        "chat.slots": "{count} ช่วงเวลา",
        "chat.bookedFor": "จองสำหรับ {start} - {end}",
        "chat.unableToConfirm": "ไม่สามารถยืนยันช่วงเวลานี้ได้ ลองช่วงเวลาอื่น",
        "chat.timezone": "เขตเวลา: {timezone}",
        "chat.durationMinutes": "{minutes} นาที",
        "chat.bookingPending": "กำลังจอง...",
        "chat.booked": "จองแล้ว",
        "chat.confirmBooking": "ยืนยันการจอง",
        "chat.you": "คุณ",
        "chat.support": "ซัพพอร์ต",
        "history.rename": "เปลี่ยนชื่อ",
        "history.delete": "ลบ",
        "history.deleteTitle": "ลบบทสนทนา?",
        "history.deleteBody": "การลบนี้จะนำบทสนทนาออกจากประวัติ ไม่สามารถย้อนกลับได้",
        "history.cancel": "ยกเลิก",
        "history.confirmDelete": "ลบ",
        "consent.title": "ประกาศความเป็นส่วนตัว",
        "consent.body": "ก่อนแชทกับ {brandName} โปรดยอมรับนโยบายความเป็นส่วนตัวของเรา",
        "consent.cta": "ฉันยอมรับและต้องการแชท",
        "header.back": "ย้อนกลับ",
        "header.flowReasoning": "เหตุผลของโฟลว์",
        "header.minimize": "ย่อแชทบอท",
        "closedFlows.dismiss": "ปิดข้อเสนอแนะโฟลว์",
        "flowDebug.title": "เหตุผลของโฟลว์",
        "flowDebug.noActiveFlow": "ไม่มีโฟลว์ที่ใช้งานอยู่",
        "flowDebug.notUpdated": "ยังไม่ได้อัปเดต",
        "flowDebug.status": "สถานะ",
        "flowDebug.conversationId": "รหัสบทสนทนา",
        "flowDebug.flowRunId": "รหัสการรันโฟลว์",
        "flowDebug.selectedFlowId": "รหัสโฟลว์ที่เลือก",
        "flowDebug.completion": "การเสร็จสิ้น",
        "flowDebug.isComplete": "เสร็จสิ้น",
        "flowDebug.lastUpdated": "อัปเดตล่าสุด",
        "flowDebug.missingFields": "ฟิลด์ที่ขาดหายไป",
        "flowDebug.noMissingFields": "ไม่มีฟิลด์ที่ขาดหายไป",
        "flowDebug.validationIssues": "ปัญหาการตรวจสอบ",
        "flowDebug.unknownField": "ฟิลด์ที่ไม่รู้จัก",
        "flowDebug.noDetails": "ไม่มีรายละเอียด",
        "flowDebug.noValidationIssues": "ไม่มีปัญหาการตรวจสอบ",
        "flowDebug.routerNotes": "บันทึกเราเตอร์",
        "flowDebug.noRouterDetails": "ยังไม่มีรายละเอียดเราเตอร์",
        "flowDebug.close": "ปิดเหตุผลของโฟลว์",
        "flowDebug.yes": "ใช่",
        "flowDebug.no": "ไม่ใช่",
        "help.howTitle": "วิธีการทำงาน",
        "help.howBody": "วิดเจ็ตนี้เป็นเพียงฝั่งหน้าเว็บในขณะนี้ เมื่อเชื่อมต่อจะส่งข้อมูลไปที่ {baseUrl} ตั้งค่า apiBaseUrl ตอน mount",
        "help.embedTitle": "การฝัง",
        "help.embedBody": "รวม chatbot-widget.js ผ่านแท็ก script เรียก ChatbotWidget.mount ด้วยองค์ประกอบเป้าหมาย หรือใส่สคริปต์เพื่อสร้างบับเบิลลอย Iframe ที่ /chatbot-embed.html ใช้ bundle เดียวกัน",
        "help.themeTitle": "ธีม",
        "help.themeBody": "ปรับค่าสีเน้น พื้นหลัง ข้อความ และรัศมีมุม ตำแหน่งสามารถเป็นล่างซ้ายหรือล่างขวา",
        "widget.welcomeMessage": "สวัสดี! ฉันคือ {brandName} เริ่มแชทใหม่เพื่อขอความช่วยเหลือหรือดำเนินต่อ",
        "widget.homeHeroTitle": "แชทกับ {brandName}",
        "widget.homeHeroSubtitle": "คำตอบรวดเร็ว ประวัติ และความช่วยเหลือโดยไม่ต้องออกจากหน้า",
        "widget.auth.startTrialActivate": "เริ่มทดลองใช้งานฟรีเพื่อเปิดใช้งานแชทบอทนี้",
        "widget.auth.unauthorized": "ไม่ได้รับอนุญาต",
        "widget.auth.unableAuth": "ไม่สามารถยืนยันตัวตนของแชทบอทได้",
        "widget.auth.notWorking": "แชทบอทนี้ไม่ทำงานในขณะนี้ กรุณาลองใหม่ภายหลัง",
        "widget.auth.startTrialEnable": "เริ่มทดลองใช้งานฟรีเพื่อเปิดใช้งานการสนทนาและโฟลว์",
        "widget.auth.activateTitle": "เปิดใช้งานแชทบอท",
        "widget.auth.goToDashboard": "ไปที่แดชบอร์ด",
        "widget.openChatbot": "เปิดแชทบอท",
        "widget.conversation.defaultName": "บทสนทนา {id}",
        "widget.conversation.defaultShort": "บทสนทนา",
        "widget.conversation.new": "บทสนทนาใหม่",
        "widget.conversation.pending": "กำลังเริ่มบทสนทนา...",
        "widget.conversation.openHistory": "เปิดเพื่อดูประวัติการสนทนา",
        "widget.handoff.joined": "เจ้าหน้าที่มนุษย์เข้าร่วมการสนทนาแล้ว ตอนนี้คุณสามารถส่งและรับข้อความแบบเรียลไทม์ได้",
        "widget.errors.noResponse": "ไม่สามารถสร้างคำตอบได้ กรุณาลองใหม่",
        "widget.errors.moreContext": "ต้องการข้อมูลเพิ่มเติมก่อนการจอง กรุณาลองใหม่",
        "widget.errors.meetingBooked": "การประชุมของคุณถูกจองแล้ว คุณจะได้รับคำเชิญปฏิทินในไม่ช้า",
        "widget.errors.bookingConfirmFailed": "ขออภัย ฉันไม่สามารถยืนยันช่วงเวลานั้นได้ กรุณาเลือกเวลาอื่น",
        "widget.errors.connectFailed": "ขออภัย มีปัญหาในการเชื่อมต่อกับผู้ช่วย กรุณาลองใหม่อีกครั้ง",
        "widget.time.justNow": "เมื่อสักครู่",
    },
    id: {
        "chat.activityProductsFor": "Mencari {goal}…",
        "chat.activityThinking": "Menyiapkan jawaban Anda…",
        "chat.activityProductDetails": "Memeriksa detail produk…",
        "chat.activityProductReview": "Meninjau produk…",
        "chat.activitySending": "Mengirim informasi Anda…",
        "chat.activityHandoff": "Meminta bantuan petugas…",
        "chat.activitySupport": "Membaca panduan dukungan…",
        "chat.activityKnowledge": "Mencari informasi bisnis…",
        "chat.activityProducts": "Mencari produk…",
        "chat.activityAvailability": "Memeriksa ketersediaan…",
        "chat.activityBooking": "Membuat pemesanan…",
        "chat.activitySaving": "Menyimpan informasi…",
        "tab.home": "Beranda",
        "tab.history": "Riwayat",
        "tab.help": "Bantuan",
        "home.welcome": "Selamat datang",
        "home.startFlowChatWith": "Mulai chat alur dengan {brandName}",
        "home.latestConversation": "Percakapan terakhir",
        "chat.placeholder": "Tanyakan apa saja...",
        "chat.send": "Kirim pesan",
        "chat.retryHint": "Coba lagi akan mengirim ulang pesan terakhir Anda.",
        "chat.retry": "Coba lagi",
        "chat.noAvailableTimes": "Tidak ada waktu tersedia saat ini.",
        "chat.slots": "{count} slot",
        "chat.bookedFor": "Dipesan untuk {start} - {end}",
        "chat.unableToConfirm": "Tidak dapat mengonfirmasi waktu ini. Coba waktu lain.",
        "chat.timezone": "Zona waktu: {timezone}",
        "chat.durationMinutes": "{minutes} menit",
        "chat.bookingPending": "Memesan...",
        "chat.booked": "Dipesan",
        "chat.confirmBooking": "Konfirmasi pemesanan",
        "chat.you": "Anda",
        "chat.support": "Dukungan",
        "history.rename": "Ganti nama",
        "history.delete": "Hapus",
        "history.deleteTitle": "Hapus percakapan?",
        "history.deleteBody": "Ini akan menghapus percakapan dari riwayat. Tidak dapat dibatalkan.",
        "history.cancel": "Batal",
        "history.confirmDelete": "Hapus",
        "consent.title": "Pemberitahuan privasi",
        "consent.body": "Sebelum mengobrol dengan {brandName}, setujui kebijakan privasi kami.",
        "consent.cta": "Saya setuju dan ingin mengobrol",
        "header.back": "Kembali",
        "header.flowReasoning": "Alasan alur",
        "header.minimize": "Minimalkan chatbot",
        "closedFlows.dismiss": "Tutup saran alur",
        "flowDebug.title": "Alasan alur",
        "flowDebug.noActiveFlow": "Tidak ada alur aktif",
        "flowDebug.notUpdated": "Belum diperbarui",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID percakapan",
        "flowDebug.flowRunId": "ID eksekusi alur",
        "flowDebug.selectedFlowId": "ID alur terpilih",
        "flowDebug.completion": "Penyelesaian",
        "flowDebug.isComplete": "Selesai",
        "flowDebug.lastUpdated": "Terakhir diperbarui",
        "flowDebug.missingFields": "Bidang hilang",
        "flowDebug.noMissingFields": "Tidak ada bidang hilang.",
        "flowDebug.validationIssues": "Masalah validasi",
        "flowDebug.unknownField": "Bidang tidak dikenal",
        "flowDebug.noDetails": "Tidak ada detail.",
        "flowDebug.noValidationIssues": "Tidak ada masalah validasi.",
        "flowDebug.routerNotes": "Catatan router",
        "flowDebug.noRouterDetails": "Belum ada detail router.",
        "flowDebug.close": "Tutup alasan alur",
        "flowDebug.yes": "Ya",
        "flowDebug.no": "Tidak",
        "help.howTitle": "Cara kerja",
        "help.howBody": "Widget ini saat ini hanya frontend. Saat terhubung, ia mengirim data ke {baseUrl}. Atur apiBaseUrl saat mount.",
        "help.embedTitle": "Penyematan",
        "help.embedBody": "Sertakan chatbot-widget.js melalui tag script. Panggil ChatbotWidget.mount dengan elemen target atau sertakan script untuk membuat gelembung melayang. Iframe di /chatbot-embed.html menggunakan bundle yang sama.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Sesuaikan nilai tema untuk warna aksen, latar, teks, dan radius sudut. Posisi bisa kiri bawah atau kanan bawah.",
        "widget.welcomeMessage": "Hai! Saya {brandName}. Mulai chat baru untuk bantuan atau melanjutkan.",
        "widget.homeHeroTitle": "Chat dengan {brandName}",
        "widget.homeHeroSubtitle": "Jawaban cepat, riwayat, dan bantuan tanpa meninggalkan halaman.",
        "widget.auth.startTrialActivate": "Mulai uji coba gratis untuk mengaktifkan chatbot ini.",
        "widget.auth.unauthorized": "Tidak berwenang.",
        "widget.auth.unableAuth": "Tidak dapat mengautentikasi chatbot.",
        "widget.auth.notWorking": "Chatbot ini sedang tidak berfungsi. Coba lagi nanti.",
        "widget.auth.startTrialEnable": "Mulai uji coba gratis untuk mengaktifkan percakapan dan alur.",
        "widget.auth.activateTitle": "Aktifkan chatbot",
        "widget.auth.goToDashboard": "Ke dashboard",
        "widget.openChatbot": "Buka chatbot",
        "widget.conversation.defaultName": "Percakapan {id}",
        "widget.conversation.defaultShort": "Percakapan",
        "widget.conversation.new": "Percakapan baru",
        "widget.conversation.pending": "Memulai percakapan...",
        "widget.conversation.openHistory": "Buka untuk melihat riwayat percakapan.",
        "widget.handoff.joined": "Agen manusia telah bergabung. Anda sekarang dapat mengirim dan menerima pesan secara real-time.",
        "widget.errors.noResponse": "Saya tidak dapat membuat respons. Silakan coba lagi.",
        "widget.errors.moreContext": "Saya membutuhkan lebih banyak konteks sebelum pemesanan. Silakan coba lagi.",
        "widget.errors.meetingBooked": "Pertemuan Anda sudah dipesan. Anda akan segera menerima undangan kalender.",
        "widget.errors.bookingConfirmFailed": "Maaf, saya tidak bisa mengonfirmasi waktu itu. Pilih waktu lain.",
        "widget.errors.connectFailed": "Maaf, saya mengalami masalah saat menghubungkan ke asisten. Silakan coba lagi sebentar lagi.",
        "widget.time.justNow": "Baru saja",
    },
    ms: {
        "chat.activityProductsFor": "Mencari {goal}…",
        "chat.activityThinking": "Menyediakan jawapan anda…",
        "chat.activityProductDetails": "Menyemak butiran produk…",
        "chat.activityProductReview": "Menilai produk…",
        "chat.activitySending": "Menghantar maklumat anda…",
        "chat.activityHandoff": "Meminta bantuan manusia…",
        "chat.activitySupport": "Membaca panduan sokongan…",
        "chat.activityKnowledge": "Mencari maklumat perniagaan…",
        "chat.activityProducts": "Mencari produk…",
        "chat.activityAvailability": "Menyemak ketersediaan…",
        "chat.activityBooking": "Membuat tempahan…",
        "chat.activitySaving": "Menyimpan maklumat…",
        "tab.home": "Laman utama",
        "tab.history": "Sejarah",
        "tab.help": "Bantuan",
        "home.welcome": "Selamat datang",
        "home.startFlowChatWith": "Mulakan chat aliran dengan {brandName}",
        "home.latestConversation": "Perbualan terakhir",
        "chat.placeholder": "Tanya apa sahaja...",
        "chat.send": "Hantar mesej",
        "chat.retryHint": "Cuba lagi akan menghantar semula mesej terakhir anda.",
        "chat.retry": "Cuba lagi",
        "chat.noAvailableTimes": "Tiada masa tersedia sekarang.",
        "chat.slots": "{count} slot",
        "chat.bookedFor": "Ditempah untuk {start} - {end}",
        "chat.unableToConfirm": "Tidak dapat mengesahkan masa ini. Cuba masa lain.",
        "chat.timezone": "Zon masa: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Menempah...",
        "chat.booked": "Ditempah",
        "chat.confirmBooking": "Sahkan tempahan",
        "chat.you": "Anda",
        "chat.support": "Sokongan",
        "history.rename": "Tukar nama",
        "history.delete": "Padam",
        "history.deleteTitle": "Padam perbualan?",
        "history.deleteBody": "Ini akan mengalih keluar perbualan daripada sejarah. Tidak boleh dibatalkan.",
        "history.cancel": "Batal",
        "history.confirmDelete": "Padam",
        "consent.title": "Notis privasi",
        "consent.body": "Sebelum bersembang dengan {brandName}, sila setuju dengan polisi privasi kami.",
        "consent.cta": "Saya setuju dan ingin bersembang",
        "header.back": "Kembali",
        "header.flowReasoning": "Sebab aliran",
        "header.minimize": "Minimakan chatbot",
        "closedFlows.dismiss": "Tolak cadangan aliran",
        "flowDebug.title": "Sebab aliran",
        "flowDebug.noActiveFlow": "Tiada aliran aktif",
        "flowDebug.notUpdated": "Belum dikemas kini",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID perbualan",
        "flowDebug.flowRunId": "ID larian aliran",
        "flowDebug.selectedFlowId": "ID aliran terpilih",
        "flowDebug.completion": "Selesai",
        "flowDebug.isComplete": "Selesai",
        "flowDebug.lastUpdated": "Kemas kini terakhir",
        "flowDebug.missingFields": "Medan hilang",
        "flowDebug.noMissingFields": "Tiada medan hilang.",
        "flowDebug.validationIssues": "Isu pengesahan",
        "flowDebug.unknownField": "Medan tidak diketahui",
        "flowDebug.noDetails": "Tiada butiran.",
        "flowDebug.noValidationIssues": "Tiada isu pengesahan.",
        "flowDebug.routerNotes": "Nota penghala",
        "flowDebug.noRouterDetails": "Tiada butiran penghala lagi.",
        "flowDebug.close": "Tutup sebab aliran",
        "flowDebug.yes": "Ya",
        "flowDebug.no": "Tidak",
        "help.howTitle": "Cara ia berfungsi",
        "help.howBody": "Widget ini buat masa ini hanya frontend. Apabila disambungkan, ia akan menghantar data ke {baseUrl}. Tetapkan apiBaseUrl semasa mount.",
        "help.embedTitle": "Penyematan",
        "help.embedBody": "Sertakan chatbot-widget.js melalui tag script. Panggil ChatbotWidget.mount dengan elemen sasaran atau sertakan skrip untuk membuat gelembung terapung. Iframe di /chatbot-embed.html menggunakan bundle yang sama.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Laraskan nilai tema untuk warna aksen, latar, teks dan jejari sudut. Kedudukan boleh di bawah kiri atau bawah kanan.",
        "widget.welcomeMessage": "Hai! Saya {brandName}. Mulakan chat baru untuk bantuan atau sambung semula.",
        "widget.homeHeroTitle": "Chat dengan {brandName}",
        "widget.homeHeroSubtitle": "Jawapan pantas, sejarah dan bantuan tanpa meninggalkan halaman.",
        "widget.auth.startTrialActivate": "Mulakan percubaan percuma untuk mengaktifkan chatbot ini.",
        "widget.auth.unauthorized": "Tidak dibenarkan.",
        "widget.auth.unableAuth": "Tidak dapat mengesahkan chatbot.",
        "widget.auth.notWorking": "Chatbot ini tidak berfungsi buat masa ini. Cuba lagi nanti.",
        "widget.auth.startTrialEnable": "Mulakan percubaan percuma untuk mengaktifkan perbualan dan aliran.",
        "widget.auth.activateTitle": "Aktifkan chatbot",
        "widget.auth.goToDashboard": "Pergi ke papan pemuka",
        "widget.openChatbot": "Buka chatbot",
        "widget.conversation.defaultName": "Perbualan {id}",
        "widget.conversation.defaultShort": "Perbualan",
        "widget.conversation.new": "Perbualan baharu",
        "widget.conversation.pending": "Memulakan perbualan...",
        "widget.conversation.openHistory": "Buka untuk melihat sejarah perbualan.",
        "widget.handoff.joined": "Ejen manusia telah menyertai chat. Anda kini boleh menghantar dan menerima mesej masa nyata.",
        "widget.errors.noResponse": "Saya tidak dapat menghasilkan jawapan. Sila cuba lagi.",
        "widget.errors.moreContext": "Saya perlukan lebih banyak konteks sebelum tempahan. Sila cuba lagi.",
        "widget.errors.meetingBooked": "Mesyuarat anda telah ditempah. Anda akan menerima jemputan kalendar tidak lama lagi.",
        "widget.errors.bookingConfirmFailed": "Maaf, saya tidak dapat mengesahkan masa tersebut. Pilih masa lain.",
        "widget.errors.connectFailed": "Maaf, saya menghadapi masalah menyambung dengan pembantu. Sila cuba lagi sebentar lagi.",
        "widget.time.justNow": "Baru sahaja",
    },
    tl: {
        "chat.activityProductsFor": "Naghahanap ng {goal}…",
        "chat.activityThinking": "Inihahanda ang sagot…",
        "chat.activityProductDetails": "Sinusuri ang detalye ng produkto…",
        "chat.activityProductReview": "Pinipili ang mga produkto…",
        "chat.activitySending": "Ipinapadala ang iyong impormasyon…",
        "chat.activityHandoff": "Humihiling ng tulong ng tao…",
        "chat.activitySupport": "Binabasa ang gabay sa suporta…",
        "chat.activityKnowledge": "Naghahanap ng impormasyon sa negosyo…",
        "chat.activityProducts": "Naghahanap ng mga produkto…",
        "chat.activityAvailability": "Sinusuri ang availability…",
        "chat.activityBooking": "Gumagawa ng booking…",
        "chat.activitySaving": "Sine-save ang impormasyon…",
        "tab.home": "Home",
        "tab.history": "History",
        "tab.help": "Tulong",
        "home.welcome": "Maligayang pagdating",
        "home.startFlowChatWith": "Simulan ang flow chat kasama si {brandName}",
        "home.latestConversation": "Huling usapan",
        "chat.placeholder": "Magtanong ng kahit ano...",
        "chat.send": "Ipadala ang mensahe",
        "chat.retryHint": "Ang subukan muli ay magpapadala ng huling mensahe.",
        "chat.retry": "Subukan muli",
        "chat.noAvailableTimes": "Walang available na oras sa ngayon.",
        "chat.slots": "{count} oras",
        "chat.bookedFor": "Naka-book para sa {start} - {end}",
        "chat.unableToConfirm": "Hindi ma-confirm ang oras na ito. Subukan ang iba.",
        "chat.timezone": "Time zone: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Nagbu-book...",
        "chat.booked": "Naka-book",
        "chat.confirmBooking": "Kumpirmahin ang booking",
        "chat.you": "Ikaw",
        "chat.support": "Suporta",
        "history.rename": "Palitan ng pangalan",
        "history.delete": "Tanggalin",
        "history.deleteTitle": "Tanggalin ang usapan?",
        "history.deleteBody": "Tatanggalin nito ang usapan sa history. Hindi na maibabalik.",
        "history.cancel": "Kanselahin",
        "history.confirmDelete": "Tanggalin",
        "consent.title": "Abiso sa privacy",
        "consent.body": "Bago makipag-chat kay {brandName}, pakisang-ayon ang aming patakaran sa privacy.",
        "consent.cta": "Sumasang-ayon ako at gusto kong makipag-chat",
        "header.back": "Bumalik",
        "header.flowReasoning": "Paliwanag ng flow",
        "header.minimize": "I-minimize ang chatbot",
        "closedFlows.dismiss": "Isara ang mga mungkahing flow",
        "flowDebug.title": "Paliwanag ng flow",
        "flowDebug.noActiveFlow": "Walang aktibong flow",
        "flowDebug.notUpdated": "Hindi pa na-update",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID ng usapan",
        "flowDebug.flowRunId": "ID ng flow run",
        "flowDebug.selectedFlowId": "Napiling flow ID",
        "flowDebug.completion": "Pagkumpleto",
        "flowDebug.isComplete": "Tapos na",
        "flowDebug.lastUpdated": "Huling update",
        "flowDebug.missingFields": "Kulang na field",
        "flowDebug.noMissingFields": "Walang kulang na field.",
        "flowDebug.validationIssues": "Isyung validation",
        "flowDebug.unknownField": "Hindi kilalang field",
        "flowDebug.noDetails": "Walang detalye.",
        "flowDebug.noValidationIssues": "Walang isyung validation.",
        "flowDebug.routerNotes": "Mga tala ng router",
        "flowDebug.noRouterDetails": "Wala pang detalye ng router.",
        "flowDebug.close": "Isara ang paliwanag ng flow",
        "flowDebug.yes": "Oo",
        "flowDebug.no": "Hindi",
        "help.howTitle": "Paano gumagana",
        "help.howBody": "Ang widget na ito ay frontend-only sa ngayon. Kapag nakakonekta, magpapadala ito ng data sa {baseUrl}. I-configure ang apiBaseUrl kapag nag-mount.",
        "help.embedTitle": "Pag-embed",
        "help.embedBody": "Isama ang chatbot-widget.js gamit ang script tag. Tawagin ang ChatbotWidget.mount gamit ang target element o idagdag ang script para gumawa ng floating bubble. Ang iframe sa /chatbot-embed.html ay gumagamit ng parehong bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Ayusin ang theme values para sa accent color, background, text, at corner radius. Puwedeng nasa ibabang kaliwa o ibabang kanan ang posisyon.",
        "widget.welcomeMessage": "Hi! Ako si {brandName}. Magsimula ng bagong chat para sa tulong o magpatuloy.",
        "widget.homeHeroTitle": "Makipag-chat kay {brandName}",
        "widget.homeHeroSubtitle": "Mabilis na sagot, history, at tulong nang hindi umaalis sa page.",
        "widget.auth.startTrialActivate": "Simulan ang libreng trial para i-activate ang chatbot na ito.",
        "widget.auth.unauthorized": "Hindi awtorisado.",
        "widget.auth.unableAuth": "Hindi ma-authenticate ang chatbot.",
        "widget.auth.notWorking": "Hindi gumagana ang chatbot na ito ngayon. Subukan ulit mamaya.",
        "widget.auth.startTrialEnable": "Simulan ang libreng trial para i-enable ang mga usapan at flow.",
        "widget.auth.activateTitle": "I-activate ang chatbot",
        "widget.auth.goToDashboard": "Pumunta sa dashboard",
        "widget.openChatbot": "Buksan ang chatbot",
        "widget.conversation.defaultName": "Usapan {id}",
        "widget.conversation.defaultShort": "Usapan",
        "widget.conversation.new": "Bagong usapan",
        "widget.conversation.pending": "Nagsisimula ng usapan...",
        "widget.conversation.openHistory": "Buksan para makita ang history ng usapan.",
        "widget.handoff.joined": "Isang taong ahente ang sumali sa chat. Maaari ka nang magpadala at tumanggap ng mensahe real-time.",
        "widget.errors.noResponse": "Hindi ako nakabuo ng sagot. Subukan ulit.",
        "widget.errors.moreContext": "Kailangan ko ng higit pang konteksto bago mag-book. Subukan ulit.",
        "widget.errors.meetingBooked": "Na-book na ang meeting mo. Makakatanggap ka ng calendar invite sa lalong madaling panahon.",
        "widget.errors.bookingConfirmFailed": "Paumanhin, hindi ko na-confirm ang oras na iyon. Pumili ng iba.",
        "widget.errors.connectFailed": "Paumanhin, nagkaproblema sa koneksyon sa assistant. Subukan ulit pagkalipas ng sandali.",
        "widget.time.justNow": "Kanina lang",
    },
    fa: {
        "chat.activityProductsFor": "در حال جستجوی {goal}…",
        "chat.activityThinking": "در حال آماده کردن پاسخ…",
        "chat.activityProductDetails": "در حال بررسی جزئیات محصول…",
        "chat.activityProductReview": "در حال ارزیابی محصولات…",
        "chat.activitySending": "در حال ارسال اطلاعات شما…",
        "chat.activityHandoff": "در حال درخواست کمک انسانی…",
        "chat.activitySupport": "در حال خواندن راهنمای پشتیبانی…",
        "chat.activityKnowledge": "در حال جستجوی اطلاعات کسب‌وکار…",
        "chat.activityProducts": "در حال جستجوی محصولات…",
        "chat.activityAvailability": "در حال بررسی زمان‌های آزاد…",
        "chat.activityBooking": "در حال ایجاد رزرو…",
        "chat.activitySaving": "در حال ذخیره اطلاعات…",
        "tab.home": "خانه",
        "tab.history": "تاریخچه",
        "tab.help": "راهنما",
        "home.welcome": "خوش آمدید",
        "home.startFlowChatWith": "شروع گفت‌وگوی جریان با {brandName}",
        "home.latestConversation": "آخرین گفتگو",
        "chat.placeholder": "هر چیزی بپرسید...",
        "chat.send": "ارسال پیام",
        "chat.retryHint": "تلاش دوباره آخرین پیام شما را دوباره ارسال می‌کند.",
        "chat.retry": "تلاش دوباره",
        "chat.noAvailableTimes": "در حال حاضر زمانی در دسترس نیست.",
        "chat.slots": "{count} بازه",
        "chat.bookedFor": "رزرو شده برای {start} - {end}",
        "chat.unableToConfirm": "نمی‌توان این زمان را تأیید کرد. زمان دیگری را امتحان کنید.",
        "chat.timezone": "منطقه زمانی: {timezone}",
        "chat.durationMinutes": "{minutes} دقیقه",
        "chat.bookingPending": "در حال رزرو...",
        "chat.booked": "رزرو شد",
        "chat.confirmBooking": "تأیید رزرو",
        "chat.you": "شما",
        "chat.support": "پشتیبانی",
        "history.rename": "تغییر نام",
        "history.delete": "حذف",
        "history.deleteTitle": "حذف گفتگو؟",
        "history.deleteBody": "این کار گفتگو را از تاریخچه حذف می‌کند. قابل بازگشت نیست.",
        "history.cancel": "لغو",
        "history.confirmDelete": "حذف",
        "consent.title": "اعلان حریم خصوصی",
        "consent.body": "پیش از گفتگو با {brandName}، سیاست حریم خصوصی ما را تأیید کنید.",
        "consent.cta": "موافقم و می‌خواهم گفتگو کنم",
        "header.back": "بازگشت",
        "header.flowReasoning": "دلیل جریان",
        "header.minimize": "کوچک‌کردن چت‌بات",
        "closedFlows.dismiss": "رد پیشنهادهای جریان",
        "flowDebug.title": "دلیل جریان",
        "flowDebug.noActiveFlow": "هیچ جریان فعالی نیست",
        "flowDebug.notUpdated": "هنوز به‌روزرسانی نشده",
        "flowDebug.status": "وضعیت",
        "flowDebug.conversationId": "شناسه گفتگو",
        "flowDebug.flowRunId": "شناسه اجرای جریان",
        "flowDebug.selectedFlowId": "شناسه جریان انتخاب‌شده",
        "flowDebug.completion": "تکمیل",
        "flowDebug.isComplete": "تکمیل شده",
        "flowDebug.lastUpdated": "آخرین به‌روزرسانی",
        "flowDebug.missingFields": "فیلدهای ناقص",
        "flowDebug.noMissingFields": "هیچ فیلد ناقصی وجود ندارد.",
        "flowDebug.validationIssues": "مشکلات اعتبارسنجی",
        "flowDebug.unknownField": "فیلد ناشناخته",
        "flowDebug.noDetails": "جزئیاتی ارائه نشده است.",
        "flowDebug.noValidationIssues": "مشکلات اعتبارسنجی وجود ندارد.",
        "flowDebug.routerNotes": "یادداشت‌های روتر",
        "flowDebug.noRouterDetails": "جزئیات روتر هنوز موجود نیست.",
        "flowDebug.close": "بستن دلیل جریان",
        "flowDebug.yes": "بله",
        "flowDebug.no": "خیر",
        "help.howTitle": "چگونه کار می‌کند",
        "help.howBody": "این ویجت در حال حاضر فقط فرانت‌اند است. هنگام اتصال، داده‌ها را به {baseUrl} ارسال می‌کند. هنگام مونت، apiBaseUrl را تنظیم کنید.",
        "help.embedTitle": "جاسازی",
        "help.embedBody": "chatbot-widget.js را با تگ script اضافه کنید. ChatbotWidget.mount را با عنصر هدف فراخوانی کنید یا اسکریپت را برای حباب شناور اضافه کنید. iframe در /chatbot-embed.html همان bundle را استفاده می‌کند.",
        "help.themeTitle": "تم",
        "help.themeBody": "مقادیر تم را برای رنگ تاکید، پس‌زمینه، متن و شعاع گوشه تنظیم کنید. موقعیت می‌تواند پایین چپ یا پایین راست باشد.",
        "widget.welcomeMessage": "سلام! من {brandName} هستم. برای کمک یک گفتگوی جدید شروع کنید یا ادامه دهید.",
        "widget.homeHeroTitle": "گفتگو با {brandName}",
        "widget.homeHeroSubtitle": "پاسخ سریع، تاریخچه و راهنما بدون ترک صفحه.",
        "widget.auth.startTrialActivate": "برای فعال‌سازی این چت‌بات، دوره آزمایشی رایگان را شروع کنید.",
        "widget.auth.unauthorized": "غیرمجاز.",
        "widget.auth.unableAuth": "احراز هویت چت‌بات ممکن نیست.",
        "widget.auth.notWorking": "این چت‌بات در حال حاضر کار نمی‌کند. بعداً دوباره تلاش کنید.",
        "widget.auth.startTrialEnable": "برای فعال کردن گفتگوها و جریان‌ها، دوره آزمایشی رایگان را شروع کنید.",
        "widget.auth.activateTitle": "فعال‌سازی چت‌بات",
        "widget.auth.goToDashboard": "رفتن به داشبورد",
        "widget.openChatbot": "باز کردن چت‌بات",
        "widget.conversation.defaultName": "گفتگو {id}",
        "widget.conversation.defaultShort": "گفتگو",
        "widget.conversation.new": "گفتگوی جدید",
        "widget.conversation.pending": "در حال شروع گفتگو...",
        "widget.conversation.openHistory": "برای دیدن تاریخچه گفتگو باز کنید.",
        "widget.handoff.joined": "یک عامل انسانی به گفتگو پیوست. اکنون می‌توانید پیام‌ها را در زمان واقعی ارسال و دریافت کنید.",
        "widget.errors.noResponse": "نتوانستم پاسخ تولید کنم. لطفاً دوباره تلاش کنید.",
        "widget.errors.moreContext": "قبل از رزرو به اطلاعات بیشتری نیاز دارم. لطفاً دوباره تلاش کنید.",
        "widget.errors.meetingBooked": "جلسه شما رزرو شد. به زودی دعوت‌نامه تقویم دریافت می‌کنید.",
        "widget.errors.bookingConfirmFailed": "متأسفم، نتوانستم آن زمان را تأیید کنم. زمان دیگری انتخاب کنید.",
        "widget.errors.connectFailed": "متأسفم، در اتصال به دستیار مشکل داشتیم. کمی بعد دوباره تلاش کنید.",
        "widget.time.justNow": "همین الان",
    },
    sr: {
        "chat.activityProductsFor": "Тражим {goal}…",
        "chat.activityThinking": "Припремам одговор…",
        "chat.activityProductDetails": "Проверавам детаље производа…",
        "chat.activityProductReview": "Разматрам производе…",
        "chat.activitySending": "Шаљем ваше податке…",
        "chat.activityHandoff": "Тражим помоћ особе…",
        "chat.activitySupport": "Читам упутства подршке…",
        "chat.activityKnowledge": "Претрага информација о предузећу…",
        "chat.activityProducts": "Претрага производа…",
        "chat.activityAvailability": "Провера доступности…",
        "chat.activityBooking": "Креирање резервације…",
        "chat.activitySaving": "Чување информација…",
        "tab.home": "Početna",
        "tab.history": "Istorija",
        "tab.help": "Pomoć",
        "home.welcome": "Dobrodošli",
        "home.startFlowChatWith": "Započni flow chat sa {brandName}",
        "home.latestConversation": "Poslednji razgovor",
        "chat.placeholder": "Pitajte bilo šta...",
        "chat.send": "Pošalji poruku",
        "chat.retryHint": "Ponovi će poslati poslednju poruku.",
        "chat.retry": "Ponovi",
        "chat.noAvailableTimes": "Trenutno nema dostupnih termina.",
        "chat.slots": "{count} termina",
        "chat.bookedFor": "Rezervisano za {start} - {end}",
        "chat.unableToConfirm": "Nije moguće potvrditi ovaj termin. Izaberite drugi.",
        "chat.timezone": "Vremenska zona: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezervacija...",
        "chat.booked": "Rezervisano",
        "chat.confirmBooking": "Potvrdi rezervaciju",
        "chat.you": "Vi",
        "chat.support": "Podrška",
        "history.rename": "Preimenuj",
        "history.delete": "Obriši",
        "history.deleteTitle": "Obrisati razgovor?",
        "history.deleteBody": "Ovo će ukloniti razgovor iz istorije. Ne može se opozvati.",
        "history.cancel": "Otkaži",
        "history.confirmDelete": "Obriši",
        "consent.title": "Obaveštenje o privatnosti",
        "consent.body": "Pre nego što čatujete sa {brandName}, odobrite našu politiku privatnosti.",
        "consent.cta": "Slažem se i želim da čatujem",
        "header.back": "Nazad",
        "header.flowReasoning": "Razlog toka",
        "header.minimize": "Minimizuj chatbota",
        "closedFlows.dismiss": "Odbaci predloge toka",
        "flowDebug.title": "Razlog toka",
        "flowDebug.noActiveFlow": "Nema aktivnog toka",
        "flowDebug.notUpdated": "Još nije ažurirano",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID razgovora",
        "flowDebug.flowRunId": "ID izvršavanja toka",
        "flowDebug.selectedFlowId": "Izabrani ID toka",
        "flowDebug.completion": "Završetak",
        "flowDebug.isComplete": "Završeno",
        "flowDebug.lastUpdated": "Poslednje ažuriranje",
        "flowDebug.missingFields": "Nedostajuća polja",
        "flowDebug.noMissingFields": "Nema nedostajućih polja.",
        "flowDebug.validationIssues": "Problemi validacije",
        "flowDebug.unknownField": "Nepoznato polje",
        "flowDebug.noDetails": "Nema detalja.",
        "flowDebug.noValidationIssues": "Nema problema validacije.",
        "flowDebug.routerNotes": "Beleške rutera",
        "flowDebug.noRouterDetails": "Još nema detalja rutera.",
        "flowDebug.close": "Zatvori razlog toka",
        "flowDebug.yes": "Da",
        "flowDebug.no": "Ne",
        "help.howTitle": "Kako radi",
        "help.howBody": "Ovaj widget je trenutno samo frontend. Kada je povezan, šalje podatke na {baseUrl}. Podesite apiBaseUrl pri mountovanju.",
        "help.embedTitle": "Ugradnja",
        "help.embedBody": "Uključite chatbot-widget.js preko script taga. Pozovite ChatbotWidget.mount sa ciljanim elementom ili dodajte skriptu za plutajući balon. Iframe na /chatbot-embed.html koristi isti bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Podesite vrednosti teme za akcentnu boju, pozadinu, tekst i radius uglova. Pozicija može biti dole levo ili dole desno.",
        "widget.welcomeMessage": "Zdravo! Ja sam {brandName}. Pokrenite novi chat za pomoć ili nastavak.",
        "widget.homeHeroTitle": "Čatujte sa {brandName}",
        "widget.homeHeroSubtitle": "Brzi odgovori, istorija i pomoć bez napuštanja stranice.",
        "widget.auth.startTrialActivate": "Pokrenite besplatan probni period da aktivirate ovog chatbota.",
        "widget.auth.unauthorized": "Neovlašćeno.",
        "widget.auth.unableAuth": "Nije moguće autentifikovati chatbota.",
        "widget.auth.notWorking": "Ovaj chatbot trenutno ne radi. Pokušajte kasnije.",
        "widget.auth.startTrialEnable": "Pokrenite besplatan probni period za razgovore i tokove.",
        "widget.auth.activateTitle": "Aktiviraj chatbota",
        "widget.auth.goToDashboard": "Idi na kontrolnu tablu",
        "widget.openChatbot": "Otvori chatbota",
        "widget.conversation.defaultName": "Razgovor {id}",
        "widget.conversation.defaultShort": "Razgovor",
        "widget.conversation.new": "Novi razgovor",
        "widget.conversation.pending": "Pokrećem razgovor...",
        "widget.conversation.openHistory": "Otvorite da vidite istoriju razgovora.",
        "widget.handoff.joined": "Ljudski agent se pridružio chatu. Sada možete slati i primati poruke u realnom vremenu.",
        "widget.errors.noResponse": "Nisam mogao da generišem odgovor. Pokušajte ponovo.",
        "widget.errors.moreContext": "Treba mi više konteksta pre rezervacije. Pokušajte ponovo.",
        "widget.errors.meetingBooked": "Vaš sastanak je rezervisan. Uskoro ćete dobiti pozivnicu u kalendar.",
        "widget.errors.bookingConfirmFailed": "Žao mi je, nisam mogao da potvrdim taj termin. Izaberite drugi.",
        "widget.errors.connectFailed": "Žao mi je, imao sam problem sa povezivanjem sa asistentom. Pokušajte ponovo za trenutak.",
        "widget.time.justNow": "Upravo sada",
    },
    hr: {
        "chat.activityProductsFor": "Tražim {goal}…",
        "chat.activityThinking": "Pripremam odgovor…",
        "chat.activityProductDetails": "Provjeravam detalje proizvoda…",
        "chat.activityProductReview": "Razmatram proizvode…",
        "chat.activitySending": "Šaljem vaše podatke…",
        "chat.activityHandoff": "Tražim pomoć osobe…",
        "chat.activitySupport": "Čitam upute podrške…",
        "chat.activityKnowledge": "Traženje informacija o tvrtki…",
        "chat.activityProducts": "Traženje proizvoda…",
        "chat.activityAvailability": "Provjera dostupnosti…",
        "chat.activityBooking": "Izrada rezervacije…",
        "chat.activitySaving": "Spremanje informacija…",
        "tab.home": "Početna",
        "tab.history": "Povijest",
        "tab.help": "Pomoć",
        "home.welcome": "Dobrodošli",
        "home.startFlowChatWith": "Pokreni flow chat s {brandName}",
        "home.latestConversation": "Zadnji razgovor",
        "chat.placeholder": "Pitajte bilo što...",
        "chat.send": "Pošalji poruku",
        "chat.retryHint": "Ponovi će poslati zadnju poruku.",
        "chat.retry": "Ponovi",
        "chat.noAvailableTimes": "Trenutno nema dostupnih termina.",
        "chat.slots": "{count} termina",
        "chat.bookedFor": "Rezervirano za {start} - {end}",
        "chat.unableToConfirm": "Nije moguće potvrditi ovaj termin. Izaberite drugi.",
        "chat.timezone": "Vremenska zona: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezervacija...",
        "chat.booked": "Rezervirano",
        "chat.confirmBooking": "Potvrdi rezervaciju",
        "chat.you": "Vi",
        "chat.support": "Podrška",
        "history.rename": "Preimenuj",
        "history.delete": "Izbriši",
        "history.deleteTitle": "Izbrisati razgovor?",
        "history.deleteBody": "Ovo će ukloniti razgovor iz povijesti. Ne može se vratiti.",
        "history.cancel": "Odustani",
        "history.confirmDelete": "Izbriši",
        "consent.title": "Obavijest o privatnosti",
        "consent.body": "Prije razgovora s {brandName}, prihvatite našu politiku privatnosti.",
        "consent.cta": "Slažem se i želim razgovarati",
        "header.back": "Natrag",
        "header.flowReasoning": "Obrazloženje toka",
        "header.minimize": "Minimiziraj chatbot",
        "closedFlows.dismiss": "Odbaci prijedloge toka",
        "flowDebug.title": "Obrazloženje toka",
        "flowDebug.noActiveFlow": "Nema aktivnog toka",
        "flowDebug.notUpdated": "Još nije ažurirano",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID razgovora",
        "flowDebug.flowRunId": "ID izvođenja toka",
        "flowDebug.selectedFlowId": "Odabrani ID toka",
        "flowDebug.completion": "Dovršenje",
        "flowDebug.isComplete": "Završeno",
        "flowDebug.lastUpdated": "Zadnje ažuriranje",
        "flowDebug.missingFields": "Nedostajuća polja",
        "flowDebug.noMissingFields": "Nema nedostajućih polja.",
        "flowDebug.validationIssues": "Problemi validacije",
        "flowDebug.unknownField": "Nepoznato polje",
        "flowDebug.noDetails": "Nema detalja.",
        "flowDebug.noValidationIssues": "Nema problema validacije.",
        "flowDebug.routerNotes": "Bilješke rutera",
        "flowDebug.noRouterDetails": "Još nema detalja rutera.",
        "flowDebug.close": "Zatvori obrazloženje toka",
        "flowDebug.yes": "Da",
        "flowDebug.no": "Ne",
        "help.howTitle": "Kako radi",
        "help.howBody": "Ovaj widget je zasad samo frontend. Kad je povezan, šalje podatke na {baseUrl}. Postavite apiBaseUrl pri mountanju.",
        "help.embedTitle": "Ugradnja",
        "help.embedBody": "Uključite chatbot-widget.js putem script taga. Pozovite ChatbotWidget.mount s ciljnim elementom ili dodajte skriptu za plutajući balon. Iframe na /chatbot-embed.html koristi isti bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Podesite vrijednosti teme za naglašenu boju, pozadinu, tekst i radijus kutova. Pozicija može biti dolje lijevo ili dolje desno.",
        "widget.welcomeMessage": "Bok! Ja sam {brandName}. Pokrenite novi chat za pomoć ili nastavak.",
        "widget.homeHeroTitle": "Chat s {brandName}",
        "widget.homeHeroSubtitle": "Brzi odgovori, povijest i pomoć bez napuštanja stranice.",
        "widget.auth.startTrialActivate": "Pokrenite besplatnu probu da aktivirate ovaj chatbot.",
        "widget.auth.unauthorized": "Niste ovlašteni.",
        "widget.auth.unableAuth": "Nije moguće autentificirati chatbot.",
        "widget.auth.notWorking": "Ovaj chatbot trenutno ne radi. Pokušajte kasnije.",
        "widget.auth.startTrialEnable": "Pokrenite besplatnu probu za razgovore i tokove.",
        "widget.auth.activateTitle": "Aktiviraj chatbot",
        "widget.auth.goToDashboard": "Idi na nadzornu ploču",
        "widget.openChatbot": "Otvori chatbot",
        "widget.conversation.defaultName": "Razgovor {id}",
        "widget.conversation.defaultShort": "Razgovor",
        "widget.conversation.new": "Novi razgovor",
        "widget.conversation.pending": "Pokrećem razgovor...",
        "widget.conversation.openHistory": "Otvorite za prikaz povijesti razgovora.",
        "widget.handoff.joined": "Ljudski agent se pridružio chatu. Sada možete slati i primati poruke u stvarnom vremenu.",
        "widget.errors.noResponse": "Nisam mogao generirati odgovor. Pokušajte ponovno.",
        "widget.errors.moreContext": "Trebam više konteksta prije rezervacije. Pokušajte ponovno.",
        "widget.errors.meetingBooked": "Vaš sastanak je rezerviran. Uskoro ćete dobiti pozivnicu u kalendar.",
        "widget.errors.bookingConfirmFailed": "Nažalost, nisam mogao potvrditi termin. Odaberite drugi.",
        "widget.errors.connectFailed": "Nažalost, došlo je do problema s povezivanjem s asistentom. Pokušajte ponovno za trenutak.",
        "widget.time.justNow": "Upravo sada",
    },
    cr: {
        "chat.activityProductsFor": "Tražim {goal}…",
        "chat.activityThinking": "Pripremam odgovor…",
        "chat.activityProductDetails": "Provjeravam detalje proizvoda…",
        "chat.activityProductReview": "Razmatram proizvode…",
        "chat.activitySending": "Šaljem vaše podatke…",
        "chat.activityHandoff": "Tražim pomoć osobe…",
        "chat.activitySupport": "Čitam upute podrške…",
        "tab.home": "Početna",
        "tab.history": "Povijest",
        "tab.help": "Pomoć",
        "home.welcome": "Dobrodošli",
        "home.startFlowChatWith": "Pokreni flow chat s {brandName}",
        "home.latestConversation": "Zadnji razgovor",
        "chat.placeholder": "Pitajte bilo što...",
        "chat.send": "Pošalji poruku",
        "chat.retryHint": "Ponovi će poslati zadnju poruku.",
        "chat.retry": "Ponovi",
        "chat.noAvailableTimes": "Trenutno nema dostupnih termina.",
        "chat.slots": "{count} termina",
        "chat.bookedFor": "Rezervirano za {start} - {end}",
        "chat.unableToConfirm": "Nije moguće potvrditi ovaj termin. Izaberite drugi.",
        "chat.timezone": "Vremenska zona: {timezone}",
        "chat.durationMinutes": "{minutes} min",
        "chat.bookingPending": "Rezervacija...",
        "chat.booked": "Rezervirano",
        "chat.confirmBooking": "Potvrdi rezervaciju",
        "chat.you": "Vi",
        "chat.support": "Podrška",
        "history.rename": "Preimenuj",
        "history.delete": "Izbriši",
        "history.deleteTitle": "Izbrisati razgovor?",
        "history.deleteBody": "Ovo će ukloniti razgovor iz povijesti. Ne može se vratiti.",
        "history.cancel": "Odustani",
        "history.confirmDelete": "Izbriši",
        "consent.title": "Obavijest o privatnosti",
        "consent.body": "Prije razgovora s {brandName}, prihvatite našu politiku privatnosti.",
        "consent.cta": "Slažem se i želim razgovarati",
        "header.back": "Natrag",
        "header.flowReasoning": "Obrazloženje toka",
        "header.minimize": "Minimiziraj chatbot",
        "closedFlows.dismiss": "Odbaci prijedloge toka",
        "flowDebug.title": "Obrazloženje toka",
        "flowDebug.noActiveFlow": "Nema aktivnog toka",
        "flowDebug.notUpdated": "Još nije ažurirano",
        "flowDebug.status": "Status",
        "flowDebug.conversationId": "ID razgovora",
        "flowDebug.flowRunId": "ID izvođenja toka",
        "flowDebug.selectedFlowId": "Odabrani ID toka",
        "flowDebug.completion": "Dovršenje",
        "flowDebug.isComplete": "Završeno",
        "flowDebug.lastUpdated": "Zadnje ažuriranje",
        "flowDebug.missingFields": "Nedostajuća polja",
        "flowDebug.noMissingFields": "Nema nedostajućih polja.",
        "flowDebug.validationIssues": "Problemi validacije",
        "flowDebug.unknownField": "Nepoznato polje",
        "flowDebug.noDetails": "Nema detalja.",
        "flowDebug.noValidationIssues": "Nema problema validacije.",
        "flowDebug.routerNotes": "Bilješke rutera",
        "flowDebug.noRouterDetails": "Još nema detalja rutera.",
        "flowDebug.close": "Zatvori obrazloženje toka",
        "flowDebug.yes": "Da",
        "flowDebug.no": "Ne",
        "help.howTitle": "Kako radi",
        "help.howBody": "Ovaj widget je zasad samo frontend. Kad je povezan, šalje podatke na {baseUrl}. Postavite apiBaseUrl pri mountanju.",
        "help.embedTitle": "Ugradnja",
        "help.embedBody": "Uključite chatbot-widget.js putem script taga. Pozovite ChatbotWidget.mount s ciljnim elementom ili dodajte skriptu za plutajući balon. Iframe na /chatbot-embed.html koristi isti bundle.",
        "help.themeTitle": "Tema",
        "help.themeBody": "Podesite vrijednosti teme za naglašenu boju, pozadinu, tekst i radijus kutova. Pozicija može biti dolje lijevo ili dolje desno.",
        "widget.welcomeMessage": "Bok! Ja sam {brandName}. Pokrenite novi chat za pomoć ili nastavak.",
        "widget.homeHeroTitle": "Chat s {brandName}",
        "widget.homeHeroSubtitle": "Brzi odgovori, povijest i pomoć bez napuštanja stranice.",
        "widget.auth.startTrialActivate": "Pokrenite besplatnu probu da aktivirate ovaj chatbot.",
        "widget.auth.unauthorized": "Niste ovlašteni.",
        "widget.auth.unableAuth": "Nije moguće autentificirati chatbot.",
        "widget.auth.notWorking": "Ovaj chatbot trenutno ne radi. Pokušajte kasnije.",
        "widget.auth.startTrialEnable": "Pokrenite besplatnu probu za razgovore i tokove.",
        "widget.auth.activateTitle": "Aktiviraj chatbot",
        "widget.auth.goToDashboard": "Idi na nadzornu ploču",
        "widget.openChatbot": "Otvori chatbot",
        "widget.conversation.defaultName": "Razgovor {id}",
        "widget.conversation.defaultShort": "Razgovor",
        "widget.conversation.new": "Novi razgovor",
        "widget.conversation.pending": "Pokrećem razgovor...",
        "widget.conversation.openHistory": "Otvorite za prikaz povijesti razgovora.",
        "widget.handoff.joined": "Ljudski agent se pridružio chatu. Sada možete slati i primati poruke u stvarnom vremenu.",
        "widget.errors.noResponse": "Nisam mogao generirati odgovor. Pokušajte ponovno.",
        "widget.errors.moreContext": "Trebam više konteksta prije rezervacije. Pokušajte ponovno.",
        "widget.errors.meetingBooked": "Vaš sastanak je rezerviran. Uskoro ćete dobiti pozivnicu u kalendar.",
        "widget.errors.bookingConfirmFailed": "Nažalost, nisam mogao potvrditi termin. Odaberite drugi.",
        "widget.errors.connectFailed": "Nažalost, došlo je do problema s povezivanjem s asistentom. Pokušajte ponovno za trenutak.",
        "widget.time.justNow": "Upravo sada",
    }
};
const normalizeLanguage = (value) => {
    if (!value)
        return "";
    const trimmed = value.trim().toLowerCase().replace(/_/g, "-");
    if (!trimmed)
        return "";
    if (NAME_ALIASES[trimmed])
        return NAME_ALIASES[trimmed];
    return trimmed;
};
export function resolveWidgetLocale(preferred, fallback) {
    const primary = normalizeLanguage(preferred);
    if (primary && translations[primary])
        return primary;
    if (primary && primary.includes("-")) {
        const base = primary.split("-")[0];
        if (translations[base])
            return base;
    }
    const backup = normalizeLanguage(fallback);
    if (backup && translations[backup])
        return backup;
    if (backup && backup.includes("-")) {
        const base = backup.split("-")[0];
        if (translations[base])
            return base;
    }
    return "en";
}
function interpolate(template, vars) {
    if (!vars)
        return template;
    return template.replace(/\{(\w+)\}/g, (_, key) => { var _a; return `${(_a = vars[key]) !== null && _a !== void 0 ? _a : ""}`; });
}
export function createWidgetI18n(preferred, fallback) {
    const locale = resolveWidgetLocale(preferred, fallback);
    const base = translations[locale] || translations.en;
    return {
        locale,
        t: (key, vars) => {
            var _a, _b;
            const template = (_b = (_a = base[key]) !== null && _a !== void 0 ? _a : translations.en[key]) !== null && _b !== void 0 ? _b : key;
            return interpolate(template, vars);
        },
    };
}
